{
  "nav": {
    "general": "Geral",
    "modules": "Módulos",
    "reports": "Relatórios",
    "dashboard": "Início",
    "tracking": "Acompanhamento",
    "projects": "Obras",
    "clientBudgets": "Orçamentos",
    "finance": "Financeiro",
    "partners": "Parceiros",
    "financeLookups": "Categorias e pagamentos",
    "team": "Frente de serviço",
    "serviceFrontModels": "Modelos de frente de serviços",
    "checklistModels": "Modelos de checklist",
    "diary": "Diário de obra",
    "workers": "Colaboradores",
    "occurrences": "Ocorrências",
    "documentCategories": "Categorias de documentos",
    "photoTags": "Etiquetas de fotos",
    "classifications": "Classificações",
    "weatherConditions": "Condições climáticas",
    "projectPriorities": "Prioridades de obra",
    "projectTypes": "Tipos de obra",
    "projectStatuses": "Status de obra",
    "projectBudgetStatuses": "Status de planejamento de custos",
    "projectClientBudgetStatuses": "Status de orçamento do cliente",
    "serviceFrontDeadlineStatuses": "Status de prazo",
    "materials": "Materiais",
    "budget": "Planejamento de custos",
    "pdf": "Relatórios PDF",
    "settings": "Configurações da empresa",
    "equipments": "Equipamentos",
    "serviceTaxCodes": "Códigos de serviço"
  },
  "notifications": {
    "title": "Notificações",
    "empty": "Nenhuma notificação ainda.",
    "markAllRead": "Marcar todas como lidas",
    "clearAll": "Limpar tudo",
    "dismiss": "Dispensar notificação",
    "types": {
      "projectReport": {
        "ready": "Seu relatório está pronto.",
        "failed": "A geração do relatório falhou."
      }
    }
  },
  "plan": {
    "free": "Plano gratuito",
    "starter": "Starter",
    "pro": "Pro",
    "business": "Business"
  },
  "login": {
    "title": "Entrar no KonstruLog",
    "description": "Use seu e-mail e senha para acessar.",
    "email": "E-mail",
    "password": "Senha",
    "submit": "Entrar",
    "noAccount": "Não tem conta?",
    "register": "Criar conta",
    "error": "E-mail ou senha incorretos",
    "emailNotConfirmed": "Confirme seu e-mail antes de entrar. Verifique sua caixa de entrada.",
    "supabaseNotConfigured": "Supabase não configurado. Verifique o arquivo .env.",
    "showPassword": "Mostrar senha",
    "hidePassword": "Ocultar senha"
  },
  "appBanner": {
    "devEnv": "Ambiente de desenvolvimento",
    "demoEnv": "Ambiente de demonstração",
    "impersonation": "Modo impersonação — vendo {{orgName}} como {{email}}",
    "impersonationWithStaff": "Modo impersonação ({{staffEmail}}) — vendo {{orgName}} como {{email}}",
    "impersonationReadOnly": "Impersonação somente leitura — vendo {{orgName}} como {{email}}",
    "impersonationReadOnlyWithStaff": "Impersonação somente leitura ({{staffEmail}}) — vendo {{orgName}} como {{email}}",
    "demoAccount": "Conta demo — {{orgName}}"
  },
  "register": {
    "title": "Criar conta",
    "description": "Preencha os dados abaixo para começar.",
    "fullName": "Nome completo",
    "fullNamePlaceholder": "João Silva",
    "email": "E-mail",
    "password": "Senha",
    "confirmPassword": "Confirmar senha",
    "submit": "Criar conta",
    "hasAccount": "Já tem conta?",
    "login": "Entrar",
    "checkEmail": "Confirme seu e-mail",
    "checkEmailDesc": "Enviamos um link de confirmação para {{email}}. Clique no link para ativar sua conta.",
    "emailAlreadyExists": "Este e-mail já está cadastrado. Faça login ou use outro e-mail.",
    "error": "Não foi possível criar a conta",
    "supabaseNotConfigured": "Supabase não configurado. Verifique o arquivo .env.",
    "acceptTerms": "Concordo com os Termos de Uso e a Política de Privacidade.",
    "googleTermsHint": "Ao continuar com o Google, você concorda com os Termos de Uso e a Política de Privacidade."
  },
  "legal": {
    "termsTitle": "Termos de Uso",
    "privacyTitle": "Política de Privacidade",
    "lastUpdated": "Última atualização: 9 de outubro de 2026",
    "backToLogin": "Voltar ao login",
    "acceptRequired": "Você precisa aceitar os Termos de Uso e a Política de Privacidade.",
    "acceptPrefix": "Concordo com os",
    "acceptAnd": "e a",
    "terms": {
      "intro": "Estes Termos de Uso regem o acesso ao KonstruLog, software de execução de obras para empresas que acompanham o canteiro e o escritório. Ao criar uma conta ou usar o serviço, você concorda com estes termos. Esta página descreve o serviço de forma geral e não substitui aconselhamento jurídico.",
      "serviceTitle": "O serviço",
      "serviceBody": "O KonstruLog oferece ferramentas para diário de obra, frentes, fotos, equipe, custo da obra, orçamentos, compras e registros relacionados. Podemos melhorar, incluir ou remover funcionalidades. A disponibilidade não é garantida sem interrupções.",
      "accountsTitle": "Contas e organizações",
      "accountsBody": "Você é responsável pelas credenciais de acesso e pela atividade na sua conta. Os dados da empresa pertencem à organização que você cria ou na qual entra. Administradores definem quem tem acesso. Informe dados cadastrais corretos (como CNPJ ou EIN) e mantenha-os atualizados.",
      "acceptableUseTitle": "Uso aceitável",
      "acceptableUseBody": "Não use o serviço de forma indevida, não tente acesso não autorizado, não envie conteúdo ilícito e não prejudique outros clientes. Você deve ter direito de enviar fotos, documentos e dados pessoais de colaboradores e parceiros que armazenar no KonstruLog.",
      "contentTitle": "Seus dados",
      "contentBody": "Você mantém os direitos sobre o conteúdo enviado. Concede-nos licença limitada para hospedar, processar e exibir esse conteúdo apenas para operar o serviço para a sua organização. Não vendemos os registros das suas obras.",
      "liabilityTitle": "Isenção e responsabilidade",
      "liabilityBody": "O serviço é oferecido no estado em que se encontra. O KonstruLog não substitui engenharia, jurídico, folha, tributário ou contabilidade. Na medida permitida pela lei, não respondemos por lucros cessantes, atrasos em obra ou danos indiretos decorrentes do uso do software.",
      "paymentsTitle": "Serviços financeiros (Brasil)",
      "paymentsBody": "Quando a organização no Brasil ativa cobranças PIX ou boleto, os serviços financeiros e de pagamentos disponibilizados por meio da presente plataforma, incluindo processamento de transações, emissão de boletos, transferências e demais movimentações de valores, são prestados pela instituição de pagamento configurada para essa organização. Por padrão, a instituição é a PAGAR.ME S.A. Organizações configuradas com o Asaas utilizam a ASAAS GESTÃO FINANCEIRA INSTITUIÇÃO DE PAGAMENTOS S.A. A taxa da instituição é descontada do valor pago. A KonstruLog atua exclusivamente como integradora tecnológica, não é instituição financeira ou de pagamento, não intermedia valores em nome próprio e não fica com comissão dessas cobranças.",
      "changesTitle": "Alterações",
      "changesBody": "Podemos atualizar estes termos. O uso contínuo após a publicação de uma nova versão implica aceitação. Se não concordar, deixe de usar o serviço e exporte seus dados com o administrador."
    },
    "privacy": {
      "intro": "Esta Política de Privacidade explica como o KonstruLog trata dados pessoais e da empresa ao usar nossos sites, aplicativo web e aplicativos móveis. Aplica-se a clientes no Brasil e nos Estados Unidos. Adendos específicos (como LGPD ou CCPA) podem ser incluídos depois.",
      "collectTitle": "O que coletamos",
      "collectBody": "Coletamos dados de conta (nome, e-mail, data de nascimento, telefone), dados da organização (razão social, identificador fiscal, endereço), registros de obra que você informa (diários, fotos, equipe, parceiros, lançamentos financeiros) e dados técnicos (dispositivo, IP, logs) necessários para operar e proteger o serviço.",
      "useTitle": "Como usamos os dados",
      "useBody": "Usamos os dados para prestar o produto, autenticar usuários, guardar o histórico da obra, enviar e-mails transacionais, melhorar a confiabilidade e cumprir obrigações legais. Não usamos fotos ou diários das suas obras para treinar modelos de IA públicos.",
      "shareTitle": "Compartilhamento",
      "shareBody": "Compartilhamos dados com subprocessadores de infraestrutura, autenticação e e-mail, apenas o necessário para operar o KonstruLog. Organizações no Brasil que ativam cobranças PIX ou boleto compartilham dados cadastrais e de transação com a instituição de pagamento configurada para essa organização: por padrão, a PAGAR.ME S.A.; se a organização estiver no Asaas, a ASAAS GESTÃO FINANCEIRA INSTITUIÇÃO DE PAGAMENTOS S.A. Podemos divulgar informações se a lei exigir. Não vendemos dados pessoais.",
      "retentionTitle": "Retenção e segurança",
      "retentionBody": "Mantemos os dados da organização enquanto a conta estiver ativa e por um período razoável depois, para que você possa exportá-los. Usamos controle de acesso, criptografia em trânsito e isolamento por organização. Nenhum método de armazenamento é 100% seguro.",
      "rightsTitle": "Seus direitos",
      "rightsBody": "Conforme o seu local, você pode pedir acesso, correção, exclusão ou portabilidade de dados pessoais, ou se opor a certos tratamentos. Administradores da organização controlam o acesso dos membros. Fale conosco para exercer esses direitos.",
      "contactTitle": "Contato",
      "contactBody": "Dúvidas sobre privacidade ou estes termos: contato@konstrulog.com (Brasil) ou contact@konstrulog.com (Estados Unidos)."
    }
  },
  "auth": {
    "profileLoadErrorTitle": "Não foi possível carregar sua conta",
    "profileLoadError": "Verifique sua conexão e tente novamente. Se o problema continuar, entre em contato com o suporte.",
    "retry": "Tentar novamente",
    "signOut": "Sair",
    "continueWithGoogle": "Continuar com Google",
    "orEmailPassword": "ou continue com e-mail",
    "googleError": "Não foi possível iniciar o login com Google. Tente novamente.",
    "googleNotConfigured": "O login com Google não está configurado. Adicione VITE_GOOGLE_WEB_CLIENT_ID no arquivo .env.",
    "googleAccountNotFound": "Nenhuma conta encontrada para esta conta Google. Crie uma conta antes de entrar.",
    "googleEmailMismatch": "Use a conta Google do e-mail convidado ({{email}}).",
    "googleAccountSwitched": "Essa conta Google pertence a outro usuário. Use o e-mail do convite."
  },
  "authCallback": {
    "loading": "Entrando…",
    "errorTitle": "Não foi possível concluir o login",
    "invalidOrExpired": "Este link é inválido ou expirou. Peça ao administrador para reenviar o convite.",
    "notConfigured": "A autenticação não está configurada. Entre em contato com o suporte.",
    "signupsDisabled": "A criação de novas contas está desativada nas configurações de autenticação. Ative “Allow new users to sign up” no Supabase e tente novamente.",
    "backToLogin": "Voltar ao login",
    "mobileBridgeLoading": "Voltando para o app KonstruLog…",
    "mobileBridgeMissingReturn": "Este link de login mobile está incompleto. Feche esta janela e tente de novo pelo app."
  },
  "noOrgAccess": {
    "title": "Você não tem mais acesso",
    "description": "Este convite foi revogado ou não é mais válido. Entre em contato com o administrador da organização se achar que isso é um engano.",
    "signOut": "Sair"
  },
  "noPermission": {
    "title": "Sem permissões",
    "description": "Sua conta ainda não tem permissão para nenhuma área do KonstruLog. Fale com o administrador da sua organização para solicitar acesso.",
    "descriptionWithOrg": "Sua conta em <org>{{orgName}}</org> ainda não tem permissão para nenhuma área do KonstruLog. Fale com o administrador da sua organização para solicitar acesso.",
    "signOut": "Sair"
  },
  "notFound": {
    "errorCode": "Erro 404",
    "title": "Página não encontrada",
    "description": "Essa página não existe ou o link pode estar incorreto. Confira o endereço ou volte para uma área conhecida.",
    "goHome": "Ir para o início",
    "goLogin": "Ir para o login",
    "goBack": "Voltar"
  },
  "memberDisabled": {
    "title": "Seu acesso está desativado",
    "description": "O administrador da organização desativou sua conta. Entre em contato com ele se precisar de acesso novamente.",
    "descriptionWithOrg": "Seu acesso a {{orgName}} foi desativado por um administrador. Entre em contato com ele se precisar de acesso novamente.",
    "signOut": "Sair"
  },
  "acceptInvite": {
    "eyebrow": "Convite",
    "title": "Você foi convidado para fazer parte da organização {{orgName}}",
    "heroTitle": "Entrar em {{orgName}}",
    "description": "Confirme seu nome e continue com Google, ou defina uma senha para entrar na equipe.",
    "descriptionExisting": "Confirme seu nome para entrar nesta organização.",
    "platformTitle": "Bem-vindo ao KonstruLog",
    "platformDescription": "Confirme seu nome e continue com Google, ou defina uma senha para começar.",
    "platformDescriptionExisting": "Confirme seu nome para continuar.",
    "orSetPassword": "ou defina uma senha",
    "fullName": "Nome completo",
    "password": "Senha",
    "confirmPassword": "Confirmar senha",
    "passwordMin": "Mínimo de 6 caracteres",
    "passwordMismatch": "As senhas não coincidem",
    "submit": "Entrar na organização",
    "continue": "Continuar",
    "platformSubmit": "Continuar",
    "logout": "Sair",
    "useAnotherAccount": "Usar outra conta",
    "supabaseNotConfigured": "A autenticação não está configurada. Entre em contato com o suporte."
  },
  "accessLocked": {
    "goToBilling": "Ir para cobrança",
    "signOut": "Sair",
    "generic": {
      "title": "Acesso restrito",
      "description": "Sua conta não tem acesso ativo no momento."
    },
    "trialEnded": {
      "title": "Período de teste encerrado",
      "description": "Seu período de teste terminou. Revise a cobrança para restaurar o acesso."
    },
    "paymentRequired": {
      "title": "Pagamento pendente",
      "description": "É necessário um pagamento para continuar usando o KonstruLog."
    },
    "organizationBlocked": {
      "title": "Acesso suspenso",
      "description": "O acesso da sua organização foi suspenso. Entre em contato com o suporte."
    }
  },
  "billing": {
    "title": "Cobrança",
    "subscriptionStatus": "{{plan}}",
    "noSubscription": "Nenhuma assinatura ativa registrada.",
    "accessActiveTitle": "Assinatura ativa",
    "accessActive": "Sua assinatura está ativa.",
    "contact": "Dúvidas?<br/>Fale conosco em <email>{{email}}</email>",
    "paymentsTitle": "Pagamentos",
    "paymentsDescription": "Cobranças e faturas recentes da sua organização.",
    "noPayments": "Nenhum pagamento registrado ainda.",
    "method": "Forma",
    "description": "Descrição",
    "paymentDescriptionMonthly": "KonstruLog {{plan}} — mensal",
    "amount": "Valor",
    "date": "Data",
    "dueAtLabel": "Vencimento",
    "viewPayment": "Ver pagamento",
    "subscribeTitle": "Escolha seu plano",
    "subscribeDescription": "Escolha o plano e a forma de pagamento para continuar após o trial.",
    "subscribeCta": "Assinar",
    "subscribeSuccess": "Assinatura criada. Conclua o pagamento se solicitado.",
    "subscribeCardSuccess": "Assinatura ativada com o cartão de crédito.",
    "subscribeError": "Não foi possível iniciar a assinatura.",
    "subscribeUnavailable": "A cobrança online ainda não está disponível. Fale com o suporte.",
    "settingsDescription": "Plano, faturas e formas de pagamento da sua organização.",
    "subscriptionStatusTitle": "Plano atual",
    "periodEnds": "Renova em {{date}}",
    "periodEndsLabel": "Renova em",
    "status": "Status",
    "choosePlan": "Plano",
    "chooseMethod": "Forma de pagamento",
    "perMonth": "/mês",
    "cardMethodHint": "Somente cartão de crédito. O cartão é cobrado no KonstruLog e renova automaticamente todo mês.",
    "cardFormTitle": "Cartão de crédito",
    "cardFormIncomplete": "Preencha todos os dados obrigatórios do cartão e da cobrança.",
    "cardNumberInvalid": "Informe um número de cartão válido.",
    "cardPreviewNamePlaceholder": "NOME NO CARTÃO",
    "cardHolderName": "Nome impresso no cartão",
    "cardNumber": "Número do cartão",
    "cardExpiryMonth": "Mês",
    "cardExpiryYear": "Ano",
    "cardCcv": "CVV",
    "cardHolderInfoTitle": "Dados do titular",
    "holderName": "Nome completo",
    "holderEmail": "E-mail",
    "holderTaxId": "CPF/CNPJ",
    "holderPostalCode": "CEP",
    "holderAddressNumber": "Número",
    "holderAddressComplement": "Complemento",
    "holderPhone": "Telefone",
    "manualCycleHint": "Todo mês uma nova cobrança é gerada. Pague o PIX ou boleto até o vencimento.",
    "retryCardTitle": "Atualizar forma de pagamento",
    "retryCardDescription": "A última cobrança falhou. Informe um cartão de crédito válido para pagar a fatura em aberto e manter a renovação automática.",
    "retryCardOpenCta": "Atualizar cartão",
    "retryCardCta": "Pagar e atualizar cartão",
    "retryCardSuccess": "Pagamento confirmado. Sua assinatura está ativa novamente.",
    "retryCardError": "Não foi possível cobrar este cartão. Confira os dados e tente de novo.",
    "graceBanner": "Pagamento falhou. Atualize a cobrança até {{date}} para manter o acesso.",
    "graceBannerMember": "Pagamento falhou. O acesso pode ser interrompido em {{date}}. Peça a um administrador da organização para atualizar a cobrança.",
    "openInvoiceTitle": "Cobrança em aberto",
    "openInvoiceDescription": "Pague esta cobrança para manter a assinatura ativa.",
    "dueAt": "Vence em {{date}}",
    "pixQrAlt": "QR Code PIX",
    "pixCopyLabel": "PIX copia e cola",
    "payWithCard": "Pagar com cartão",
    "planLabels": {
      "starter": "Starter",
      "pro": "Pro",
      "business": "Business"
    },
    "statusLabels": {
      "trialing": "Em teste",
      "active": "Ativo",
      "past_due": "Pagamento pendente",
      "canceled": "Cancelado"
    },
    "paymentMethods": {
      "pix": "PIX",
      "boleto": "Boleto",
      "credit_card": "Cartão de crédito",
      "other": "Outro"
    },
    "paymentStatuses": {
      "pending": "Pendente",
      "paid": "Pago",
      "overdue": "Em atraso",
      "canceled": "Cancelado"
    }
  },
  "onboarding": {
    "eyebrow": "Onboarding",
    "stepOf": "{{current}} / {{total}}",
    "personalTitle": "Informações pessoais",
    "personalDescription": "Essas informações identificam você no KonstruLog.",
    "collaboratorPersonalDescription": "Informe seu cargo, data de nascimento e telefone.",
    "companyTitle": "Informações da empresa",
    "companyDescription": "Essas informações identificam sua empresa no KonstruLog.",
    "collaboratorAddressTitle": "Endereço",
    "collaboratorAddressDescription": "Informe o endereço para concluir o cadastro de colaborador.",
    "title": "Configure sua empresa",
    "description": "Essas informações identificam sua conta no KonstruLog.",
    "fullName": "Seu nome",
    "fullNamePlaceholder": "João Silva",
    "birthDate": "Data de nascimento",
    "birthDatePlaceholder": "Selecione a data",
    "birthDateOpenCalendar": "Abrir calendário",
    "birthDateFuture": "A data de nascimento não pode ser no futuro.",
    "birthDateMinAge": "Você precisa ter pelo menos 18 anos.",
    "orgName": "Nome fantasia",
    "orgNamePlaceholder": "Construtora Silva",
    "orgNameRequired": "Informe o nome fantasia",
    "legalName": "Razão social",
    "legalNamePlaceholder": "Construtora Silva LTDA",
    "legalNamePlaceholderUs": "Acme Construction LLC",
    "country": "País",
    "countryBR": "Brasil",
    "countryUS": "Estados Unidos",
    "cnpj": "CNPJ",
    "cnpjPlaceholder": "00.000.000/0000-00",
    "cnpjInvalid": "Informe um CNPJ válido",
    "ein": "EIN",
    "einPlaceholder": "12-3456789",
    "einInvalid": "Informe um EIN válido",
    "orgType": "Tipo de conta",
    "solo": "Solo — autônomo ou pequena empresa",
    "business": "Business — equipe com múltiplos membros",
    "logout": "Sair",
    "continue": "Continuar",
    "back": "Voltar",
    "submit": "Começar período de teste",
    "submitPaid": "Começar plano {{plan}}",
    "collaboratorSubmit": "Entrar na organização",
    "error": "Erro ao criar empresa",
    "unauthorized": "Algo deu errado ao sincronizar sua conta. Saia e entre novamente. Se continuar assim, entre em contato com o suporte."
  },
  "productTour": {
    "welcomeTitle": "Bem-vindo ao KonstruLog",
    "welcomeDescription": "Um tour curto desta tela para você saber por onde começar.",
    "start": "Começar tour",
    "skip": "Pular",
    "next": "Próximo",
    "back": "Voltar",
    "done": "Concluir",
    "stepOf": "{{current}} / {{total}}",
    "replay": "Ver tour",
    "steps": {
      "appNav": {
        "title": "Início, obras e orçamentos",
        "description": "Use a barra lateral para ir ao Início, ao Acompanhamento, à lista de obras e aos orçamentos."
      },
      "dashboardKpis": {
        "title": "Saúde das obras",
        "description": "Estes cards mostram obras ativas, pausadas, sem diário hoje e atrasadas. Toque em um para filtrar a lista."
      },
      "newProject": {
        "title": "Criar uma obra",
        "description": "Adicione sua primeira obra por aqui. A configuração leva só alguns passos."
      },
      "memberProjects": {
        "title": "Suas obras",
        "description": "Abra uma obra para registrar diário, fotos e andamento."
      },
      "globalSearch": {
        "title": "Busca",
        "description": "Encontre obras e páginas rapidamente. No computador você também pode usar Ctrl/Cmd+K."
      },
      "settings": {
        "title": "Configurações da empresa",
        "description": "A configuração da empresa fica aqui: usuários, modelos, colaboradores e mais."
      },
      "accountMenu": {
        "title": "Sua conta",
        "description": "Altere idioma, tema ou organização, veja este tour de novo ou saia. As notificações ficam ao lado deste menu."
      }
    }
  },
  "account": {
    "title": "Conta",
    "sections": {
      "personal": "Pessoal"
    }
  },
  "settings": {
    "sections": {
      "empresa": "Empresa",
      "cadastros": "Cadastros",
      "obras": "Obras",
      "ferramentas": "Ferramentas"
    },
    "nav": {
      "main": "Visão geral",
      "profile": "Perfil",
      "general": "Geral",
      "organization": "Organização",
      "administration": "Administração",
      "users": "Usuários",
      "permissions": "Permissões"
    },
    "searchPlaceholder": "Buscar configuração",
    "home": {
      "title": "Acesso rápido às principais configurações da empresa",
      "subtitle": "Empresa, cadastros e ferramentas — encontre o que precisa, rápido",
      "descriptions": {
        "administration": "Empresa, usuários, permissões e preferências gerais",
        "general": "Configure o comportamento geral do aplicativo na sua empresa",
        "organization": "Gerencie os dados da sua empresa",
        "users": "Gerencie usuários, convites e acessos da sua organização",
        "permissions": "Defina cargos e modelos de permissão para sua equipe",
        "diaryReportModels": "Configure modelos de PDF reutilizáveis para relatórios do diário",
        "serviceFrontModels": "Crie modelos de frente de serviço reutilizáveis para seus projetos",
        "checklistModels": "Crie modelos de checklist reutilizáveis para etapas de frente de serviço",
        "occurrences": "Configure os tipos de ocorrência registrados na obra",
        "documentCategories": "Organize os documentos dos projetos em categorias",
        "photoTags": "Gerencie as tags usadas para classificar fotos dos projetos",
        "classifications": "Configure prioridades, tipos e status",
        "workers": "Gerencie colaboradores e seus cargos",
        "materials": "Gerencie materiais, categorias e unidades de medida",
        "equipments": "Gerencie equipamentos e categorias",
        "partners": "Cadastre clientes, fornecedores e prestadores usados nas obras e no financeiro",
        "financeLookups": "Configure categorias financeiras e formas de pagamento",
        "serviceTaxCodes": "Cadastre os códigos LC 116 usados na emissão de NFS-e"
      }
    },
    "materials": {
      "categories": "Categorias de materiais",
      "list": "Lista",
      "measurementUnits": "Unidades de medida",
      "items": "Materiais"
    },
    "workers": {
      "list": "Lista",
      "items": "Colaboradores",
      "roles": "Cargos"
    },
    "title": "Configurações da empresa",
    "description": "Equipe, catálogo e preferências.",
    "hubEmpty": "Nenhuma seção de configurações está disponível para sua conta.",
    "edit": "Editar",
    "orgSectionTitle": "Organização",
    "orgSectionDescription": "Dados da sua empresa no KonstruLog. O nome é atualizado em todo o app após salvar.",
    "orgId": "ID da organização",
    "orgType": "Tipo de conta",
    "yourRole": "Seu papel",
    "planLabel": "Plano",
    "updatedAt": "Última atualização",
    "save": "Salvar alterações",
    "saveSuccess": "Organização atualizada.",
    "saveError": "Não foi possível salvar.",
    "forbidden": "Você não tem permissão para editar a organização.",
    "loadError": "Não foi possível carregar os dados da organização.",
    "memberReadOnly": "Somente administradores podem alterar o nome da empresa. Fale com um administrador se algo estiver incorreto.",
    "stepDetails": "Dados da organização",
    "stepReview": "Revisar e enviar",
    "formReviewTitle": "Revisar e enviar",
    "reviewSummaryTitle": "Resumo",
    "profile": {
      "description": "Seu nome aparece no app.",
      "fullName": "Nome completo",
      "fullNamePlaceholder": "João Silva",
      "birthDate": "Data de nascimento",
      "birthDatePlaceholder": "Selecione a data",
      "birthDateOpenCalendar": "Abrir calendário",
      "birthDateFuture": "A data de nascimento não pode ser no futuro.",
      "birthDateMinAge": "Você precisa ter pelo menos 18 anos.",
      "email": "E-mail",
      "permissionProfile": "Perfil de permissão",
      "unknownName": "Não informado",
      "formTitle": "Editar perfil",
      "stepDetails": "Dados do perfil",
      "saveSuccess": "Perfil atualizado.",
      "saveError": "Não foi possível salvar seu perfil.",
      "avatar": "Foto de perfil",
      "avatarHint": "JPEG, PNG ou WebP até 2 MB.",
      "avatarModalTitle": "Sua foto de perfil",
      "avatarEdit": "Editar",
      "avatarEditAria": "Editar foto de perfil",
      "avatarRemove": "Remover foto",
      "avatarRemoveConfirmTitle": "Remover foto de perfil?",
      "avatarRemoveConfirmDescription": "Suas iniciais serão exibidas até você adicionar uma nova foto.",
      "avatarUpdateSuccess": "Foto de perfil atualizada.",
      "avatarRemoveSuccess": "Foto de perfil removida."
    },
    "general": {
      "sectionDiary": "Diário",
      "allowPastDiaryEntryEdits": "Permitir edição de diários de dias anteriores",
      "allowPastDiaryEntryEditsDescription": "Quando esta opção estiver ligada, diários publicados de dias anteriores poderão ser editados ou excluídos.",
      "diaryEntryFormModeDescription": "Escolha o nível de detalhe dos diários.",
      "diaryEntryFormOccurrences": "Ocorrências",
      "diaryEntryFormMaterials": "Materiais",
      "diaryEntryFormEquipments": "Equipamentos",
      "diaryEntryFormChecklists": "Checklists",
      "sectionFiscal": "Notas fiscais",
      "fiscalDocumentsEnabled": "Emitir notas fiscais (NFS-e)",
      "fiscalDocumentsEnabledDescription": "Quando desligado, a empresa não emite NFS-e e as telas de nota fiscal ficam ocultas.",
      "sectionCharges": "Cobranças",
      "chargesEnabled": "Gerar boleto e PIX",
      "chargesEnabledDescription": "Quando desligado, a empresa não gera boleto e PIX e o cadastro da conta bancária fica oculto.",
      "saveSuccess": "Configurações salvas."
    },
    "organization": {
      "formTitle": "Editar organização",
      "sectionLegal": "Identificação legal",
      "sectionDomain": "Domínio",
      "sectionContact": "Contato e faturamento",
      "sectionSize": "Porte",
      "sectionAccount": "Conta",
      "logo": "Logotipo",
      "logoHint": "JPEG, PNG ou WebP até 2 MB. Imagens grandes são reduzidas automaticamente.",
      "logoModalTitle": "Logotipo da empresa",
      "logoEdit": "Escolher imagem",
      "logoEditAria": "Editar logotipo da empresa",
      "logoRemove": "Remover logotipo",
      "logoRemoveConfirmTitle": "Remover logotipo?",
      "logoRemoveConfirmDescription": "O logotipo deixará de aparecer nos relatórios até você adicionar outro.",
      "logoUpdateSuccess": "Logotipo atualizado.",
      "logoRemoveSuccess": "Logotipo removido.",
      "technicalResponsible": "Responsável técnico",
      "technicalResponsiblePlaceholder": "Selecione um colaborador…",
      "technicalResponsibleRegistry": "CREA / CAU",
      "technicalResponsibleRegistryPlaceholder": "Número do registro",
      "country": "País",
      "countries": {
        "BR": "Brasil",
        "US": "Estados Unidos"
      },
      "countryLockedHint": "Definido na criação da empresa. Fale com o suporte para alterar.",
      "timeZone": "Fuso horário",
      "timeZonePlaceholder": "Buscar fuso horário…",
      "segment": "Segmento",
      "segmentPlaceholder": "Selecione um segmento",
      "segments": {
        "residential": "Residencial",
        "commercial": "Comercial",
        "industrial": "Industrial",
        "renovation": "Reformas"
      },
      "address": "Endereço da sede",
      "addressPlaceholder": "Rua, cidade, estado, CEP",
      "phone": "Telefone",
      "phonePlaceholder": "+55 11 99999-0000",
      "commercialEmail": "E-mail comercial",
      "commercialEmailPlaceholder": "contato@empresa.com",
      "commercialEmailInvalid": "Informe um e-mail válido",
      "financialContact": "Responsável financeiro",
      "estimatedEmployeeCount": "Funcionários estimados",
      "estimatedConcurrentProjects": "Obras simultâneas estimadas",
      "employeeRanges": {
        "from_1_to_5": "1–5",
        "from_6_to_20": "6–20",
        "from_21_to_50": "21–50",
        "from_51_to_200": "51–200",
        "from_200_plus": "200+"
      },
      "concurrentProjectsRanges": {
        "one": "1",
        "from_2_to_5": "2–5",
        "from_6_to_15": "6–15",
        "from_16_to_30": "16–30",
        "from_30_plus": "30+"
      },
      "employeeRangePlaceholder": "Selecione uma faixa…",
      "concurrentProjectsRangePlaceholder": "Selecione uma faixa…"
    },
    "users": {
      "invite": "Criar usuário",
      "inviteTitle": "Criar usuário",
      "inviteStep": "Dados do convite",
      "inviteStepEmail": "E-mail",
      "inviteStepPermissions": "Permissões",
      "inviteStepReview": "Revisão",
      "inviteSubmit": "Criar usuário",
      "createWorkerOnAccept": "Criar colaborador",
      "createWorkerOnAcceptHint": "Como colaborador, a pessoa pode ser responsável pela obra, criar diário de obras e realizar outras atividades no sistema. Telefone, endereço e cargo são preenchidos ao aceitar o convite.",
      "inviteSuccess": "Convite enviado.",
      "createSuccess": "Usuário criado.",
      "sendInviteModalTitle": "Enviar convite agora?",
      "sendInviteModalDescription": "Você pode enviar o e-mail de convite agora ou criar o usuário sem enviar e-mail. Usuários sem convite ficam em “Sem convite” até você enviar pela lista de usuários.",
      "sendInviteNow": "Enviar convite agora",
      "createWithoutInvite": "Criar sem convite",
      "sendInvite": "Enviar convite",
      "sendInviteSuccess": "Convite enviado.",
      "resendInvite": "Reenviar convite",
      "resendInviteSuccess": "Convite reenviado.",
      "colStatus": "Status",
      "invitedAt": "Convidado em",
      "status": {
        "not_invited": "Sem convite",
        "invited": "Convidado",
        "onboarded": "Ativo",
        "disabled": "Desativado"
      },
      "backToList": "Voltar para usuários",
      "email": "E-mail",
      "role": "Papel",
      "colName": "Nome",
      "colPermissions": "Permissões",
      "profileType": "Tipo de perfil",
      "useExistingProfile": "Usar perfil existente",
      "customPermissions": "Permissões personalizadas",
      "selectProfile": "Selecionar perfil",
      "permissionRequired": "Selecione um perfil de permissão.",
      "inviteEmailAlreadyExists": "Não é possível criar este usuário. Já existe uma conta com este e-mail.",
      "inviteMemberAlreadyExists": "Não é possível criar este usuário. Ele já faz parte da sua organização.",
      "inviteUserAlreadyInOrg": "Não é possível criar este usuário. Este e-mail pertence a um usuário de outra organização.",
      "saveAsProfile": "Salvar como novo perfil",
      "selectedProfile": "Perfil selecionado",
      "customProfile": "Personalizado",
      "searchPlaceholder": "Buscar por nome ou e-mail…",
      "clearSearch": "Limpar busca",
      "total_one": "{{count}} resultado",
      "total_other": "{{count}} resultados",
      "userCount_one": "{{count}} usuário",
      "userCount_other": "{{count}} usuários",
      "emptyTitle": "Nenhum usuário ainda",
      "emptyDescription": "Convide pessoas para colaborar na sua organização.",
      "noSearchResults": "Nenhum usuário corresponde à busca.",
      "noFilterResults": "Nenhum usuário corresponde aos filtros selecionados.",
      "loadError": "Não foi possível carregar os usuários.",
      "loadMoreError": "Não foi possível carregar mais usuários.",
      "loadMoreRetry": "Tentar novamente",
      "seatsRemaining_one": "Você pode convidar mais {{count}} usuário no seu plano.",
      "seatsRemaining_other": "Você pode convidar mais {{count}} usuários no seu plano.",
      "atCapHint": "Você atingiu o limite de usuários do plano.",
      "drawerDetailTitle": "Detalhe do usuário",
      "joinedAt": "Entrou em",
      "permissionsHeading": "Permissões",
      "edit": "Editar",
      "remove": "Remover",
      "disable": "Desativar",
      "enable": "Ativar",
      "disableConfirmTitle": "Desativar usuário",
      "disableConfirmDescription": "Este usuário perderá o acesso à organização até ser reativado. A vaga continuará ocupada.",
      "disableConfirmAction": "Desativar usuário",
      "disableSuccess": "Usuário desativado.",
      "enableSuccess": "Usuário ativado.",
      "actionsMenu": "Ações do usuário",
      "editTitle": "Editar permissões do usuário",
      "editStep": "Dados do usuário",
      "formReviewTitle": "Revisar e enviar",
      "reviewSummaryTitle": "Resumo",
      "editSuccess": "Permissões do usuário atualizadas.",
      "removeConfirmTitle": "Remover usuário",
      "removeConfirmDescription": "Este usuário perderá o acesso à sua organização. Esta ação não pode ser desfeita.",
      "removeConfirmAction": "Remover usuário",
      "removeSuccess": "Usuário removido.",
      "filter": {
        "permissions": "Permissões",
        "permissionsSearch": "Buscar perfis de permissão…",
        "permissionsEmpty": "Nenhum perfil de permissão encontrado.",
        "apply": "Mostrar resultados",
        "reset": "Limpar",
        "close": "Fechar filtro"
      }
    },
    "equipments": {
      "categories": "Categorias de equipamentos",
      "list": "Lista",
      "items": "Equipamentos"
    },
    "finance": {
      "categories": "Categorias financeiras",
      "paymentMethods": "Formas de pagamento"
    }
  },
  "roles": {
    "admin": "Administrador",
    "member": "Membro",
    "owner": "Proprietário"
  },
  "memberHome": {
    "title": "Seu trabalho",
    "subtitle": "Escolha uma obra abaixo para abrir detalhes, diário e registros que você pode ver.",
    "projectsHeading": "Suas obras"
  },
  "projectServiceFronts": {
    "new": "Nova frente de serviço",
    "edit": "Editar",
    "delete": "Excluir",
    "inactivate": "Inativar",
    "reactivate": "Reativar",
    "save": "Salvar",
    "cancel": "Cancelar",
    "formSections": {
      "identification": "Identificação",
      "details": "Detalhes"
    },
    "createdAt": "Criado em",
    "createdByLabel": "Registrado por",
    "unknownCreator": "Usuário desconhecido",
    "colName": "Nome",
    "colStatus": "Status",
    "colDescription": "Descrição",
    "colColor": "Cor",
    "colProgress": "Progresso",
    "colDeadlineStatus": "Prazo",
    "colInitialDate": "Data inicial",
    "colCompletionDate": "Conclusão",
    "colTeam": "Equipe",
    "colProjectDiaryEntries": "Registros do diário",
    "colOccurrences": "Ocorrências",
    "nameLabel": "Nome",
    "descriptionLabel": "Descrição",
    "colorLabel": "Cor",
    "progressLabel": "Progresso",
    "progressInvalid": "Informe um número inteiro de 0 a 100.",
    "initialDateLabel": "Data inicial",
    "completionDateLabel": "Data prevista de conclusão",
    "completionDateBeforeInitial": "A data de conclusão não pode ser anterior à data inicial.",
    "deadlineStatusLabel": "Prazo",
    "deadlineStatus": {
      "on_time": "No prazo",
      "overdue": "Atrasada",
      "completed": "Concluída"
    },
    "teamLabel": "Equipe",
    "teamPlaceholder": "Selecione colaboradores…",
    "drawerNoTeam": "Nenhum colaborador atribuído.",
    "checklistsLabel": "Checklists",
    "checklistsPlaceholder": "Selecione checklists…",
    "drawerNoChecklists": "Nenhum checklist atribuído.",
    "colorInvalid": "Informe uma cor hexadecimal válida (ex.: #1D4ED8).",
    "colorPlaceholder": "#RRGGBB",
    "dialogCreateTitle": "Nova frente de serviço",
    "dialogEditTitle": "Editar frente de serviço",
    "formCreateTitle": "Nova frente de serviço",
    "formEditTitle": "Editar frente de serviço",
    "formReviewTitle": "Revisar e enviar",
    "stepDetails": "Detalhes da frente de serviço",
    "stepReview": "Revisar e enviar",
    "reviewSummaryTitle": "Resumo",
    "reviewPreviousLine": "Anterior: {{value}}",
    "backToList": "Voltar para frentes de serviço",
    "notFound": "Esta frente de serviço não existe mais ou você não tem acesso.",
    "drawerNoDescription": "Sem descrição.",
    "drawerDetailTitle": "Detalhe da frente de serviço",
    "drawerStatsProjectDiaryEntries": "Registros do diário",
    "drawerStatsOccurrences": "Ocorrências",
    "drawerStatsPhotos": "Fotos",
    "drawerRecentActivitiesSection": "Diário de obra",
    "drawerRecentProjectServiceFronts": "Frente de serviço",
    "drawerRecentOccurrences": "Ocorrências",
    "drawerSeeAll": "Ver todos",
    "drawerNoRecentProjectServiceFronts": "Nenhum registro do diário para esta frente ainda.",
    "drawerNoRecentOccurrences": "Nenhuma ocorrência nos registros relacionados ainda.",
    "drawerActivityPhotoCount_one": "{{count}} foto",
    "drawerActivityPhotoCount_other": "{{count}} fotos",
    "loadError": "Não foi possível carregar as frentes de serviço.",
    "saveSuccess": "Frente de serviço salva.",
    "statusActive": "Ativa",
    "statusInactive": "Inativa",
    "deleteSuccess": "Frente de serviço removida.",
    "inactivateSuccess": "Frente de serviço inativada.",
    "reactivateSuccess": "Frente de serviço reativada.",
    "deleteConfirmTitle": "Excluir esta frente de serviço?",
    "deleteConfirmDescription": "Esta ação não pode ser desfeita. A frente não possui histórico no diário.",
    "deleteConfirmAction": "Excluir",
    "inactivateConfirmTitle": "Inativar esta frente de serviço?",
    "inactivateConfirmDescription": "Ela deixará de aparecer em novos registros do diário. O histórico existente será preservado.",
    "inactivateConfirmAction": "Inativar",
    "reactivateConfirmTitle": "Reativar esta frente de serviço?",
    "reactivateConfirmDescription": "Ela voltará a aparecer em novos registros do diário e seleções.",
    "reactivateConfirmAction": "Reativar",
    "deleteInUse": "Esta frente possui histórico no diário e não pode ser excluída.",
    "nameTaken": "Já existe uma frente de serviço com este nome.",
    "forbidden": "Você não tem permissão para alterar as frentes de serviço.",
    "actionsMenu": "Ações",
    "emptyTitle": "Nenhuma frente de serviço",
    "emptyDescription": "Crie uma para usar no diário de obra e demais funcionalidades.",
    "searchPlaceholder": "Buscar por nome ou descrição…",
    "clearSearch": "Limpar busca",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "noSearchResults": "Nenhuma frente de serviço corresponde à sua busca.",
    "filter": {
      "progress": "Progresso",
      "progressRangeInvalid": "De deve ser menor ou igual a Até.",
      "deadlineStatus": "Prazo",
      "deadlineStatusSearch": "Buscar status de prazo…",
      "deadlineStatusEmpty": "Nenhum status de prazo encontrado.",
      "initialDate": "Data inicial",
      "completionDate": "Data de conclusão",
      "dateFromLabel": "De",
      "dateToLabel": "Até",
      "projectDiaryEntries": "Registros do diário",
      "projectDiaryEntriesWith": "Com registros",
      "projectDiaryEntriesWithout": "Sem registros",
      "occurrences": "Ocorrências",
      "occurrencesWith": "Com ocorrências",
      "occurrencesWithout": "Sem ocorrências"
    },
    "loadMoreError": "Não foi possível carregar mais frentes de serviço.",
    "loadMoreRetry": "Tentar novamente"
  },
  "serviceFrontModels": {
    "new": "Novo modelo",
    "edit": "Editar",
    "delete": "Excluir",
    "save": "Salvar",
    "cancel": "Cancelar",
    "createdAt": "Criado em",
    "colName": "Nome",
    "colDescription": "Descrição",
    "colSteps": "Etapas",
    "colStatus": "Status",
    "statusActive": "Ativo",
    "statusInactive": "Inativo",
    "nameLabel": "Nome",
    "descriptionLabel": "Descrição",
    "stepsLabel": "Etapas",
    "stepsOverflow": "+{{count}} etapas",
    "stepNameLabel": "Etapa {{index}}",
    "stepNamePlaceholder": "Nome da etapa…",
    "stepColorLabel": "Cor da etapa {{index}}",
    "colorInvalid": "Informe uma cor hexadecimal válida (ex.: #1D4ED8).",
    "addStep": "Adicionar etapa",
    "removeStep": "Remover etapa",
    "reorderStep": "Reordenar etapa",
    "formCreateTitle": "Novo modelo de frente de serviço",
    "formEditTitle": "Editar modelo de frente de serviço",
    "notFound": "Este modelo não existe mais ou você não tem acesso.",
    "drawerNoDescription": "Sem descrição.",
    "drawerDetailTitle": "Detalhe do modelo de frente de serviço",
    "loadError": "Não foi possível carregar os modelos.",
    "saveSuccess": "Modelo salvo.",
    "deleteSuccess": "Modelo removido.",
    "deleteConfirmTitle": "Excluir este modelo?",
    "deleteConfirmDescription": "Esta ação não pode ser desfeita. Não é possível excluir um modelo usado em obras.",
    "deleteConfirmAction": "Excluir",
    "deleteInUse": "Este modelo está em uso em obras e não pode ser excluído.",
    "nameTaken": "Já existe um modelo com este nome.",
    "forbidden": "Você não tem permissão para alterar os modelos.",
    "actionsMenu": "Ações",
    "emptyTitle": "Nenhum modelo de frente de serviço",
    "emptyDescription": "Ainda não há modelos de frente de serviço configurados para esta organização.",
    "searchPlaceholder": "Buscar por nome ou descrição…",
    "clearSearch": "Limpar busca",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "noSearchResults": "Nenhum modelo corresponde à sua busca.",
    "noFilterResults": "Nenhum modelo corresponde aos filtros selecionados.",
    "loadMoreError": "Não foi possível carregar mais modelos.",
    "loadMoreRetry": "Tentar novamente",
    "checklistModelsLabel": "Modelos de checklist",
    "checklistModelsPlaceholder": "Selecione modelos de checklist…",
    "checklistModelsSearch": "Buscar modelos de checklist…",
    "checklistModelsEmpty": "Nenhum modelo de checklist encontrado.",
    "checklistModelsNone": "Nenhum modelo de checklist",
    "checklistsCount_one": "{{count}} checklist",
    "checklistsCount_other": "{{count}} checklists",
    "stepChecklistsLabel_one": "Checklist",
    "stepChecklistsLabel_other": "Checklists"
  },
  "checklistModels": {
    "new": "Novo modelo",
    "edit": "Editar",
    "delete": "Excluir",
    "save": "Salvar",
    "cancel": "Cancelar",
    "createdAt": "Criado em",
    "colName": "Nome",
    "colDescription": "Descrição",
    "colItems": "Itens",
    "colStatus": "Status",
    "statusActive": "Ativo",
    "statusInactive": "Inativo",
    "nameLabel": "Nome",
    "descriptionLabel": "Descrição",
    "itemsLabel": "Itens",
    "itemsOverflow": "+{{count}} itens",
    "itemNameLabel": "Item {{index}}",
    "itemNamePlaceholder": "Nome do item…",
    "addItem": "Adicionar item",
    "removeItem": "Remover item",
    "reorderItem": "Reordenar item",
    "formCreateTitle": "Novo modelo de checklist",
    "formEditTitle": "Editar modelo de checklist",
    "notFound": "Este modelo não existe mais ou você não tem acesso.",
    "drawerNoDescription": "Sem descrição.",
    "drawerDetailTitle": "Detalhe do modelo de checklist",
    "loadError": "Não foi possível carregar os modelos.",
    "saveSuccess": "Modelo salvo.",
    "deleteSuccess": "Modelo removido.",
    "deleteConfirmTitle": "Remover este modelo?",
    "deleteConfirmDescription": "Esta ação não pode ser desfeita. Não é possível excluir um modelo que está em uso.",
    "deleteConfirmAction": "Remover",
    "deleteInUse": "Este modelo está em uso e não pode ser excluído.",
    "nameTaken": "Já existe um modelo com este nome.",
    "forbidden": "Você não tem permissão para alterar modelos.",
    "actionsMenu": "Ações",
    "emptyTitle": "Nenhum modelo de checklist",
    "emptyDescription": "Ainda não há modelos de checklist configurados para esta organização.",
    "searchPlaceholder": "Buscar por nome ou descrição…",
    "clearSearch": "Limpar busca",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "noSearchResults": "Nenhum modelo corresponde à busca.",
    "noFilterResults": "Nenhum modelo corresponde aos filtros selecionados.",
    "loadMoreError": "Não foi possível carregar mais modelos.",
    "loadMoreRetry": "Tentar novamente"
  },
  "workers": {
    "new": "Novo colaborador",
    "edit": "Editar",
    "delete": "Excluir",
    "save": "Salvar",
    "cancel": "Cancelar",
    "createdAt": "Criado em",
    "colName": "Nome",
    "colLinkedUser": "Usuário vinculado",
    "colCode": "Código",
    "colRole": "Cargo",
    "colEmploymentLink": "Vínculo",
    "colBirthDate": "Data de nascimento",
    "colProjectServiceFronts": "Frentes de serviço",
    "colStatus": "Status",
    "statusActive": "Ativo",
    "statusInactive": "Inativo",
    "nameLabel": "Nome",
    "codeLabel": "Código",
    "codeNotFound": "Nenhum colaborador com este código.",
    "roleLabel": "Cargo",
    "rolePlaceholder": "Selecione um cargo…",
    "employmentLinkLabel": "Vínculo",
    "employmentLinkOwned": "Próprio",
    "employmentLinkOutsourced": "Terceirizado",
    "employmentLinkOutsourcedWithPartner": "Terceirizado · {{name}}",
    "serviceProviderLabel": "Prestador",
    "serviceProviderPlaceholder": "Selecione um prestador…",
    "birthDateLabel": "Data de nascimento",
    "birthDatePlaceholder": "DD/MM/AAAA",
    "birthDateOpenCalendar": "Abrir calendário",
    "birthDateFuture": "A data de nascimento não pode ser no futuro.",
    "birthDateMinAge": "O colaborador deve ter pelo menos 16 anos.",
    "phoneLabel": "Telefone",
    "linkedUserLabel": "Usuário vinculado",
    "linkedUserHint": "Opcional. Liga este colaborador a alguém que entra no sistema.",
    "linkedUserPlaceholder": "Selecione um usuário…",
    "linkedUserLinked": "Vinculado",
    "projectServiceFrontsLabel": "Frentes de serviço",
    "projectServiceFrontsPlaceholder": "Selecione as frentes de serviço…",
    "projectServiceFrontsSearch": "Buscar frentes de serviço…",
    "projectServiceFrontsEmpty": "Nenhuma frente de serviço encontrada.",
    "projectServiceFrontsRemove": "Remover {{name}}",
    "projectServiceFrontsOverflow": "Mais {{count}} frentes de serviço",
    "projectServiceFrontsRequired": "Selecione ao menos uma frente de serviço.",
    "formCreateTitle": "Novo colaborador",
    "addButtonLabel": "Adicionar colaborador",
    "emptyCatalog": "Nenhum colaborador cadastrado.",
    "formEditTitle": "Editar colaborador",
    "reviewPreviousPrefix": "Anterior:",
    "backToList": "Voltar para colaboradores",
    "notFound": "Este colaborador não existe mais ou você não tem acesso.",
    "drawerDetailTitle": "Detalhe do colaborador",
    "detailGeneralSection": "Geral",
    "detailPersonalSection": "Dados pessoais",
    "addressesSection": "Endereço",
    "addressesEmpty": "Nenhum endereço cadastrado.",
    "loadError": "Não foi possível carregar os colaboradores.",
    "saveSuccess": "Colaborador salvo.",
    "deleteSuccess": "Colaborador removido.",
    "deleteConfirmTitle": "Excluir este colaborador?",
    "deleteConfirmDescription": "Esta ação não pode ser desfeita. Não é possível excluir um colaborador usado em atividades do diário.",
    "deleteConfirmAction": "Excluir",
    "deleteInUse": "Este colaborador está em uso em atividades e não pode ser excluído.",
    "invalidProjectServiceFronts": "Uma ou mais frentes de serviço selecionadas são inválidas.",
    "forbidden": "Você não tem permissão para alterar colaboradores.",
    "actionsMenu": "Ações",
    "emptyTitle": "Nenhum colaborador",
    "emptyDescription": "Adicione a equipe que aparece no diário.",
    "searchPlaceholder": "Buscar por nome…",
    "clearSearch": "Limpar busca",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "noSearchResults": "Nenhum colaborador corresponde à sua busca.",
    "noFilterResults": "Nenhum colaborador corresponde aos filtros selecionados.",
    "loadMoreError": "Não foi possível carregar mais colaboradores.",
    "loadMoreRetry": "Tentar novamente",
    "filter": {
      "projectServiceFront": "Frentes de serviço",
      "projectServiceFrontWithCount": "Frentes de serviço, {{count}} selecionadas",
      "projectServiceFrontSearch": "Buscar frentes de serviço…",
      "projectServiceFrontEmpty": "Nenhuma frente de serviço encontrada.",
      "projectServiceFrontLoadError": "Não foi possível carregar as frentes de serviço."
    },
    "filterProjectServiceFront": "Frentes de serviço",
    "filterProjectServiceFrontWithCount": "Frentes de serviço, {{count}} selecionadas",
    "filterProjectServiceFrontClear": "Remover filtro {{name}}",
    "filterProjectServiceFrontDialogTitle": "Filtrar por frente de serviço",
    "filterProjectServiceFrontDialogDescription": "Selecione uma ou mais frentes de serviço. A seleção é mantida enquanto você busca.",
    "filterProjectServiceFrontSearch": "Buscar frentes de serviço…",
    "filterProjectServiceFrontSelected": "Selecionadas",
    "filterProjectServiceFrontResults": "Resultados",
    "filterProjectServiceFrontEmpty": "Nenhuma frente de serviço encontrada.",
    "filterProjectServiceFrontLoadError": "Não foi possível carregar as frentes de serviço.",
    "filterApply": "Mostrar resultados",
    "filterReset": "Limpar",
    "filterCancel": "Cancelar"
  },
  "occurrences": {
    "new": "Nova ocorrência",
    "edit": "Editar",
    "delete": "Excluir",
    "save": "Salvar",
    "cancel": "Cancelar",
    "createdAt": "Criada em",
    "colName": "Nome",
    "colDescription": "Descrição",
    "colColor": "Cor",
    "colStatus": "Status",
    "statusActive": "Ativa",
    "statusInactive": "Inativa",
    "nameLabel": "Nome",
    "descriptionLabel": "Descrição",
    "colorLabel": "Cor",
    "colorPlaceholder": "#1A56DB",
    "colorInvalid": "Informe uma cor hexadecimal válida (ex.: #1A56DB).",
    "formCreateTitle": "Nova ocorrência",
    "formEditTitle": "Editar ocorrência",
    "formReviewTitle": "Revisar e enviar",
    "stepDetails": "Dados da ocorrência",
    "stepReview": "Revisar e enviar",
    "reviewSummaryTitle": "Resumo",
    "reviewPreviousLine": "Anterior: {{value}}",
    "backToList": "Voltar para ocorrências",
    "notFound": "Esta ocorrência não existe mais ou você não tem acesso.",
    "drawerDetailTitle": "Detalhe da ocorrência",
    "drawerNoDescription": "Sem descrição",
    "loadError": "Não foi possível carregar as ocorrências.",
    "saveSuccess": "Ocorrência salva.",
    "deleteSuccess": "Ocorrência removida.",
    "deleteConfirmTitle": "Remover esta ocorrência?",
    "deleteConfirmDescription": "Esta ação não pode ser desfeita. Não é possível excluir uma ocorrência em uso.",
    "deleteConfirmAction": "Remover",
    "deleteInUse": "Esta ocorrência está em uso e não pode ser excluída.",
    "forbidden": "Você não tem permissão para alterar ocorrências.",
    "actionsMenu": "Ações",
    "emptyTitle": "Nenhuma ocorrência",
    "emptyDescription": "Ainda não há ocorrências configuradas para esta organização.",
    "searchPlaceholder": "Buscar por nome…",
    "clearSearch": "Limpar busca",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "noSearchResults": "Nenhuma ocorrência corresponde à busca.",
    "noFilterResults": "Nenhuma ocorrência corresponde aos filtros selecionados.",
    "loadMoreError": "Não foi possível carregar mais ocorrências.",
    "loadMoreRetry": "Tentar novamente"
  },
  "documentCategories": {
    "new": "Nova categoria",
    "edit": "Editar",
    "delete": "Excluir",
    "save": "Salvar",
    "cancel": "Cancelar",
    "createdAt": "Criada em",
    "colName": "Nome",
    "colDescription": "Descrição",
    "colColor": "Cor",
    "colStatus": "Status",
    "statusActive": "Ativa",
    "statusInactive": "Inativa",
    "nameLabel": "Nome",
    "descriptionLabel": "Descrição",
    "colorLabel": "Cor",
    "colorPlaceholder": "#1A56DB",
    "colorInvalid": "Informe uma cor hexadecimal válida (ex.: #1A56DB).",
    "formCreateTitle": "Nova categoria de documento",
    "formEditTitle": "Editar categoria de documento",
    "formReviewTitle": "Revisar e enviar",
    "stepDetails": "Dados da categoria",
    "stepReview": "Revisar e enviar",
    "reviewSummaryTitle": "Resumo",
    "reviewPreviousLine": "Anterior: {{value}}",
    "backToList": "Voltar às categorias",
    "notFound": "Esta categoria não existe mais ou você não tem acesso.",
    "drawerDetailTitle": "Detalhe da categoria de documento",
    "drawerNoDescription": "Sem descrição",
    "loadError": "Não foi possível carregar as categorias.",
    "saveSuccess": "Categoria salva.",
    "deleteSuccess": "Categoria removida.",
    "deleteConfirmTitle": "Remover esta categoria?",
    "deleteConfirmDescription": "Esta ação não pode ser desfeita. Não é possível excluir uma categoria em uso.",
    "deleteConfirmAction": "Remover",
    "deleteInUse": "Esta categoria está em uso e não pode ser excluída.",
    "forbidden": "Você não tem permissão para alterar categorias de documentos.",
    "actionsMenu": "Ações",
    "emptyTitle": "Nenhuma categoria",
    "emptyDescription": "Ainda não há categorias de documentos configuradas para esta organização.",
    "searchPlaceholder": "Buscar por nome…",
    "clearSearch": "Limpar busca",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "noSearchResults": "Nenhuma categoria corresponde à busca.",
    "noFilterResults": "Nenhuma categoria corresponde aos filtros selecionados.",
    "loadMoreError": "Não foi possível carregar mais categorias.",
    "loadMoreRetry": "Tentar novamente"
  },
  "projectDocuments": {
    "new": "Novo documento",
    "edit": "Editar",
    "delete": "Excluir",
    "save": "Salvar",
    "saveVersion": "Enviar versão",
    "cancel": "Cancelar",
    "formSections": {
      "identification": "Identificação"
    },
    "colCode": "Código",
    "codeLabel": "Código",
    "colName": "Documento",
    "colCategory": "Categoria",
    "colCurrentVersion": "Versão atual",
    "colUpdatedAt": "Atualizado",
    "nameLabel": "Nome",
    "categoryLabel": "Categoria",
    "categoryPlaceholder": "Selecione uma categoria",
    "descriptionLabel": "Descrição",
    "changeDescriptionLabel": "Observação da revisão",
    "versionDateLabel": "Data",
    "versionAuthorLabel": "Enviado por",
    "fileLabel": "Arquivo",
    "fileSizeLabel": "Tamanho",
    "versionLabel": "Versão",
    "actionsLabel": "Ações",
    "actionsMenu": "Ações",
    "previewAction": "Pré-visualizar",
    "viewAction": "Visualizar",
    "downloadAction": "Download",
    "newVersion": "Nova versão",
    "formCreateTitle": "Novo documento",
    "formEditTitle": "Editar documento",
    "formReviewTitle": "Revisar e enviar",
    "formStepDetails": "Dados do documento",
    "stepReview": "Revisar e enviar",
    "reviewSummaryTitle": "Resumo",
    "newVersionTitle": "Nova versão — {{name}}",
    "newVersionStep": "Enviar arquivo",
    "backToList": "Voltar aos documentos",
    "drawerDetailTitle": "Detalhe do documento",
    "generalSection": "Informações",
    "currentVersionSection": "Versão atual",
    "historySection": "Histórico de versões",
    "unknownUser": "Usuário desconhecido",
    "loadError": "Não foi possível carregar os documentos.",
    "notFound": "Documento não encontrado.",
    "saveError": "Não foi possível salvar o documento.",
    "deleteError": "Não foi possível excluir o documento.",
    "saveSuccess": "Documento salvo.",
    "versionSaveSuccess": "Nova versão enviada.",
    "deleteSuccess": "Documento removido.",
    "deleteConfirmTitle": "Remover este documento?",
    "deleteConfirmDescription": "Isso remove o documento e todas as versões. Esta ação não pode ser desfeita.",
    "deleteConfirmAction": "Remover",
    "fileRequired": "Selecione um arquivo.",
    "fileInvalid": "Tipo de arquivo não suportado.",
    "emptyTitle": "Nenhum documento",
    "emptyDescription": "Envie documentos do projeto com histórico de versões.",
    "searchPlaceholder": "Buscar documentos…",
    "clearSearch": "Limpar busca",
    "filterCategory": "Categoria",
    "filterCategorySearch": "Buscar categorias…",
    "filterCategoryEmpty": "Nenhuma categoria encontrada.",
    "clearFilters": "Limpar filtros",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "noFilterResults": "Nenhum documento corresponde aos filtros selecionados.",
    "loadMoreError": "Não foi possível carregar mais documentos.",
    "loadMoreRetry": "Tentar novamente"
  },
  "projectBudgets": {
    "new": "Novo planejamento",
    "edit": "Editar",
    "delete": "Excluir",
    "save": "Salvar",
    "saveVersion": "Criar versão",
    "cancel": "Cancelar",
    "colName": "Planejamento",
    "colNumber": "Número",
    "colType": "Tipo",
    "colVersion": "Versão",
    "colStatus": "Status",
    "colTotalValue": "Total",
    "colBudgetDate": "Data do planejamento",
    "colServiceFront": "Frente de serviço",
    "selectCostLine": "Selecionar linha de custo",
    "nameLabel": "Nome",
    "descriptionLabel": "Descrição",
    "numberLabel": "Número",
    "typeLabel": "Tipo",
    "typePlaceholder": "Selecione um tipo",
    "versionLabel": "Versão",
    "statusLabel": "Status",
    "statusPlaceholder": "Selecione um status",
    "budgetDateLabel": "Data do planejamento",
    "notesLabel": "Observações",
    "totalValueLabel": "Valor total",
    "updatedAtLabel": "Atualizado em",
    "plannedValueLabel": "Valor planejado",
    "lineNotesLabel": "Observações",
    "serviceFrontLabel": "Frente de serviço",
    "serviceFrontPlaceholder": "Selecione uma frente de serviço",
    "serviceFrontLineTitle": "Frente de serviço {{index}}",
    "serviceFrontsSection": "Frentes de serviço",
    "serviceFrontsRequired": "Adicione pelo menos uma frente de serviço.",
    "serviceFrontsDuplicate": "Cada frente de serviço só pode ser selecionada uma vez.",
    "itemsSection": "Linhas de custo",
    "itemsSectionDescription": "Planeje o custo desta frente. Isso não gera uma compra.",
    "itemsRequired": "Adicione pelo menos uma linha de custo.",
    "itemLineTitle": "Linha {{index}}",
    "itemNameLabel": "Descrição",
    "itemNameDescription": "O que esta frente deve custar. Isso não gera uma compra.",
    "itemQuantityLabel": "Quantidade",
    "itemUnitLabel": "Unidade",
    "itemUnitPriceLabel": "Preço unitário",
    "itemPlannedValueLabel": "Valor planejado",
    "itemCatalogSection": "Catálogo",
    "itemCatalogDescription": "Opcional. Liga ao catálogo para preencher a solicitação depois. Não adiciona estoque e não compra.",
    "itemCatalogKindLabel": "Tipo",
    "itemCatalogKindPlaceholder": "Selecione o tipo",
    "itemCatalogKindMaterial": "Material",
    "itemCatalogKindEquipment": "Equipamento",
    "itemCatalogKindOther": "Outros",
    "itemMaterialLabel": "Material",
    "itemEquipmentLabel": "Equipamento",
    "itemCatalogExclusive": "Vincule um material ou um equipamento, não os dois.",
    "addItem": "Adicionar linha",
    "addItemSave": "Adicionar",
    "editItem": "Editar linha",
    "removeItem": "Remover linha",
    "deleteItemConfirmTitle": "Remover esta linha?",
    "deleteItemConfirmDescription": "Ela será removida deste planejamento.",
    "deleteItemConfirmAction": "Remover",
    "addServiceFront": "Adicionar frente de serviço",
    "editServiceFront": "Editar frente de serviço",
    "addShort": "Adicionar",
    "composerContinue": "Continuar",
    "composerBack": "Voltar",
    "composerStepFront": "Frente de serviço",
    "composerStepLines": "Linhas de custo",
    "composerStepProgress": "{{current}} / {{total}} — {{label}}",
    "composerSelectedFront": "Frente selecionada",
    "composerLinesHint": "Cada linha é um custo planejado nesta frente — não uma compra.",
    "addLineTitle": "Adicionar linha de frente de serviço",
    "addLineAction": "Adicionar frente de serviço",
    "formDraftSection": "Frentes de serviço neste planejamento",
    "formDraftEmpty": "Nenhuma frente de serviço adicionada ainda.",
    "formDraftItemsSection": "Linhas neste planejamento",
    "formDraftItemsEmpty": "Nenhuma linha de custo adicionada ainda.",
    "itemsCount": "{{count}} linha(s) de custo",
    "remove": "Remover",
    "lineDone": "Concluir",
    "removeServiceFront": "Remover frente de serviço",
    "liveTotal": "Total: {{value}}",
    "documentsLabel": "Documentos",
    "documentsPlaceholder": "Selecione documentos",
    "documentsSection": "Documentos",
    "documentsCount": "{{count}} documento(s)",
    "documentsEmpty": "Nenhum documento vinculado ainda.",
    "manageDocuments": "Gerenciar documentos",
    "manageDocumentsTitle": "Gerenciar documentos",
    "manageDocumentsSave": "Salvar",
    "manageDocumentsSuccess": "Documentos atualizados.",
    "manageDocumentsSelected": "{{count}} selecionado(s)",
    "manageDocumentsPreviewEmpty": "Selecione um documento para pré-visualizar.",
    "manageDocumentsListEmpty": "Nenhum documento encontrado.",
    "manageDocumentsLoadMore": "Carregar mais",
    "manageDocumentsUnavailable": "Nenhum documento da obra disponível.",
    "serviceFrontsCount": "{{count}} frente(s) de serviço",
    "actionsMenu": "Ações",
    "newVersion": "Nova versão",
    "formCreateTitle": "Novo planejamento de custos",
    "formEditTitle": "Editar planejamento de custos",
    "formReviewTitle": "Revisar e enviar",
    "formStepDetails": "Dados do planejamento",
    "formSections": {
      "identification": "Identificação",
      "items": "Linhas de custo"
    },
    "formStepServiceFronts": "Linhas de custo",
    "formStepServiceFrontsDescription": "Adicione os custos planejados desta frente. Isso não gera uma compra.",
    "stepReview": "Revisar e enviar",
    "reviewSummaryTitle": "Resumo",
    "newVersionTitle": "Nova versão — {{name}}",
    "drawerDetailTitle": "Detalhe do planejamento",
    "loadError": "Não foi possível carregar o planejamento de custos.",
    "notFound": "Planejamento não encontrado.",
    "saveError": "Não foi possível salvar o planejamento.",
    "deleteError": "Não foi possível excluir o planejamento.",
    "saveSuccess": "Planejamento salvo.",
    "versionSaveSuccess": "Nova versão do planejamento criada.",
    "deleteSuccess": "Planejamento removido.",
    "deleteConfirmTitle": "Remover este planejamento?",
    "deleteConfirmDescription": "Isso remove o planejamento permanentemente. Esta ação não pode ser desfeita.",
    "deleteConfirmAction": "Remover",
    "deleteInUse": "Este planejamento tem contas a pagar vinculadas e não pode ser excluído.",
    "approve": "Aprovar",
    "approveSuccess": "Planejamento aprovado.",
    "sendForReview": "Enviar para análise",
    "sendForReviewSuccess": "Planejamento enviado para análise.",
    "reject": "Reprovar",
    "rejectSuccess": "Planejamento reprovado.",
    "cancelBudget": "Cancelar",
    "cancelBudgetSuccess": "Planejamento cancelado.",
    "emptyTitle": "Nenhum planejamento de custos",
    "emptyDescription": "O caminho usual é aprovar um orçamento do cliente e depois detalhar os custos por frente. Você ainda pode criar um planejamento sem orçamento.",
    "commercialRevenueSection": "Receita do orçamento do cliente",
    "plannedRevenueLabel": "Receita prevista",
    "plannedCostLabel": "Custo previsto",
    "plannedMarginLabel": "Margem prevista",
    "discountLabel": "Desconto",
    "finalValueLabel": "Valor final",
    "createPurchaseRequest": "Criar solicitação de compra",
    "createPurchaseRequestHint": "Gera uma solicitação só das linhas planejadas selecionadas. Material que não está no planejamento: Nova solicitação.",
    "createPurchaseRequestNeedItems": "Selecione pelo menos uma linha.",
    "createPurchaseRequestSameFront": "Selecione linhas da mesma frente de serviço.",
    "currentEmpty": "Nenhum planejamento de custos atual ainda.",
    "viewAll": "Ver planejamento de custos",
    "searchPlaceholder": "Buscar planejamentos…",
    "clearSearch": "Limpar busca",
    "filter": {
      "date": "Data",
      "type": "Tipo",
      "typeSearch": "Buscar tipos…",
      "typeEmpty": "Nenhum tipo encontrado.",
      "status": "Status",
      "statusSearch": "Buscar status…",
      "statusEmpty": "Nenhum status encontrado."
    },
    "dateFromLabel": "De",
    "dateToLabel": "Até",
    "clearFilters": "Limpar filtros",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "noFilterResults": "Nenhum planejamento corresponde aos filtros selecionados.",
    "loadMoreError": "Não foi possível carregar mais planejamentos.",
    "loadMoreRetry": "Tentar novamente",
    "type": {
      "initial": "Inicial",
      "revision": "Revisão",
      "additive": "Aditivo"
    },
    "status": {
      "in_elaboration": "Em elaboração",
      "under_review": "Em análise",
      "approved": "Aprovado",
      "rejected": "Rejeitado",
      "cancelled": "Cancelado"
    }
  },
  "projectClientBudgets": {
    "new": "Novo orçamento",
    "edit": "Editar",
    "delete": "Excluir",
    "save": "Salvar",
    "saveVersion": "Criar versão",
    "cancel": "Cancelar",
    "colNumber": "Número",
    "colType": "Tipo",
    "colVersion": "Versão",
    "colStatus": "Status",
    "colFinalValue": "Valor final",
    "colBudgetDate": "Data",
    "headerSection": "Dados do orçamento",
    "clientProjectSection": "Cliente e obra",
    "valuesSection": "Valores",
    "clientLabel": "Cliente",
    "numberLabel": "Número",
    "numberHint": "Gerado automaticamente. Você pode alterar se quiser.",
    "typeLabel": "Tipo",
    "typePlaceholder": "Selecione um tipo",
    "versionLabel": "Versão",
    "statusLabel": "Status",
    "statusPlaceholder": "Selecione um status",
    "budgetDateLabel": "Data do orçamento",
    "validUntilLabel": "Validade",
    "notesLabel": "Observações",
    "itemsSection": "Itens vendidos",
    "itemsSectionDescription": "O que foi vendido ao cliente, por frente de serviço.",
    "itemsRequired": "Adicione pelo menos um item.",
    "itemLineTitle": "Item {{index}}",
    "itemNameLabel": "Descrição",
    "itemDescriptionLabel": "Detalhes",
    "itemAmountLabel": "Valor",
    "serviceFrontLabel": "Frente de serviço",
    "serviceFrontPlaceholder": "Selecione uma frente de serviço",
    "addItem": "Adicionar item",
    "addItemSave": "Adicionar",
    "editItem": "Editar item",
    "removeItem": "Remover item",
    "emptyItemsHint": "Nenhum item adicionado.",
    "itemsTableTitle": "Itens neste orçamento",
    "colServiceFront": "Frente de serviço",
    "colItemName": "Descrição",
    "colItemAmount": "Valor",
    "commercialSection": "Condições comerciais",
    "commercialSectionDescription": "Parcelas e prazo são condições do contrato. Aprovar o orçamento não lança contas a receber.",
    "discountLabel": "Desconto",
    "discountHint": "O desconto fica no total. A receita por frente usa o valor dos itens.",
    "discountExceedsTotal": "O desconto não pode ser maior que o total dos itens.",
    "paymentMethodLabel": "Forma de pagamento",
    "paymentMethodPlaceholder": "Selecione uma forma de pagamento",
    "installmentCountLabel": "Número de parcelas",
    "executionDeadlineDaysLabel": "Prazo de execução (dias)",
    "executionDeadlineDaysValue_one": "{{count}} dia",
    "executionDeadlineDaysValue_other": "{{count}} dias",
    "commercialNotesLabel": "Observações comerciais",
    "totalValueLabel": "Total",
    "finalValueLabel": "Valor final",
    "updatedAtLabel": "Atualizado em",
    "liveTotal": "Total: {{value}}",
    "liveDiscount": "Desconto: {{value}}",
    "liveFinal": "Valor final: {{value}}",
    "actionsMenu": "Ações",
    "newVersion": "Nova versão",
    "formCreateTitle": "Novo orçamento do cliente",
    "formEditTitle": "Editar orçamento do cliente",
    "newVersionTitle": "Nova versão — {{number}}",
    "drawerDetailTitle": "Detalhe do orçamento do cliente",
    "loadError": "Não foi possível carregar o orçamento do cliente.",
    "notFound": "Orçamento do cliente não encontrado.",
    "saveError": "Não foi possível salvar o orçamento do cliente.",
    "deleteError": "Não foi possível excluir o orçamento do cliente.",
    "saveSuccess": "Orçamento do cliente salvo.",
    "versionSaveSuccess": "Nova versão do orçamento criada.",
    "deleteSuccess": "Orçamento do cliente removido.",
    "deleteConfirmTitle": "Remover este orçamento?",
    "deleteConfirmDescription": "Isso remove o orçamento permanentemente. Esta ação não pode ser desfeita.",
    "deleteConfirmAction": "Remover",
    "deleteInUse": "Este orçamento tem contas a receber vinculadas e não pode ser excluído.",
    "emptyTitle": "Nenhum orçamento do cliente",
    "emptyDescription": "Defina o que foi vendido e por quanto. Depois de aprovado, o planejamento de custos usa este valor como receita.",
    "orgEmptyTitle": "Nenhum orçamento",
    "orgEmptyDescription": "Crie um orçamento para um cliente. Depois, ao abrir a obra, você pode informar o número deste orçamento.",
    "colClient": "Cliente",
    "colProject": "Obra",
    "projectLabel": "Obra",
    "projectPlaceholder": "Selecione a obra",
    "quoteScopeLabel": "Vínculo",
    "quoteScopeUnattached": "Sem obra",
    "quoteScopeAttached": "Com obra",
    "proposedNameLabel": "Nome da obra",
    "proposedAddressLabel": "Endereço da obra",
    "serviceFrontModelLabel": "Modelo de frentes",
    "serviceFrontModelPlaceholder": "Opcional. Se escolher, os itens seguem as etapas do modelo.",
    "serviceFrontModelStepLabel": "Etapa do modelo",
    "serviceFrontModelStepPlaceholder": "Selecione uma etapa",
    "itemsSectionDescriptionCommercial": "O que foi vendido ao cliente. Sem modelo, cada item é uma linha comercial.",
    "itemsSectionDescriptionModel": "O que foi vendido ao cliente, por etapa do modelo de frentes.",
    "approve": "Aprovar",
    "approveSuccess": "Orçamento aprovado.",
    "sendForReview": "Enviar para análise",
    "sendForReviewSuccess": "Orçamento enviado para análise.",
    "reject": "Reprovar",
    "rejectSuccess": "Orçamento reprovado.",
    "cancelBudget": "Cancelar",
    "cancelBudgetSuccess": "Orçamento cancelado.",
    "noProjectYet": "Ainda sem obra",
    "searchPlaceholder": "Buscar orçamentos…",
    "clearSearch": "Limpar busca",
    "filter": {
      "date": "Data",
      "type": "Tipo",
      "typeSearch": "Buscar tipos…",
      "typeEmpty": "Nenhum tipo encontrado.",
      "status": "Status",
      "statusSearch": "Buscar status…",
      "statusEmpty": "Nenhum status encontrado."
    },
    "dateFromLabel": "De",
    "dateToLabel": "Até",
    "clearFilters": "Limpar filtros",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "noFilterResults": "Nenhum orçamento corresponde aos filtros selecionados.",
    "loadMoreError": "Não foi possível carregar mais orçamentos.",
    "loadMoreRetry": "Tentar novamente"
  },
  "purchaseRequests": {
    "new": "Nova solicitação",
    "edit": "Editar",
    "save": "Salvar",
    "submit": "Enviar para aprovação",
    "approve": "Aprovar",
    "cancel": "Cancelar",
    "createQuotation": "Gerar cotação",
    "colNumber": "Número",
    "colNeededAt": "Necessário em",
    "colServiceFront": "Frente",
    "colPriority": "Prioridade",
    "colStatus": "Status",
    "requestedAtLabel": "Data da solicitação",
    "neededAtLabel": "Necessário em",
    "serviceFrontLabel": "Frente de serviço",
    "serviceFrontPlaceholder": "Selecione uma frente de serviço",
    "priorityLabel": "Prioridade",
    "priorityPlaceholder": "Selecione uma prioridade",
    "notesLabel": "Observações",
    "itemsSection": "Itens",
    "expandItems": "Ocultar detalhes",
    "collapseItems": "Mostrar detalhes",
    "itemNameLabel": "Descrição",
    "itemNameDescription": "Produto ou serviço que a obra precisa comprar.",
    "itemQuantityLabel": "Quantidade",
    "itemUnitLabel": "Unidade",
    "itemUnitPlaceholder": "Selecione uma unidade",
    "itemCatalogKindLabel": "Tipo",
    "itemCatalogKindPlaceholder": "Selecione o tipo",
    "itemCatalogKindMaterial": "Material",
    "itemCatalogKindEquipment": "Equipamento",
    "itemCatalogKindOther": "Outros",
    "itemMaterialLabel": "Material",
    "itemMaterialPlaceholder": "Selecione um material",
    "itemMaterialDescription": "Vincule um material do catálogo, se já estiver cadastrado.",
    "itemEquipmentLabel": "Equipamento",
    "itemEquipmentPlaceholder": "Selecione um equipamento",
    "addItem": "Adicionar item",
    "addItemSave": "Adicionar",
    "editItem": "Editar item",
    "removeItem": "Remover item",
    "emptyItemsHint": "Nenhum item adicionado.",
    "deleteItemConfirmTitle": "Remover este item?",
    "deleteItemConfirmDescription": "Ele será removido desta solicitação.",
    "deleteItemConfirmAction": "Remover",
    "itemsRequired": "Inclua pelo menos um item.",
    "stepDetails": "Dados da solicitação",
    "formSections": {
      "identification": "Identificação",
      "items": "Itens"
    },
    "stepReview": "Revisar e enviar",
    "formCreateTitle": "Nova solicitação de compra",
    "formEditTitle": "Editar solicitação de compra",
    "formReviewTitle": "Revisar e enviar",
    "detailTitle": "Solicitação de compra",
    "backToList": "Voltar às solicitações",
    "loadError": "Não foi possível carregar as solicitações de compra.",
    "saveError": "Não foi possível salvar a solicitação de compra.",
    "saveSuccess": "Solicitação de compra salva.",
    "submitSuccess": "Solicitação enviada para aprovação.",
    "approveSuccess": "Solicitação aprovada.",
    "cancelSuccess": "Solicitação cancelada.",
    "quotationCreated": "Solicitação enviada para cotação.",
    "notFound": "Esta solicitação não existe mais ou você não tem acesso.",
    "editDraftOnly": "Só é possível editar solicitações em rascunho.",
    "cancelConfirmTitle": "Cancelar esta solicitação?",
    "cancelConfirmDescription": "A solicitação será cancelada. Cotações em andamento desta solicitação também serão canceladas.",
    "cancelConfirmAction": "Cancelar solicitação",
    "actionsMenu": "Ações",
    "emptyTitle": "Nenhuma solicitação de compra",
    "emptyDescription": "Peça o que a obra precisa comprar. Depois você cotará com fornecedores.",
    "emptyFilteredTitle": "Nenhuma solicitação encontrada",
    "emptyFilteredDescription": "Nenhuma solicitação corresponde à busca.",
    "searchPlaceholder": "Buscar solicitações…",
    "clearSearch": "Limpar busca",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados"
  },
  "projectQuotations": {
    "colNumber": "Número",
    "colName": "Cotação",
    "colDate": "Data",
    "colDeadline": "Prazo de resposta",
    "colStatus": "Status",
    "actionsMenu": "Ações",
    "nameLabel": "Nome",
    "dateLabel": "Data da cotação",
    "deadlineLabel": "Prazo de resposta",
    "notesLabel": "Observações",
    "requestLabel": "Solicitação",
    "openRequest": "Abrir solicitação",
    "fromRequest": "Cotação da",
    "detailTitle": "Cotação",
    "formSections": {
      "identification": "Identificação"
    },
    "backToList": "Voltar às cotações",
    "compareTitle": "Comparar fornecedores",
    "expandCompare": "Ocultar detalhes",
    "collapseCompare": "Mostrar detalhes",
    "supplierCol": "Fornecedor",
    "actionsCol": "Ações",
    "addSupplier": "Adicionar fornecedor",
    "partnerLabel": "Fornecedor",
    "partnerPlaceholder": "Buscar fornecedor",
    "newPartnerLabel": "Ou informe o nome de um novo fornecedor",
    "supplierAdded": "Fornecedor adicionado.",
    "removeSupplier": "Remover",
    "removeSupplierConfirmTitle": "Remover este fornecedor?",
    "removeSupplierConfirmDescription": "Os preços deste fornecedor serão apagados desta cotação. Esta ação não pode ser desfeita.",
    "removeSupplierConfirmAction": "Remover",
    "supplierRemoved": "Fornecedor removido.",
    "pricesPending": "Alterações não salvas…",
    "pricesSaving": "Salvando…",
    "pricesSaved": "Todas as alterações salvas",
    "pricesSaveFailedShort": "Falha ao salvar — tentaremos de novo",
    "selectSupplier": "Escolher",
    "selected": "Escolhido",
    "unselectSupplier": "Desfazer escolha",
    "supplierSelected": "Fornecedor escolhido.",
    "supplierUnselected": "Escolha desfeita.",
    "approve": "Aprovar",
    "approveSuccess": "Cotação aprovada.",
    "createPurchaseOrder": "Gerar pedido de compra",
    "poCreated": "Pedido de compra gerado.",
    "openPurchaseOrder": "Pedido {{number}}",
    "cancel": "Cancelar",
    "cancelConfirmTitle": "Cancelar esta cotação?",
    "cancelConfirmDescription": "A cotação será cancelada e não poderá gerar pedido de compra.",
    "cancelConfirmAction": "Cancelar cotação",
    "cancelSuccess": "Cotação cancelada.",
    "noSuppliers": "Adicione fornecedores para comparar preços. O mais barato não é escolhido automaticamente.",
    "unitPriceLabel": "Preço unitário",
    "freightLabel": "Frete",
    "leadTimeLabel": "Prazo de entrega (dias)",
    "leadTimeCol": "Entrega",
    "paymentTermLabel": "Prazo de pagamento (dias)",
    "paymentTermCol": "Pagto.",
    "daysUnit": "dias",
    "totalLabel": "Total",
    "loadError": "Não foi possível carregar as cotações.",
    "notFound": "Esta cotação não existe mais ou você não tem acesso.",
    "emptyTitle": "Nenhuma cotação",
    "emptyDescription": "Gere uma cotação a partir de uma solicitação de compra aprovada.",
    "emptyFilteredTitle": "Nenhuma cotação encontrada",
    "emptyFilteredDescription": "Nenhuma cotação corresponde à busca.",
    "searchPlaceholder": "Buscar cotações…",
    "clearSearch": "Limpar busca",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados"
  },
  "purchaseOrders": {
    "colNumber": "Número",
    "colPartner": "Fornecedor",
    "colTotal": "Total",
    "colStatus": "Status",
    "colReceived": "Estoque",
    "notReceived": "Não atualizado",
    "freightLabel": "Frete",
    "quotationLabel": "Cotação",
    "openQuotation": "Abrir cotação",
    "notesLabel": "Observações",
    "formSections": {
      "identification": "Identificação"
    },
    "itemsSection": "Itens",
    "expandItems": "Ocultar detalhes",
    "collapseItems": "Mostrar detalhes",
    "colItemName": "Item",
    "itemQuantityLabel": "Quantidade",
    "itemUnitPriceLabel": "Preço unitário",
    "colLineTotal": "Valor",
    "itemMaterialLabel": "Material",
    "noMaterial": "Sem material do catálogo",
    "detailTitle": "Pedido de compra",
    "backToList": "Voltar aos pedidos",
    "generatePayable": "Gerar conta a pagar",
    "payableCreated": "Conta a pagar gerada.",
    "payableAmountHint": "O valor será {{amount}} (total do pedido, com frete).",
    "openPayable": "Abrir conta a pagar",
    "updateStock": "Atualizar estoque",
    "updateStockHint": "Isso adiciona as quantidades ao estoque da obra. O estoque da organização não é alterado.",
    "pickMaterial": "Escolher material",
    "stockUpdated": "Estoque da obra atualizado.",
    "cancel": "Cancelar",
    "cancelConfirmTitle": "Cancelar este pedido de compra?",
    "cancelConfirmDescription": "O pedido será cancelado. Se precisar, você pode gerar um novo pedido a partir da cotação.",
    "cancelConfirmAction": "Cancelar pedido",
    "cancelSuccess": "Pedido de compra cancelado.",
    "loadError": "Não foi possível carregar os pedidos de compra.",
    "notFound": "Este pedido não existe mais ou você não tem acesso.",
    "emptyTitle": "Nenhum pedido de compra",
    "emptyDescription": "Gere um pedido a partir de uma cotação aprovada.",
    "emptyFilteredTitle": "Nenhum pedido encontrado",
    "emptyFilteredDescription": "Nenhum pedido corresponde à busca.",
    "searchPlaceholder": "Buscar pedidos…",
    "clearSearch": "Limpar busca",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados"
  },
  "projectTracking": {
    "loadError": "Não foi possível carregar a visão geral.",
    "alertsTitle": "Alertas",
    "alertsEmpty": "Nenhum alerta aberto.",
    "openServiceFronts": "Abrir frentes de serviço",
    "expandView": "Expandir",
    "collapseView": "Sair da visão expandida",
    "tabs": {
      "schedule": "Cronograma",
      "fronts": "Frentes",
      "timeline": "Linha do tempo",
      "indicators": "Indicadores"
    },
    "modeTitles": {
      "schedule": "Cronograma da obra",
      "fronts": "Situação das frentes",
      "timeline": "Atividades recentes",
      "indicators": "Indicadores da obra"
    },
    "summary": {
      "needsAttention": "Obra requer atenção",
      "onTrack": "Obra em dia",
      "lastUpdate": "Última atualização",
      "completed": "Concluída",
      "openAlerts": "Alertas abertos",
      "frontsProgress": "{{completed}} de {{total}}",
      "frontsCompleted": "Frentes concluídas"
    },
    "schedule": {
      "onTrack": "No prazo",
      "overdue": "Atrasada",
      "noDueDate": "Sem prazo",
      "daysProgress": "{{elapsed}} / {{planned}} dias",
      "daysElapsed": "{{count}} dias"
    },
    "alertMessages": {
      "projectOverdue": "Obra atrasada {{days}} dias",
      "frontOverdue": "{{name}} atrasada {{days}} dias",
      "frontOverdueGroup": "{{count}} frentes de serviço atrasadas",
      "frontOverdueDays": "{{days}} dias de atraso",
      "viewAll": "Ver todas",
      "collapse": "Recolher",
      "diaryMissing": "Diário não preenchido ontem",
      "diaryStale": "Sem diário há {{days}}+ dias"
    },
    "scheduleColumns": {
      "name": "Frente",
      "start": "Início",
      "end": "Fim",
      "duration": "Dias"
    },
    "scheduleEmpty": "Nenhuma data de cronograma nas frentes de serviço.",
    "frontsEmpty": "Nenhuma frente de serviço ainda.",
    "frontsNoWorkers": "Sem responsáveis",
    "frontsUpdated": "Atualizado",
    "timelineEmpty": "Nenhuma atividade recente.",
    "timelineDiary": "Diário por {{name}}",
    "timelineOccurrence": "Ocorrência: {{name}}",
    "timelineMaterial": "Material: {{name}}",
    "indicators": {
      "occurrencesByMonth": "Ocorrências por mês",
      "diaryEntriesByMonth": "Diários da obra por mês",
      "openOccurrencesBySeverity": "Ocorrências abertas por severidade",
      "topConsumedMaterials": "Consumo de materiais",
      "count": "Quantidade",
      "consumedQuantity": "Quantidade consumida",
      "equipmentAllocation": "Alocação de equipamentos",
      "photosByMonth": "Linha do tempo de fotos",
      "serviceFrontsByStatus": "Frentes planejadas versus concluídas",
      "frontProgress": "Progresso por frente",
      "progress": "Progresso",
      "total": "Total",
      "scheduleTitle": "Prazo",
      "elapsedDays": "Dias decorridos",
      "plannedDays": "Dias planejados",
      "overdueFronts": "Frentes atrasadas",
      "measurementTitle": "Medição",
      "plannedQuantity": "Quantidade planejada",
      "quantityAdvanced": "Quantidade medida",
      "measuredValue": "Valor medido",
      "diaryComplianceTitle": "Diário (30 dias)",
      "publishedDays": "Dias com diário",
      "expectedWorkdays": "Dias úteis",
      "purchasingTitle": "Compras",
      "openRequests": "Solicitações abertas",
      "awaitingQuotes": "Cotações aguardando",
      "openOrders": "Pedidos em aberto",
      "stockTitle": "Estoque",
      "belowMinimum": "Abaixo do mínimo",
      "cashTitle": "Caixa da obra",
      "payables": "A pagar",
      "receivables": "A receber",
      "cashOpen": "Em aberto",
      "cashOverdue": "Vencido",
      "severity": {
        "critical": "Crítica",
        "high": "Alta",
        "medium": "Média",
        "low": "Baixa"
      },
      "equipmentStatus": {
        "allocated": "Alocados",
        "available": "Disponíveis",
        "maintenance": "Em manutenção"
      },
      "frontStatus": {
        "completed": "Concluídas",
        "in_progress": "Em andamento",
        "not_started": "Não iniciadas"
      }
    },
    "indicatorsEmpty": "Ainda não há dados suficientes."
  },
  "projectPhotos": {
    "addPhoto": "Adicionar foto",
    "atCapHint": "Limite de fotos gerais do álbum atingido ({{used}}/{{limit}}). Fotos do diário não contam neste limite.",
    "edit": "Editar",
    "delete": "Excluir",
    "drawerTitle": "Detalhe da foto",
    "detailsTitle": "Detalhe",
    "infoTitle": "Informações",
    "captionLabel": "Legenda",
    "dateLabel": "Data",
    "dateFromLabel": "De",
    "dateToLabel": "Até",
    "uploaderLabel": "Enviada por",
    "originSection": "Origem",
    "originTypeLabel": "Tipo",
    "serviceFrontLabel": "Frente de serviço",
    "occurrenceLabel": "Ocorrência",
    "diaryEntryLabel": "Diário de obra",
    "openDiaryEntry": "Abrir diário de obra",
    "tagsSection": "Etiquetas",
    "tagsLabel": "Etiquetas",
    "tagsPlaceholder": "Buscar etiquetas",
    "noTagsAvailable": "Nenhuma etiqueta disponível.",
    "unknownUser": "Usuário desconhecido",
    "origin": {
      "general": "Foto geral da obra",
      "serviceFront": "Frente de serviço",
      "occurrence": "Ocorrência"
    },
    "uploadTitle": "Adicionar foto",
    "uploadHint": "Escolha uma imagem ou tire uma foto.",
    "dropHint": "Solte a imagem para enviar.",
    "chooseFile": "Escolher arquivo",
    "takePhoto": "Tirar foto",
    "uploadAction": "Enviar",
    "uploadSuccess": "Foto adicionada.",
    "invalidFile": "Tipo de arquivo não suportado.",
    "saveSuccess": "Foto atualizada.",
    "deleteSuccess": "Foto removida.",
    "deleteConfirmTitle": "Remover esta foto?",
    "deleteConfirmDescription": "Esta ação não pode ser desfeita.",
    "emptyTitle": "Nenhuma foto",
    "emptyDescription": "Adicione fotos gerais da obra ou registre fotos no diário.",
    "loadError": "Não foi possível carregar as fotos.",
    "noFilterResults": "Nenhuma foto corresponde aos filtros selecionados.",
    "loadMoreError": "Não foi possível carregar mais fotos.",
    "loadMoreRetry": "Tentar novamente",
    "saveError": "Não foi possível salvar a foto.",
    "deleteError": "Não foi possível excluir a foto.",
    "filter": {
      "date": "Data",
      "origin": "Origem",
      "originEmpty": "Nenhuma origem encontrada.",
      "tags": "Etiquetas",
      "tagsSearch": "Buscar etiquetas…",
      "tagsEmpty": "Nenhuma etiqueta encontrada.",
      "creators": "Enviada por",
      "creatorsSearch": "Buscar pessoas…",
      "creatorsEmpty": "Nenhuma pessoa encontrada."
    }
  },
  "photoTags": {
    "title": "Etiquetas de fotos",
    "new": "Nova etiqueta",
    "edit": "Editar",
    "delete": "Excluir",
    "save": "Salvar",
    "cancel": "Cancelar",
    "nameLabel": "Nome",
    "colorLabel": "Cor",
    "colorPlaceholder": "#1D4ED8",
    "colorInvalid": "Informe uma cor válida (ex.: #1D4ED8).",
    "formCreateTitle": "Nova etiqueta",
    "formEditTitle": "Editar etiqueta",
    "formReviewTitle": "Revisar e enviar",
    "stepDetails": "Dados da etiqueta",
    "stepReview": "Revisar e enviar",
    "reviewSummaryTitle": "Resumo",
    "statusActive": "Ativa",
    "statusInactive": "Inativa",
    "colName": "Nome",
    "colColor": "Cor",
    "colStatus": "Status",
    "typeLabel": "Tipo",
    "reservedBadge": "Reservada",
    "createdAt": "Criada em",
    "total": "{{count}} etiquetas",
    "actionsMenu": "Ações da etiqueta",
    "searchPlaceholder": "Buscar etiquetas",
    "clearSearch": "Limpar busca",
    "drawerDetailTitle": "Detalhe da etiqueta",
    "emptyTitle": "Nenhuma etiqueta",
    "emptyDescription": "Ainda não há etiquetas de fotos configuradas para esta organização.",
    "noFilterResults": "Nenhuma etiqueta encontrada para os filtros aplicados.",
    "noSearchResults": "Nenhuma etiqueta encontrada para a busca.",
    "loadError": "Não foi possível carregar as etiquetas.",
    "loadMoreError": "Não foi possível carregar mais etiquetas.",
    "loadMoreRetry": "Tentar novamente",
    "notFound": "Etiqueta não encontrada.",
    "saveSuccess": "Etiqueta salva.",
    "deleteSuccess": "Etiqueta removida.",
    "deleteConfirmTitle": "Remover esta etiqueta?",
    "deleteConfirmDescription": "A etiqueta será removida de todas as fotos. Esta ação não pode ser desfeita.",
    "deleteConfirmAction": "Remover"
  },
  "materialCategories": {
    "new": "Nova categoria",
    "edit": "Editar",
    "delete": "Excluir",
    "save": "Salvar",
    "cancel": "Cancelar",
    "colName": "Nome",
    "colDescription": "Descrição",
    "colStatus": "Status",
    "statusActive": "Ativa",
    "statusInactive": "Inativa",
    "nameLabel": "Nome",
    "descriptionLabel": "Descrição",
    "formCreateTitle": "Nova categoria",
    "formEditTitle": "Editar categoria",
    "formReviewTitle": "Revisar e enviar",
    "stepDetails": "Dados da categoria",
    "stepReview": "Revisar e enviar",
    "reviewSummaryTitle": "Resumo",
    "reviewPreviousLine": "Anterior: {{value}}",
    "drawerDetailTitle": "Detalhe da categoria",
    "drawerNoDescription": "Sem descrição",
    "loadError": "Não foi possível carregar as categorias.",
    "saveSuccess": "Categoria salva.",
    "deleteSuccess": "Categoria removida.",
    "deleteConfirmTitle": "Remover esta categoria?",
    "deleteConfirmDescription": "Esta ação não pode ser desfeita.",
    "deleteConfirmAction": "Remover",
    "actionsMenu": "Ações",
    "emptyTitle": "Nenhuma categoria",
    "emptyCatalog": "Nenhuma categoria cadastrada.",
    "emptyDescription": "Ainda não há categorias de materiais configuradas para esta organização.",
    "searchPlaceholder": "Buscar por nome…",
    "clearSearch": "Limpar busca",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "noSearchResults": "Nenhuma categoria corresponde à busca.",
    "noFilterResults": "Nenhuma categoria corresponde aos filtros selecionados.",
    "loadMoreError": "Não foi possível carregar mais categorias.",
    "loadMoreRetry": "Tentar novamente",
    "notFound": "Esta categoria não existe mais ou você não tem acesso.",
    "createdAt": "Criada em"
  },
  "materials": {
    "new": "Novo material",
    "edit": "Editar",
    "delete": "Excluir",
    "save": "Salvar",
    "cancel": "Cancelar",
    "colCode": "Código",
    "colName": "Nome",
    "colCategory": "Categoria",
    "colUnit": "Unidade",
    "colBrand": "Marca",
    "colManufacturer": "Fabricante",
    "colStatus": "Status",
    "statusActive": "Ativo",
    "statusInactive": "Inativo",
    "nameLabel": "Nome",
    "codeLabel": "Código",
    "codeHint": "Gerado automaticamente. Você pode alterar se quiser.",
    "descriptionLabel": "Descrição",
    "barcodeLabel": "Código de barras",
    "barcodeHint": "Opcional. Deve ser único na organização.",
    "barcodeInvalid": "Informe de 8 a 64 caracteres (letras, números, - ou _).",
    "brandLabel": "Marca",
    "manufacturerLabel": "Fabricante",
    "modelLabel": "Modelo",
    "minimumStockLabel": "Estoque mínimo",
    "currentStockLabel": "Estoque atual",
    "colCurrentStock": "Estoque atual",
    "colMinimumStock": "Estoque mínimo",
    "categoryLabel": "Categoria",
    "unitLabel": "Unidade de medida",
    "categoryPlaceholder": "Selecione uma categoria",
    "unitPlaceholder": "Selecione uma unidade",
    "noneOption": "Nenhuma",
    "formCreateTitle": "Novo material",
    "formEditTitle": "Editar material",
    "formReviewTitle": "Revisar e enviar",
    "stepDetails": "Dados do material",
    "stepReview": "Revisar e enviar",
    "reviewSummaryTitle": "Resumo",
    "drawerDetailTitle": "Detalhe do material",
    "drawerNoDescription": "Sem descrição",
    "drawerNoCategory": "Sem categoria",
    "drawerNoUnit": "Sem unidade",
    "drawerNoValue": "—",
    "loadError": "Não foi possível carregar os materiais.",
    "saveSuccess": "Material salvo.",
    "deleteSuccess": "Material removido.",
    "deleteConfirmTitle": "Remover este material?",
    "deleteConfirmDescription": "Esta ação não pode ser desfeita.",
    "deleteConfirmAction": "Remover",
    "actionsMenu": "Ações",
    "actionsStockSection": "Estoque",
    "viewMovements": "Ver movimentações",
    "emptyTitle": "Nenhum material",
    "emptyDescription": "Ainda não há materiais configurados para esta organização.",
    "searchPlaceholder": "Buscar por nome, código, marca…",
    "clearSearch": "Limpar busca",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "noSearchResults": "Nenhum material corresponde à busca.",
    "noFilterResults": "Nenhum material corresponde aos filtros selecionados.",
    "loadMoreError": "Não foi possível carregar mais materiais.",
    "loadMoreRetry": "Tentar novamente",
    "codeNotFound": "Nenhum material com este código.",
    "notFound": "Este material não existe mais ou você não tem acesso.",
    "createdAt": "Criado em",
    "filterCategory": "Categoria",
    "filterCategorySearch": "Buscar categorias…",
    "filterCategoryEmpty": "Nenhuma categoria encontrada.",
    "filterBrand": "Marca",
    "filterBrandSearch": "Buscar marcas…",
    "filterBrandEmpty": "Nenhuma marca encontrada.",
    "filterManufacturer": "Fabricante",
    "filterManufacturerSearch": "Buscar fabricantes…",
    "filterManufacturerEmpty": "Nenhum fabricante encontrado.",
    "stockAdd": "Adicionar",
    "stockRemove": "Remover",
    "stockAdjustAddTitle": "Adicionar estoque",
    "stockAdjustRemoveTitle": "Remover estoque",
    "stockAdjustQuantityLabel": "Quantidade",
    "stockAdjustConfirmAdd": "Adicionar estoque",
    "stockAdjustConfirmRemove": "Remover estoque",
    "stockAdjustSuccess": "Estoque atualizado.",
    "stockInsufficient": "Não é possível remover mais do que o estoque atual.",
    "tabs": {
      "list": "Lista",
      "movements": "Movimentações de estoque"
    }
  },
  "materialStockMovements": {
    "pageTitle": "Movimentações de estoque",
    "colDate": "Data",
    "colMaterial": "Material",
    "colCategory": "Categoria",
    "colQuantity": "Quantidade",
    "colSource": "Tipo",
    "colOrigin": "Descrição",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "loadError": "Não foi possível carregar as movimentações.",
    "loadMoreError": "Não foi possível carregar mais movimentações.",
    "loadMoreRetry": "Tentar novamente",
    "emptyTitle": "Nenhuma movimentação",
    "emptyDescription": "Alterações de estoque aparecerão aqui.",
    "emptyFilteredTitle": "Nenhuma movimentação corresponde aos filtros",
    "emptyFilteredDescription": "Tente ajustar o período ou os filtros.",
    "drawerTitle": "Movimentações de estoque",
    "formSections": {
      "identification": "Identificação"
    },
    "recentSection": "Movimentações recentes",
    "searchPlaceholder": "Buscar por nome ou código",
    "clearSearch": "Limpar busca",
    "dateFromLabel": "De",
    "dateToLabel": "Até",
    "timeFromLabel": "Horário inicial",
    "timeToLabel": "Horário final",
    "filter": {
      "date": "Data",
      "material": "Material",
      "materialSearch": "Buscar materiais",
      "materialEmpty": "Nenhum material encontrado",
      "category": "Categoria",
      "categorySearch": "Buscar categorias",
      "categoryEmpty": "Nenhuma categoria encontrada",
      "type": "Tipo",
      "typeSearch": "Buscar tipos",
      "typeEmpty": "Nenhum tipo encontrado"
    },
    "source": {
      "opening_balance": "Saldo inicial",
      "purchase": "Compra",
      "transfer_in": "Entrada",
      "transfer_out": "Saída",
      "consumption": "Consumo",
      "adjustment": "Ajuste",
      "return": "Devolução",
      "manual": "Manual"
    }
  },
  "workerRoles": {
    "new": "Novo cargo",
    "edit": "Editar",
    "delete": "Excluir",
    "save": "Salvar",
    "cancel": "Cancelar",
    "colName": "Nome",
    "colDescription": "Descrição",
    "colStatus": "Status",
    "statusActive": "Ativo",
    "statusInactive": "Inativo",
    "nameLabel": "Nome",
    "descriptionLabel": "Descrição",
    "formCreateTitle": "Novo cargo",
    "formEditTitle": "Editar cargo",
    "drawerDetailTitle": "Detalhe do cargo",
    "drawerNoDescription": "Sem descrição",
    "loadError": "Não foi possível carregar os cargos.",
    "saveSuccess": "Cargo salvo.",
    "deleteSuccess": "Cargo removido.",
    "deleteConfirmTitle": "Remover este cargo?",
    "deleteConfirmDescription": "Não é possível excluir um cargo atribuído a colaboradores.",
    "deleteConfirmAction": "Remover",
    "deleteInUse": "Este cargo está em uso e não pode ser excluído.",
    "actionsMenu": "Ações",
    "emptyTitle": "Nenhum cargo",
    "emptyCatalog": "Nenhum cargo cadastrado.",
    "emptyDescription": "Adicione os cargos da equipe.",
    "searchPlaceholder": "Buscar por nome…",
    "clearSearch": "Limpar busca",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "noSearchResults": "Nenhum cargo corresponde à busca.",
    "noFilterResults": "Nenhum cargo corresponde aos filtros selecionados.",
    "loadMoreError": "Não foi possível carregar mais cargos.",
    "loadMoreRetry": "Tentar novamente",
    "notFound": "Este cargo não existe mais ou você não tem acesso.",
    "createdAt": "Criado em"
  },
  "weatherConditions": {
    "new": "Nova condição",
    "edit": "Editar",
    "delete": "Excluir",
    "save": "Salvar",
    "cancel": "Cancelar",
    "colName": "Nome",
    "colDescription": "Descrição",
    "colStatus": "Status",
    "statusActive": "Ativo",
    "statusInactive": "Inativo",
    "nameLabel": "Nome",
    "descriptionLabel": "Descrição",
    "formCreateTitle": "Nova condição climática",
    "formEditTitle": "Editar condição climática",
    "formReviewTitle": "Revisar e enviar",
    "stepDetails": "Dados da condição",
    "stepReview": "Revisar e enviar",
    "reviewSummaryTitle": "Resumo",
    "reviewPreviousLine": "Anterior: {{value}}",
    "drawerDetailTitle": "Detalhe da condição climática",
    "drawerNoDescription": "Sem descrição",
    "loadError": "Não foi possível carregar as condições climáticas.",
    "saveSuccess": "Condição climática salva.",
    "deleteSuccess": "Condição climática removida.",
    "deleteConfirmTitle": "Remover esta condição climática?",
    "deleteConfirmDescription": "Não é possível excluir uma condição usada em registros do diário.",
    "deleteConfirmAction": "Remover",
    "deleteInUse": "Esta condição está em uso e não pode ser excluída.",
    "actionsMenu": "Ações",
    "emptyTitle": "Nenhuma condição climática",
    "emptyDescription": "Ainda não há condições climáticas configuradas para esta organização.",
    "searchPlaceholder": "Buscar por nome…",
    "clearSearch": "Limpar busca",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "noSearchResults": "Nenhuma condição corresponde à busca.",
    "noFilterResults": "Nenhuma condição corresponde aos filtros selecionados.",
    "loadMoreError": "Não foi possível carregar mais condições.",
    "loadMoreRetry": "Tentar novamente",
    "notFound": "Esta condição não existe mais ou você não tem acesso.",
    "createdAt": "Criado em"
  },
  "projectPriorities": {
    "new": "Nova prioridade",
    "edit": "Editar",
    "delete": "Excluir",
    "save": "Salvar",
    "cancel": "Cancelar",
    "colName": "Nome",
    "colDescription": "Descrição",
    "colColor": "Cor",
    "colStatus": "Status",
    "statusActive": "Ativo",
    "statusInactive": "Inativo",
    "nameLabel": "Nome",
    "descriptionLabel": "Descrição",
    "colorLabel": "Cor",
    "colorPlaceholder": "#2563EB",
    "formCreateTitle": "Nova prioridade de obra",
    "formEditTitle": "Editar prioridade de obra",
    "formReviewTitle": "Revisar e enviar",
    "stepDetails": "Dados da prioridade",
    "stepReview": "Revisar e enviar",
    "reviewSummaryTitle": "Resumo",
    "reviewPreviousLine": "Anterior: {{value}}",
    "drawerDetailTitle": "Detalhe da prioridade de obra",
    "drawerNoDescription": "Sem descrição",
    "loadError": "Não foi possível carregar as prioridades de obra.",
    "saveSuccess": "Prioridade de obra salva.",
    "deleteSuccess": "Prioridade de obra removida.",
    "deleteConfirmTitle": "Remover esta prioridade de obra?",
    "deleteConfirmDescription": "Não é possível excluir uma prioridade usada em obras.",
    "deleteConfirmAction": "Remover",
    "deleteInUse": "Esta prioridade está em uso e não pode ser excluída.",
    "actionsMenu": "Ações",
    "emptyTitle": "Nenhuma prioridade de obra",
    "emptyDescription": "Ainda não há prioridades de obra configuradas para esta organização.",
    "searchPlaceholder": "Buscar por nome…",
    "clearSearch": "Limpar busca",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "noSearchResults": "Nenhuma prioridade corresponde à busca.",
    "noFilterResults": "Nenhuma prioridade corresponde aos filtros selecionados.",
    "loadMoreError": "Não foi possível carregar mais prioridades.",
    "loadMoreRetry": "Tentar novamente",
    "notFound": "Esta prioridade não existe mais ou você não tem acesso.",
    "createdAt": "Criado em"
  },
  "projectTypes": {
    "new": "Novo tipo",
    "edit": "Editar",
    "delete": "Excluir",
    "save": "Salvar",
    "cancel": "Cancelar",
    "colName": "Nome",
    "colDescription": "Descrição",
    "colDefaultModel": "Modelo padrão",
    "colStatus": "Status",
    "statusActive": "Ativo",
    "statusInactive": "Inativo",
    "nameLabel": "Nome",
    "descriptionLabel": "Descrição",
    "defaultModelLabel": "Modelo padrão de frentes",
    "defaultModelPlaceholder": "Selecione um modelo…",
    "noDefaultModel": "Sem modelo padrão",
    "drawerNoDefaultModel": "Nenhum",
    "formCreateTitle": "Novo tipo de obra",
    "formEditTitle": "Editar tipo de obra",
    "formReviewTitle": "Revisar e enviar",
    "stepDetails": "Dados do tipo",
    "stepReview": "Revisar e enviar",
    "reviewSummaryTitle": "Resumo",
    "reviewPreviousLine": "Anterior: {{value}}",
    "drawerDetailTitle": "Detalhe do tipo de obra",
    "drawerNoDescription": "Sem descrição",
    "loadError": "Não foi possível carregar os tipos de obra.",
    "saveSuccess": "Tipo de obra salvo.",
    "deleteSuccess": "Tipo de obra removido.",
    "deleteConfirmTitle": "Remover este tipo de obra?",
    "deleteConfirmDescription": "Tipos usados por obras não podem ser excluídos.",
    "deleteConfirmAction": "Remover",
    "deleteInUse": "Este tipo está em uso e não pode ser excluído.",
    "actionsMenu": "Ações",
    "emptyTitle": "Nenhum tipo de obra",
    "emptyDescription": "Ainda não há tipos de obra configurados para esta organização.",
    "searchPlaceholder": "Buscar por nome…",
    "clearSearch": "Limpar busca",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "noSearchResults": "Nenhum tipo corresponde à busca.",
    "noFilterResults": "Nenhum tipo corresponde aos filtros selecionados.",
    "loadMoreError": "Não foi possível carregar mais tipos.",
    "loadMoreRetry": "Tentar novamente",
    "notFound": "Este tipo não existe mais ou você não tem acesso.",
    "createdAt": "Criado em"
  },
  "projectStatuses": {
    "edit": "Editar",
    "save": "Salvar",
    "colName": "Nome",
    "colKey": "Chave do sistema",
    "colDescription": "Descrição",
    "colColor": "Cor",
    "colStatus": "Status",
    "statusActive": "Ativo",
    "statusInactive": "Inativo",
    "nameLabel": "Nome",
    "keyLabel": "Chave do sistema",
    "descriptionLabel": "Descrição",
    "colorLabel": "Cor",
    "colorPlaceholder": "#2563EB",
    "formEditTitle": "Editar status de obra",
    "formReviewTitle": "Revisar e enviar",
    "stepDetails": "Dados do status",
    "stepReview": "Revisar e enviar",
    "reviewSummaryTitle": "Resumo",
    "reviewPreviousLine": "Anterior: {{value}}",
    "drawerDetailTitle": "Detalhe do status de obra",
    "drawerNoDescription": "Sem descrição",
    "loadError": "Não foi possível carregar os status de obra.",
    "emptyTitle": "Nenhum status de obra",
    "emptyDescription": "Ainda não há status de obra configurados para esta organização.",
    "saveSuccess": "Status de obra salvo.",
    "actionsMenu": "Ações",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "notFound": "Este status não existe mais ou você não tem acesso.",
    "createdAt": "Criado em"
  },
  "projectBudgetStatuses": {
    "edit": "Editar",
    "save": "Salvar",
    "colName": "Nome",
    "colKey": "Chave do sistema",
    "colDescription": "Descrição",
    "colColor": "Cor",
    "colStatus": "Status",
    "statusActive": "Ativo",
    "statusInactive": "Inativo",
    "nameLabel": "Nome",
    "keyLabel": "Chave do sistema",
    "descriptionLabel": "Descrição",
    "colorLabel": "Cor",
    "colorPlaceholder": "#2563EB",
    "formEditTitle": "Editar status de planejamento de custos",
    "formReviewTitle": "Revisar e enviar",
    "stepDetails": "Dados do status",
    "stepReview": "Revisar e enviar",
    "reviewSummaryTitle": "Resumo",
    "reviewPreviousLine": "Anterior: {{value}}",
    "drawerDetailTitle": "Detalhe do status de planejamento de custos",
    "drawerNoDescription": "Sem descrição",
    "loadError": "Não foi possível carregar os status de planejamento de custos.",
    "emptyTitle": "Nenhum status de planejamento de custos",
    "emptyDescription": "Ainda não há status de planejamento de custos configurados para esta organização.",
    "saveSuccess": "Status de planejamento de custos salvo.",
    "actionsMenu": "Ações",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "notFound": "Este status não existe mais ou você não tem acesso.",
    "createdAt": "Criado em"
  },
  "projectClientBudgetStatuses": {
    "edit": "Editar",
    "save": "Salvar",
    "colName": "Nome",
    "colKey": "Chave do sistema",
    "colDescription": "Descrição",
    "colColor": "Cor",
    "colStatus": "Status",
    "statusActive": "Ativo",
    "statusInactive": "Inativo",
    "nameLabel": "Nome",
    "keyLabel": "Chave do sistema",
    "descriptionLabel": "Descrição",
    "colorLabel": "Cor",
    "colorPlaceholder": "#2563EB",
    "formEditTitle": "Editar status de orçamento do cliente",
    "drawerDetailTitle": "Detalhe do status de orçamento do cliente",
    "loadError": "Não foi possível carregar os status de orçamento do cliente.",
    "emptyTitle": "Nenhum status de orçamento do cliente",
    "emptyDescription": "Ainda não há status de orçamento do cliente configurados para esta organização.",
    "saveSuccess": "Status de orçamento do cliente salvo.",
    "actionsMenu": "Ações",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "notFound": "Este status não existe mais ou você não tem acesso.",
    "createdAt": "Criado em"
  },
  "serviceFrontDeadlineStatuses": {
    "edit": "Editar",
    "save": "Salvar",
    "colName": "Nome",
    "colKey": "Chave do sistema",
    "colDescription": "Descrição",
    "colColor": "Cor",
    "colStatus": "Status",
    "statusActive": "Ativo",
    "statusInactive": "Inativo",
    "nameLabel": "Nome",
    "keyLabel": "Chave do sistema",
    "descriptionLabel": "Descrição",
    "colorLabel": "Cor",
    "colorPlaceholder": "#EAB308",
    "formEditTitle": "Editar status de prazo",
    "formReviewTitle": "Revisar e enviar",
    "stepDetails": "Dados do status",
    "stepReview": "Revisar e enviar",
    "reviewSummaryTitle": "Resumo",
    "reviewPreviousLine": "Anterior: {{value}}",
    "drawerDetailTitle": "Detalhe do status de prazo",
    "drawerNoDescription": "Sem descrição",
    "loadError": "Não foi possível carregar os status de prazo.",
    "emptyTitle": "Nenhum status de prazo",
    "emptyDescription": "Ainda não há status de prazo configurados para esta organização.",
    "saveSuccess": "Status de prazo salvo.",
    "actionsMenu": "Ações",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "notFound": "Este status não existe mais ou você não tem acesso.",
    "createdAt": "Criado em"
  },
  "measurementUnits": {
    "new": "Nova unidade",
    "edit": "Editar",
    "delete": "Excluir",
    "save": "Salvar",
    "cancel": "Cancelar",
    "colName": "Nome",
    "colSymbol": "Símbolo",
    "colStatus": "Status",
    "statusActive": "Ativa",
    "statusInactive": "Inativa",
    "nameLabel": "Nome",
    "symbolLabel": "Símbolo",
    "symbolPlaceholder": "kg",
    "formCreateTitle": "Nova unidade de medida",
    "formEditTitle": "Editar unidade de medida",
    "formReviewTitle": "Revisar e enviar",
    "stepDetails": "Dados da unidade",
    "stepReview": "Revisar e enviar",
    "reviewSummaryTitle": "Resumo",
    "reviewPreviousLine": "Anterior: {{value}}",
    "drawerDetailTitle": "Detalhe da unidade de medida",
    "loadError": "Não foi possível carregar as unidades de medida.",
    "saveSuccess": "Unidade de medida salva.",
    "deleteSuccess": "Unidade de medida removida.",
    "deleteConfirmTitle": "Remover esta unidade?",
    "deleteConfirmDescription": "Não é possível excluir uma unidade usada por materiais.",
    "deleteConfirmAction": "Remover",
    "deleteInUse": "Esta unidade está em uso e não pode ser excluída.",
    "actionsMenu": "Ações",
    "emptyTitle": "Nenhuma unidade de medida",
    "emptyCatalog": "Nenhuma unidade de medida cadastrada.",
    "emptyDescription": "Ainda não há unidades de medida configuradas para esta organização.",
    "searchPlaceholder": "Buscar por nome ou símbolo…",
    "clearSearch": "Limpar busca",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "noSearchResults": "Nenhuma unidade corresponde à busca.",
    "noFilterResults": "Nenhuma unidade corresponde aos filtros selecionados.",
    "loadMoreError": "Não foi possível carregar mais unidades.",
    "loadMoreRetry": "Tentar novamente",
    "notFound": "Esta unidade não existe mais ou você não tem acesso."
  },
  "partners": {
    "new": "Novo parceiro",
    "edit": "Editar",
    "delete": "Excluir",
    "save": "Salvar",
    "colName": "Nome",
    "colCode": "Código",
    "colPersonType": "Pessoa",
    "colDocument": "Documento",
    "colEmail": "E-mail",
    "colPhone": "Telefone",
    "colKind": "Tipo",
    "colStatus": "Status",
    "detailGeneralSection": "Geral",
    "nameLabel": "Nome",
    "codeLabel": "Código",
    "codeNotFound": "Nenhum parceiro encontrado com este código.",
    "codeTaken": "Já existe um parceiro com este código.",
    "nameLabelIndividual": "Nome completo",
    "nameLabelCompany": "Nome fantasia",
    "legalNameLabel": "Razão social",
    "legalNameRequired": "Informe a razão social.",
    "documentLabel": "Documento",
    "cpfLabel": "CPF",
    "cnpjLabel": "CNPJ",
    "cpfPlaceholder": "000.000.000-00",
    "cnpjPlaceholder": "00.000.000/0000-00",
    "cpfInvalid": "Informe um CPF válido.",
    "rgLabel": "RG",
    "stateRegistrationLabel": "Inscrição estadual",
    "municipalRegistrationLabel": "Inscrição municipal",
    "birthDateLabel": "Data de nascimento",
    "birthDatePlaceholder": "DD/MM/AAAA",
    "birthDateOpenCalendar": "Abrir calendário",
    "birthDateFuture": "A data de nascimento não pode ser no futuro.",
    "emailLabel": "E-mail",
    "emailInvalid": "Informe um e-mail válido.",
    "phoneLabel": "Telefone",
    "phonePlaceholder": "(00) 00000-0000",
    "phoneInvalid": "Informe um telefone válido.",
    "personTypeLabel": "Tipo",
    "personTypeIndividual": "Pessoa física",
    "personTypeCompany": "Pessoa jurídica",
    "filterPersonType": "Pessoa",
    "filterPersonTypeSearch": "Buscar tipo de pessoa…",
    "filterPersonTypeEmpty": "Nenhum tipo de pessoa encontrado.",
    "filterKind": "Tipo",
    "filterKindSearch": "Buscar tipo…",
    "filterKindEmpty": "Nenhum tipo encontrado.",
    "isFinalConsumerLabel": "Consumidor final para emissão de NFS-e",
    "isFinalConsumerDescription": "Indica se o parceiro é consumidor final na emissão de NFS-e.",
    "isFinalConsumerYes": "Sim",
    "isFinalConsumerNo": "Não",
    "formSections": {
      "type": "Tipo",
      "identification": "Identificação",
      "contact": "Contato",
      "details": "Detalhes"
    },
    "addressesSection": "Endereço",
    "addAddress": "Adicionar endereço",
    "removeAddress": "Remover endereço",
    "removeAddressConfirmTitle": "Remover este endereço?",
    "removeAddressConfirmDescription": "Isso remove o endereço deste parceiro. Esta ação não pode ser desfeita depois de salvar.",
    "removeAddressConfirmAction": "Remover",
    "addressesEmpty": "Nenhum endereço cadastrado.",
    "contactsEmpty": "Nenhum contato cadastrado.",
    "duplicateContact": "Este contato já foi adicionado.",
    "formContactCreateTitle": "Novo contato",
    "formContactEditTitle": "Editar contato",
    "removeContactConfirmTitle": "Remover este contato?",
    "removeContactConfirmDescription": "Isso remove o contato deste parceiro. Esta ação não pode ser desfeita depois de salvar.",
    "removeContactConfirmAction": "Remover",
    "duplicateAddress": "Este endereço já foi adicionado.",
    "formAddressCreateTitle": "Novo endereço",
    "formAddressEditTitle": "Editar endereço",
    "zipCodeLabel": "CEP",
    "zipCodePlaceholder": "00000-000",
    "zipCodeSearching": "Buscando endereço…",
    "zipInvalid": "Informe um CEP válido.",
    "streetLabel": "Endereço",
    "streetNumberLabel": "Número",
    "complementLabel": "Complemento",
    "neighborhoodLabel": "Bairro",
    "cityLabel": "Cidade",
    "stateLabel": "Estado",
    "statePlaceholder": "Selecione",
    "contactsSection": "Contatos",
    "addContact": "Adicionar contato",
    "removeContact": "Remover contato",
    "contactNameLabel": "Nome",
    "paymentMethodsSection": "Dados de pagamento",
    "addPaymentData": "Adicionar dados de pagamento",
    "removePaymentData": "Remover dados de pagamento",
    "paymentDataEmpty": "Nenhum dado de pagamento cadastrado.",
    "duplicatePaymentData": "Este dado de pagamento já foi adicionado.",
    "formPaymentDataCreateTitle": "Novos dados de pagamento",
    "formPaymentDataEditTitle": "Editar dados de pagamento",
    "removePaymentDataConfirmTitle": "Remover estes dados de pagamento?",
    "removePaymentDataConfirmDescription": "Isso remove os dados de pagamento deste parceiro. Esta ação não pode ser desfeita depois de salvar.",
    "removePaymentDataConfirmAction": "Remover",
    "paymentDataTypeLabel": "Tipo",
    "paymentDataTypePix": "Pix",
    "paymentDataTypeTed": "TED",
    "paymentDataTypeAch": "ACH",
    "paymentDataTypeCheck": "Cheque",
    "paymentDataTypeWire": "Wire",
    "paymentDataTypeMoney": "Dinheiro",
    "paymentDataTypeOther": "Outro",
    "paymentDataDescriptionLabel": "Descrição",
    "paymentDataDescriptionPlaceholder": "Ex: Pix do fornecedor, Conta Banco do Brasil",
    "paymentDataSelectPlaceholder": "Selecione",
    "paymentDataBankLabel": "Banco",
    "paymentDataAgencyLabel": "Agência",
    "paymentDataRoutingLabel": "Routing number",
    "paymentDataAgencyPlaceholder": "Ex: 1234",
    "paymentDataAccountLabel": "Conta",
    "paymentDataAccountPlaceholder": "Ex: 00123-4",
    "paymentDataPixKeyTypeLabel": "Tipo de chave PIX",
    "paymentDataPixKeyTypeCpf": "CPF",
    "paymentDataPixKeyTypeCnpj": "CNPJ",
    "paymentDataPixKeyTypeEmail": "Email",
    "paymentDataPixKeyTypePhone": "Telefone",
    "paymentDataPixKeyTypeEvp": "Chave aleatória",
    "paymentDataPixKeyLabel": "Chave PIX",
    "paymentDataPixKeyPlaceholder": "Digite",
    "paymentDataPixKeyInvalid": "Informe uma chave PIX válida.",
    "paymentDataNotesPlaceholder": "Digite",
    "paymentDataIsPrimary": "Definir como forma de pagamento principal",
    "paymentDataDetailsLabel": "Detalhes",
    "paymentDataPrimaryColumn": "Principal",
    "kindLabel": "Tipo",
    "notesLabel": "Observações",
    "isClient": "Cliente",
    "isSupplier": "Fornecedor",
    "isServiceProvider": "Prestador",
    "kindClient": "Cliente",
    "kindSupplier": "Fornecedor",
    "kindServiceProvider": "Prestador",
    "kindRequired": "Marque cliente, fornecedor, prestador ou uma combinação.",
    "statusActive": "Ativo",
    "statusInactive": "Inativo",
    "formCreateTitle": "Novo parceiro",
    "formEditTitle": "Editar parceiro",
    "formReviewTitle": "Revisar e enviar",
    "stepDetails": "Dados do parceiro",
    "stepReview": "Revisar e enviar",
    "reviewSummaryTitle": "Resumo",
    "drawerDetailTitle": "Detalhe do parceiro",
    "loadError": "Não foi possível carregar os parceiros.",
    "loadMoreError": "Não foi possível carregar mais parceiros.",
    "loadMoreRetry": "Tentar novamente",
    "saveSuccess": "Parceiro salvo.",
    "deleteSuccess": "Parceiro removido.",
    "deleteConfirmTitle": "Remover este parceiro?",
    "deleteConfirmDescription": "Isso remove o parceiro permanentemente. Esta ação não pode ser desfeita.",
    "deleteConfirmAction": "Remover",
    "deleteInUse": "Este parceiro está em uso e não pode ser excluído.",
    "nameTaken": "Já existe um parceiro com este nome.",
    "documentTaken": "Já existe um parceiro com este documento.",
    "actionsMenu": "Ações",
    "emptyTitle": "Nenhum parceiro",
    "emptyDescription": "Cadastre clientes, fornecedores e prestadores para usar nas obras e no financeiro.",
    "emptyFilteredTitle": "Nenhum parceiro encontrado",
    "emptyFilteredDescription": "Nenhum parceiro corresponde aos filtros selecionados.",
    "searchPlaceholder": "Buscar parceiros…",
    "clearSearch": "Limpar busca",
    "addButtonLabel": "Adicionar parceiro",
    "emptyCatalog": "Nenhum cliente cadastrado.",
    "emptyCatalogSupplier": "Nenhum fornecedor cadastrado.",
    "emptyCatalogServiceProvider": "Nenhum prestador cadastrado.",
    "codeNotFound": "Nenhum parceiro com este documento.",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "notFound": "Este parceiro não existe mais ou você não tem acesso."
  },
  "financialCategories": {
    "new": "Nova categoria",
    "edit": "Editar",
    "delete": "Excluir",
    "save": "Salvar",
    "colName": "Nome",
    "colKind": "Tipo",
    "colGroup": "Grupo",
    "colStatus": "Status",
    "nameLabel": "Nome",
    "kindLabel": "Tipo",
    "kindPlaceholder": "Selecione o tipo",
    "groupLabel": "Grupo do fluxo de caixa",
    "groupPlaceholder": "Selecione o grupo",
    "kind": {
      "payable": "Despesa",
      "receivable": "Receita"
    },
    "statusActive": "Ativa",
    "statusInactive": "Inativa",
    "formCreateTitle": "Nova categoria financeira",
    "formEditTitle": "Editar categoria financeira",
    "drawerDetailTitle": "Detalhe da categoria",
    "loadError": "Não foi possível carregar as categorias financeiras.",
    "saveSuccess": "Categoria financeira salva.",
    "deleteSuccess": "Categoria financeira removida.",
    "deleteConfirmTitle": "Remover esta categoria?",
    "deleteConfirmDescription": "Isso remove a categoria permanentemente. Esta ação não pode ser desfeita.",
    "deleteConfirmAction": "Remover",
    "deleteInUse": "Esta categoria está em uso e não pode ser excluída.",
    "nameTaken": "Já existe uma categoria financeira com este nome.",
    "actionsMenu": "Ações",
    "emptyTitle": "Nenhuma categoria financeira",
    "emptyDescription": "Crie categorias para classificar contas a pagar e a receber.",
    "emptyFilteredTitle": "Nenhuma categoria encontrada",
    "emptyFilteredDescription": "Nenhuma categoria corresponde aos filtros selecionados.",
    "searchPlaceholder": "Buscar categorias…",
    "clearSearch": "Limpar busca",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "notFound": "Esta categoria não existe mais ou você não tem acesso."
  },
  "paymentMethods": {
    "new": "Nova forma de pagamento",
    "edit": "Editar",
    "delete": "Excluir",
    "save": "Salvar",
    "colName": "Nome",
    "colStatus": "Status",
    "nameLabel": "Nome",
    "statusActive": "Ativa",
    "statusInactive": "Inativa",
    "formCreateTitle": "Nova forma de pagamento",
    "formEditTitle": "Editar forma de pagamento",
    "drawerDetailTitle": "Detalhe da forma de pagamento",
    "loadError": "Não foi possível carregar as formas de pagamento.",
    "saveSuccess": "Forma de pagamento salva.",
    "deleteSuccess": "Forma de pagamento removida.",
    "deleteConfirmTitle": "Remover esta forma de pagamento?",
    "deleteConfirmDescription": "Isso remove a forma de pagamento permanentemente. Esta ação não pode ser desfeita.",
    "deleteConfirmAction": "Remover",
    "deleteInUse": "Esta forma de pagamento está em uso e não pode ser excluída.",
    "nameTaken": "Já existe uma forma de pagamento com este nome.",
    "actionsMenu": "Ações",
    "emptyTitle": "Nenhuma forma de pagamento",
    "emptyDescription": "Cadastre as formas de pagamento usadas nas contas.",
    "emptyFilteredTitle": "Nenhuma forma de pagamento encontrada",
    "emptyFilteredDescription": "Nenhuma forma de pagamento corresponde aos filtros selecionados.",
    "searchPlaceholder": "Buscar formas de pagamento…",
    "clearSearch": "Limpar busca",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "notFound": "Esta forma de pagamento não existe mais ou você não tem acesso."
  },
  "finance": {
    "title": "Financeiro",
    "tabs": {
      "payables": "Contas a pagar",
      "receivables": "Contas a receber",
      "invoices": "Notas fiscais",
      "cashFlow": "Fluxo de caixa"
    },
    "status": {
      "open": "Em aberto",
      "paid": "Liquidado",
      "cancelled": "Cancelado",
      "overdue": "Vencido"
    }
  },
  "payables": {
    "new": "Nova conta a pagar",
    "edit": "Editar",
    "delete": "Excluir",
    "settle": "Baixar",
    "save": "Salvar",
    "drawerDetailTitle": "Detalhe da conta a pagar",
    "colCode": "Código",
    "codeLabel": "Código",
    "colDescription": "Descrição",
    "colProject": "Obra",
    "colPartner": "Fornecedor",
    "colAmount": "Valor",
    "colDueDate": "Vencimento",
    "colStatus": "Status",
    "projectLabel": "Obra",
    "partnerLabel": "Fornecedor",
    "budgetItemLabel": "Linha do planejamento",
    "budgetItemEmpty": "Nenhuma linha no planejamento de custos.",
    "categoryLabel": "Categoria",
    "categoryPlaceholder": "Selecione uma categoria",
    "paymentMethodLabel": "Forma de pagamento",
    "descriptionLabel": "Descrição",
    "amountLabel": "Valor",
    "dueDateLabel": "Vencimento",
    "statusLabel": "Status",
    "paidAtLabel": "Pago em",
    "documentNumberLabel": "Número do documento",
    "notesLabel": "Observações",
    "formCreateTitle": "Nova conta a pagar",
    "formEditTitle": "Editar conta a pagar",
    "formReviewTitle": "Revisar e enviar",
    "stepDetails": "Dados da conta",
    "formSections": {
      "identification": "Identificação",
      "values": "Valores"
    },
    "stepReview": "Revisar e enviar",
    "reviewSummaryTitle": "Resumo",
    "loadError": "Não foi possível carregar as contas a pagar.",
    "saveError": "Não foi possível salvar a conta a pagar.",
    "deleteError": "Não foi possível excluir a conta a pagar.",
    "saveSuccess": "Conta a pagar salva.",
    "deleteSuccess": "Conta a pagar removida.",
    "deleteConfirmTitle": "Remover esta conta a pagar?",
    "deleteConfirmDescription": "Isso remove a conta permanentemente. Esta ação não pode ser desfeita.",
    "deleteConfirmAction": "Remover",
    "settleConfirmTitle": "Baixar esta conta a pagar?",
    "settleConfirmDescription": "{{description}} — {{amount}}. Informe a data do pagamento.",
    "settleConfirmAction": "Baixar",
    "settleSuccess": "Conta a pagar baixada.",
    "actionsMenu": "Ações",
    "emptyTitle": "Nenhuma conta a pagar",
    "emptyDescription": "Lance contas a pagar da obra, com ou sem vínculo ao planejamento de custos.",
    "emptyFilteredTitle": "Nenhuma conta encontrada",
    "emptyFilteredDescription": "Nenhuma conta a pagar corresponde aos filtros.",
    "searchPlaceholder": "Buscar contas a pagar…",
    "clearSearch": "Limpar busca",
    "filterStatus": "Status",
    "filterStatusSearch": "Buscar status",
    "filterStatusEmpty": "Nenhum status encontrado.",
    "filterOverdue": "Vencidas",
    "filterOverdueSearch": "Buscar",
    "filterOverdueEmpty": "Nenhuma opção.",
    "filterDueDate": "Vencimento",
    "filterDueDateFrom": "De",
    "filterDueDateTo": "Até",
    "filterSettledAt": "Pago em",
    "filterSettledAtFrom": "De",
    "filterSettledAtTo": "Até",
    "filterCashFlowGroup": "Grupo do fluxo",
    "filterCashFlowGroupSearch": "Buscar grupo",
    "filterCashFlowGroupEmpty": "Nenhum grupo encontrado.",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "notFound": "Esta conta a pagar não existe mais ou você não tem acesso."
  },
  "receivables": {
    "new": "Nova conta a receber",
    "edit": "Editar",
    "delete": "Excluir",
    "settle": "Receber",
    "save": "Salvar",
    "drawerDetailTitle": "Detalhe da conta a receber",
    "colCode": "Código",
    "codeLabel": "Código",
    "colDescription": "Descrição",
    "colProject": "Obra",
    "colClient": "Cliente",
    "colAmount": "Valor",
    "colDueDate": "Vencimento",
    "colStatus": "Status",
    "colCharge": "Cobrança",
    "colNfse": "Nota",
    "badgeChargeGenerated": "Gerada",
    "badgeNfseGenerated": "Gerada",
    "projectLabel": "Obra",
    "clientLabel": "Cliente",
    "categoryLabel": "Categoria",
    "paymentMethodLabel": "Forma de pagamento",
    "descriptionLabel": "Descrição",
    "amountLabel": "Valor",
    "dueDateLabel": "Vencimento",
    "statusLabel": "Status",
    "receivedAtLabel": "Recebido em",
    "documentNumberLabel": "Número do documento",
    "notesLabel": "Observações",
    "formCreateTitle": "Nova conta a receber",
    "formEditTitle": "Editar conta a receber",
    "formReviewTitle": "Revisar e enviar",
    "stepDetails": "Dados da conta",
    "formSections": {
      "identification": "Identificação",
      "values": "Valores"
    },
    "stepReview": "Revisar e enviar",
    "reviewSummaryTitle": "Resumo",
    "loadError": "Não foi possível carregar as contas a receber.",
    "saveError": "Não foi possível salvar a conta a receber.",
    "deleteError": "Não foi possível excluir a conta a receber.",
    "saveSuccess": "Conta a receber salva.",
    "deleteSuccess": "Conta a receber removida.",
    "deleteConfirmTitle": "Remover esta conta a receber?",
    "deleteConfirmDescription": "Isso remove a conta permanentemente. Esta ação não pode ser desfeita.",
    "deleteConfirmAction": "Remover",
    "settleConfirmTitle": "Receber esta conta a receber?",
    "settleConfirmDescription": "{{description}} — {{amount}}. Informe a data do recebimento.",
    "settleConfirmAction": "Receber",
    "settleSuccess": "Conta a receber baixada.",
    "actionsMenu": "Ações",
    "emptyTitle": "Nenhuma conta a receber",
    "emptyDescription": "Lance contas a receber vinculadas ao cliente da obra.",
    "emptyFilteredTitle": "Nenhuma conta encontrada",
    "emptyFilteredDescription": "Nenhuma conta a receber corresponde aos filtros.",
    "searchPlaceholder": "Buscar contas a receber…",
    "clearSearch": "Limpar busca",
    "filterStatus": "Status",
    "filterStatusSearch": "Buscar status",
    "filterStatusEmpty": "Nenhum status encontrado.",
    "filterOverdue": "Vencidas",
    "filterOverdueSearch": "Buscar",
    "filterOverdueEmpty": "Nenhuma opção.",
    "filterDueDate": "Vencimento",
    "filterDueDateFrom": "De",
    "filterDueDateTo": "Até",
    "filterSettledAt": "Recebido em",
    "filterSettledAtFrom": "De",
    "filterSettledAtTo": "Até",
    "filterCashFlowGroup": "Grupo do fluxo",
    "filterCashFlowGroupSearch": "Buscar grupo",
    "filterCashFlowGroupEmpty": "Nenhum grupo encontrado.",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "notFound": "Esta conta a receber não existe mais ou você não tem acesso.",
    "generateCharge": "Gerar cobrança",
    "viewCharge": "Ver cobrança",
    "chargeCreateSuccess": "Cobrança gerada.",
    "chargeCreateError": "Não foi possível gerar a cobrança.",
    "chargeNeedsOnboard": "Ative as cobranças em Configurações da empresa antes de gerar PIX ou boleto.",
    "chargeNeedsBankAccount": "Cadastre a conta bancária em Organização antes de gerar boleto ou PIX.",
    "chargeChooseTitle": "Como cobrar?",
    "chargeChooseDescription": "O cliente paga com PIX ou boleto, processados pelo Asaas. O dinheiro entra na conta da sua empresa.",
    "chargeChooseDescriptionPagarme": "O cliente paga com PIX ou boleto pelo Pagar.me. A taxa do Pagar.me é descontada do valor pago. O líquido cai na conta da sua empresa. A KonstruLog não fica com comissão.",
    "chargePix": "PIX",
    "chargeBoleto": "Boleto",
    "chargeDrawerTitle": "Cobrança",
    "chargeProjectLine": "{{project}}",
    "chargeTypeLabel": "Tipo",
    "chargePixSection": "PIX",
    "chargePixQrAlt": "QR Code PIX",
    "chargeCopyPix": "Copiar código PIX",
    "chargePixCopied": "Código PIX copiado.",
    "chargeBoletoSection": "Boleto",
    "chargeOpenBoleto": "Abrir boleto",
    "chargeCopyLine": "Copiar linha digitável",
    "chargeLineCopied": "Linha digitável copiada.",
    "chargeSend": "Enviar cobrança",
    "chargeShareTitle": "Cobrança",
    "chargeShareCopied": "Dados da cobrança copiados.",
    "chargeCopyFailed": "Não foi possível copiar."
  },
  "cashFlow": {
    "fromLabel": "De",
    "toLabel": "Até",
    "apply": "Aplicar",
    "loadError": "Não foi possível carregar o fluxo de caixa.",
    "colGroup": "Grupo",
    "colPlanned": "Previsto",
    "colRealized": "Realizado",
    "totalsOut": "Saídas",
    "totalsIn": "Entradas",
    "groups": {
      "suppliers": "Fornecedores",
      "labor": "Mão de obra",
      "taxes": "Impostos",
      "services": "Serviços",
      "other": "Outros",
      "receipts": "Recebimentos",
      "other_receipts": "Outros recebimentos"
    }
  },
  "projectCosts": {
    "title": "Custos da obra",
    "recordAdvance": "Medição de serviço",
    "loadError": "Não foi possível carregar os custos da obra.",
    "overBudgetAlert": "O valor pago já ultrapassou o planejamento de custos atual desta obra.",
    "budgetedCost": "Planejado",
    "measuredCost": "Medido",
    "paidPayables": "Pago",
    "openPayables": "A pagar em aberto",
    "overduePayables": "A pagar vencido",
    "plannedRevenue": "Receita prevista",
    "receivedReceivables": "Recebido",
    "openReceivables": "A receber em aberto",
    "overdueReceivables": "A receber vencido",
    "budgetActualTitle": "Planejado × realizado",
    "measuredHint": "Medido é o serviço executado. Pago e a pagar só mudam quando você gera uma conta a pagar.",
    "budgetActualEmpty": "Não há planejamento de custos aprovado com linhas para comparar.",
    "colItem": "Item",
    "colPlanned": "Planejado",
    "colPaid": "Pago",
    "openPayablesLink": "Abrir contas a pagar",
    "openPayablesLinkAria": "Abrir contas a pagar de {{name}}",
    "colRemaining": "Saldo",
    "colMeasured": "Medido",
    "colQty": "Avanço físico",
    "qtyProgress": "{{advanced}} / {{planned}}",
    "itemCount_one": "{{count}} item",
    "itemCount_other": "{{count}} itens",
    "expandFrontAria": "Mostrar itens de {{name}}",
    "collapseFrontAria": "Ocultar itens de {{name}}",
    "advanceTitle": "Registrar medição de serviço",
    "advanceDescription": "Informe quanto foi executado nesta linha. A quantidade soma no avanço físico e no valor medido. Pago e Saldo só mudam se você gerar uma conta a pagar.",
    "recordAdvanceRowAria": "Registrar medição de {{name}}",
    "advanceQuantityHint": "Já medido: {{advanced}} / {{planned}}{{unit}}",
    "advanceQuantityHintNoPlan": "Já medido: {{advanced}}{{unit}}",
    "advanceItemLabel": "Linha do planejamento",
    "advanceDateLabel": "Data",
    "advanceQuantityLabel": "Quantidade executada",
    "advanceNotesLabel": "Observações",
    "advanceSave": "Salvar medição",
    "advanceSaveSuccess": "Medição de serviço registrada.",
    "advanceSaveError": "Não foi possível registrar a medição de serviço.",
    "advanceValuePreview": "Isso vale {{value}} (quantidade × preço unitário).",
    "advanceCreatePayable": "Gerar conta a pagar",
    "advanceCreatePayableRowAria": "Gerar conta a pagar de {{name}}",
    "advancePayableDescription": "Medição — {{name}} · {{quantity}}{{unit}}"
  },
  "projectOccurrences": {
    "dateFromLabel": "Data inicial",
    "dateToLabel": "Data final",
    "timeFromLabel": "Horário inicial",
    "timeToLabel": "Horário final",
    "typeLabel": "Tipo",
    "typeAll": "Todos os tipos",
    "clearFilters": "Limpar filtros",
    "filter": {
      "date": "Data",
      "type": "Tipo",
      "typeSearch": "Buscar…",
      "typeEmpty": "Nenhum tipo encontrado.",
      "workers": "Colaboradores",
      "workersSearch": "Buscar colaboradores…",
      "workersEmpty": "Nenhum colaborador encontrado.",
      "projectServiceFronts": "Frentes de serviço",
      "projectServiceFrontsSearch": "Buscar frentes de serviço…",
      "projectServiceFrontsEmpty": "Nenhuma frente de serviço encontrada.",
      "creators": "Registrado por",
      "creatorsSearch": "Buscar pessoas…",
      "creatorsEmpty": "Nenhuma pessoa encontrada.",
      "apply": "Mostrar resultados",
      "reset": "Limpar",
      "close": "Fechar filtro"
    },
    "colDate": "Data",
    "colType": "Tipo",
    "colDescription": "Descrição",
    "colWorkers": "Colaboradores",
    "colCreatedBy": "Registrado por",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "loadError": "Não foi possível carregar as ocorrências.",
    "emptyTitle": "Nenhuma ocorrência registrada",
    "emptyDescription": "As ocorrências registradas no diário de obra aparecerão aqui.",
    "noFilterResults": "Nenhuma ocorrência corresponde aos filtros selecionados.",
    "drawerTitle": "Detalhe da ocorrência",
    "noDescription": "Sem descrição",
    "noWorkers": "Nenhum colaborador",
    "unknownCreator": "Usuário desconhecido",
    "formSections": {
      "identification": "Identificação"
    },
    "photosSection": "Fotos",
    "openProjectDiaryEntry": "Ver registro no diário",
    "loadMoreError": "Não foi possível carregar mais ocorrências.",
    "loadMoreRetry": "Tentar novamente"
  },
  "projectMaterials": {
    "dateFromLabel": "Data inicial",
    "dateToLabel": "Data final",
    "timeFromLabel": "Horário inicial",
    "timeToLabel": "Horário final",
    "clearFilters": "Limpar filtros",
    "searchPlaceholder": "Buscar por nome ou código…",
    "clearSearch": "Limpar busca",
    "formSections": {
      "identification": "Identificação"
    },
    "filter": {
      "date": "Data",
      "material": "Material",
      "materialSearch": "Buscar…",
      "materialEmpty": "Nenhum material encontrado.",
      "creators": "Registrado por",
      "creatorsSearch": "Buscar pessoas…",
      "creatorsEmpty": "Nenhuma pessoa encontrada.",
      "apply": "Mostrar resultados",
      "reset": "Limpar",
      "close": "Fechar filtro"
    },
    "colDate": "Data",
    "colCode": "Código",
    "colMaterial": "Material",
    "colQuantity": "Quantidade",
    "colCreatedBy": "Registrado por",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "loadError": "Não foi possível carregar os materiais.",
    "emptyTitle": "Nenhum material registrado",
    "emptyDescription": "Os materiais usados no diário de obra aparecerão aqui.",
    "noFilterResults": "Nenhum material corresponde aos filtros selecionados.",
    "drawerTitle": "Detalhe do material",
    "unknownCreator": "Usuário desconhecido",
    "openProjectDiaryEntry": "Ver registro no diário",
    "loadMoreError": "Não foi possível carregar mais materiais.",
    "loadMoreRetry": "Tentar novamente",
    "tabs": {
      "usage": "Histórico de uso",
      "catalog": "Catálogo da obra",
      "movements": "Movimentações de estoque"
    }
  },
  "projectMaterialMovements": {
    "colDate": "Data",
    "colCode": "Código",
    "colMaterial": "Material",
    "colQuantity": "Quantidade",
    "colSource": "Tipo",
    "colOrigin": "Descrição",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "loadError": "Não foi possível carregar as movimentações.",
    "emptyTitle": "Nenhuma movimentação",
    "emptyDescription": "Transferências e consumo do diário aparecerão aqui.",
    "emptyFilteredTitle": "Nenhuma movimentação corresponde aos filtros",
    "emptyFilteredDescription": "Tente ajustar o período ou os filtros.",
    "loadMoreError": "Não foi possível carregar mais movimentações.",
    "loadMoreRetry": "Tentar novamente",
    "drawerTitle": "Movimentações do material",
    "movementDetailTitle": "Detalhe da movimentação",
    "formSections": {
      "identification": "Identificação"
    },
    "recentSection": "Movimentações recentes",
    "searchPlaceholder": "Buscar por nome ou código",
    "clearSearch": "Limpar busca",
    "dateFromLabel": "De",
    "dateToLabel": "Até",
    "timeFromLabel": "Horário inicial",
    "timeToLabel": "Horário final",
    "filter": {
      "date": "Data",
      "material": "Material",
      "materialSearch": "Buscar materiais",
      "materialEmpty": "Nenhum material encontrado",
      "type": "Tipo",
      "typeSearch": "Buscar tipos",
      "typeEmpty": "Nenhum tipo encontrado"
    },
    "source": {
      "transfer_in": "Entrada",
      "transfer_out": "Saída",
      "consumption": "Consumo",
      "reversal": "Estorno",
      "consumption_delta": "Ajuste de quantidade",
      "purchase": "Compra"
    }
  },
  "projectMaterialSelection": {
    "colCode": "Código",
    "colName": "Nome",
    "colCategory": "Categoria",
    "colUnit": "Unidade",
    "colStatus": "Status",
    "colQuantity": "Estoque atual",
    "colOrgStock": "Estoque empresa",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "loadError": "Não foi possível carregar os materiais da obra.",
    "saveError": "Não foi possível salvar os materiais da obra.",
    "deleteError": "Não foi possível remover o material da obra.",
    "emptyTitle": "Nenhum material selecionado",
    "emptyDescription": "Adicione materiais do catálogo da empresa e aloque quantidades para esta obra.",
    "searchPlaceholder": "Buscar por nome ou código…",
    "clearSearch": "Limpar busca",
    "clearFilters": "Limpar filtros",
    "noSearchResults": "Nenhum material corresponde à busca.",
    "noFilterResults": "Nenhum material corresponde aos filtros selecionados.",
    "statusActive": "Ativo",
    "statusInactive": "Inativo",
    "filterCategory": "Categoria",
    "filterCategorySearch": "Buscar categorias…",
    "filterCategoryEmpty": "Nenhuma categoria encontrada.",
    "filterUnit": "Unidade",
    "filterUnitSearch": "Buscar unidades…",
    "filterUnitEmpty": "Nenhuma unidade encontrada.",
    "addMaterialsAction": "Adicionar materiais",
    "addLabel": "Material",
    "addPlaceholder": "Buscar materiais do catálogo…",
    "addLineTitle": "Adicionar linha de material",
    "addLineAction": "Adicionar linha",
    "addItemSave": "Adicionar",
    "edit": "Editar",
    "editItem": "Editar linha",
    "addBatchSuccess": "Materiais adicionados à obra.",
    "alreadySelected": "Este material já está na obra.",
    "codeNotFound": "Este código não está no estoque da obra.",
    "materialRequired": "Selecione um material.",
    "quantityLabel": "Quantidade",
    "quantityRequired": "Informe uma quantidade.",
    "quantityExceedsStock": "A quantidade não pode exceder o estoque da empresa.",
    "quantityMaxHint": "Máximo disponível: {{max}} {{unit}}",
    "quantityNoStock": "Sem estoque disponível para este material.",
    "orgStockHint": "Estoque da empresa: {{stock}} {{unit}}",
    "orgStockLabel": "Estoque empresa",
    "orgStockInsufficient": "Estoque da empresa insuficiente para esta quantidade.",
    "projectQuantityInsufficient": "Quantidade insuficiente na obra.",
    "remove": "Excluir",
    "actionsMenu": "Ações",
    "actionsQuantitySection": "Estoque",
    "viewMovements": "Ver movimentações",
    "quantityAdd": "Adicionar",
    "quantityRemove": "Remover",
    "quantityAdjustAddTitle": "Adicionar quantidade à obra",
    "quantityAdjustRemoveTitle": "Remover quantidade da obra",
    "quantityAdjustLabel": "Quantidade",
    "quantityAdjustConfirmAdd": "Adicionar",
    "quantityAdjustConfirmRemove": "Remover",
    "quantityAdjustSuccess": "Quantidade da obra atualizada.",
    "deleteSuccess": "Material removido da obra.",
    "deleteConfirmTitle": "Remover material da obra?",
    "deleteConfirmDescription": "A quantidade restante voltará ao estoque da empresa. Os registros existentes do diário são mantidos.",
    "deleteConfirmAction": "Remover",
    "cancel": "Cancelar",
    "diaryEmptyHint": "Nenhum material com quantidade disponível nesta obra. Adicione materiais na aba Catálogo da obra.",
    "formTitle": "Adicionar materiais à obra",
    "formStepDetails": "Materiais",
    "formStepReview": "Revisar e enviar",
    "formReviewTitle": "Revisar e enviar",
    "reviewSummaryTitle": "Resumo",
    "formSave": "Salvar",
    "formDraftSection": "Materiais a adicionar",
    "formDraftEmpty": "Adicione uma ou mais linhas de material.",
    "formItemsRequired": "Adicione pelo menos uma linha de material.",
    "draftQuantity": "Quantidade: {{quantity}} {{unit}}",
    "removeDraftLine": "Remover linha"
  },
  "projectDiaryEntries": {
    "new": "Novo registro",
    "viewDetails": "Ver detalhes",
    "edit": "Editar",
    "delete": "Excluir",
    "save": "Salvar",
    "cancel": "Cancelar",
    "formSections": {
      "identification": "Identificação"
    },
    "colCode": "Código",
    "codeLabel": "Código",
    "colDate": "Data e hora",
    "colWeather": "Clima",
    "colWorkability": "Praticabilidade",
    "colStatus": "Status",
    "colProjectServiceFronts": "Frentes de serviço",
    "colOccurrences": "Ocorrências",
    "colMaterials": "Materiais",
    "colPhotos": "Fotos",
    "colCreatedBy": "Registrado por",
    "colNotes": "Observações",
    "listOccurrencesNone": "Sem ocorrências",
    "listOccurrencesOne": "1 ocorrência",
    "listOccurrencesMany": "{{count}} ocorrências",
    "projectServiceFrontsOverflowAria": "Mais {{count}} frentes de serviço",
    "entryDateLabel": "Data e hora",
    "entryTimeLabel": "Horário",
    "workabilityLabel": "Praticabilidade",
    "workabilityPracticable": "Praticável",
    "workabilityImpracticable": "Impraticável",
    "weatherLabel": "Clima",
    "weatherPlaceholder": "Selecione a condição climática",
    "notesLabel": "Observações",
    "statusLabel": "Status",
    "statusDraft": "Rascunho",
    "statusPublished": "Publicado",
    "continueDraft": "Continuar rascunho",
    "discardDraft": "Descartar rascunho",
    "discardDraftConfirmTitle": "Descartar este rascunho?",
    "discardDraftConfirmDescription": "Este rascunho será removido permanentemente. Ele nunca foi publicado.",
    "discardDraftConfirmAction": "Descartar",
    "keepDraftConfirmTitle": "Manter este rascunho?",
    "keepDraftConfirmDescription": "Você pode continuar depois na lista do diário. Se não manter, este rascunho será removido.",
    "keepDraftConfirmAction": "Manter",
    "discardDraftSuccess": "Rascunho descartado.",
    "discardDraftLeaving": "Descartando rascunho…",
    "publish": "Publicar",
    "publishSuccess": "Registro do diário publicado.",
    "publishReviewHint": "Este registro ainda é um rascunho. Publique para finalizar e aplicar as movimentações de estoque.",
    "draftPending": "Alterações não salvas…",
    "draftSaving": "Salvando…",
    "draftSaved": "Todas as alterações salvas",
    "draftSaveFailed": "Não foi possível salvar o rascunho. Suas alterações ficam locais até o próximo salvamento.",
    "draftSaveFailedShort": "Falha ao salvar — tentaremos de novo",
    "draftPhotoUploading": "Enviando foto…",
    "draftPhotoUploadingCount": "Enviando foto {{current}} de {{total}}…",
    "draftPhotoDeleting": "Excluindo foto…",
    "draftPhotoDeleteFailed": "Não foi possível excluir a foto.",
    "draftPhotoFailedShort": "Falha no envio de foto",
    "draftLeavingSaving": "Salvando alterações…",
    "draftLeavingUploadingPhotos": "Enviando foto…",
    "draftPhotoUploadFailed": "Não foi possível enviar todas as fotos. Corrija ou remova as falhas antes de continuar.",
    "draftsBanner": "Você tem {{count}} rascunho(s) não finalizado(s).",
    "showDraftsBannerAria": "Mostrar alerta de rascunhos não finalizados ({{count}})",
    "viewDrafts": "Ver rascunhos",
    "dismissDraftsBanner": "Dispensar",
    "formDraftTitle": "Rascunho do diário",
    "weatherSunny": "Ensolarado",
    "weatherPartlyCloudy": "Parcialmente nublado",
    "weatherCloudy": "Nublado",
    "weatherRainy": "Chuvoso",
    "weatherStorm": "Tempestade",
    "generalSection": "Geral",
    "addShort": "Adicionar",
    "drawerNewProjectServiceFront": "Nova frente de serviço",
    "drawerEditProjectServiceFront": "Editar frente de serviço",
    "drawerNewOccurrence": "Nova ocorrência",
    "drawerEditOccurrence": "Editar ocorrência",
    "lineNoDescription": "Sem descrição ainda.",
    "lineUntitled": "Sem título",
    "projectServiceFrontsSection": "Frentes de serviço",
    "projectServiceFrontSection": "Frente de serviço",
    "occurrencesSection": "Ocorrências",
    "materialsSection": "Materiais",
    "photosSection": "Fotos",
    "addProjectServiceFront": "Adicionar frente de serviço",
    "addOccurrence": "Adicionar ocorrência",
    "createProjectServiceFrontLink": "Criar nova frente de serviço",
    "createOccurrenceLink": "Criar nova ocorrência",
    "catalogCreateProjectServiceFrontTitle": "Nova frente de serviço",
    "catalogCreateOccurrenceTitle": "Nova ocorrência",
    "addPhoto": "Adicionar foto",
    "choosePhoto": "Escolher foto",
    "takePhoto": "Tirar foto",
    "photoCameraCapture": "Capturar",
    "photoCameraLoading": "Iniciando câmera…",
    "photoCameraUnavailable": "Não foi possível acessar a câmera. Verifique as permissões do navegador e tente novamente.",
    "photoCameraCaptureFailed": "Não foi possível capturar a foto. Tente novamente.",
    "photosCount_one": "{{count}} foto",
    "photosCount_other": "{{count}} fotos",
    "photoMaxReached": "Não foi possível adicionar mais fotos nesta linha.",
    "projectServiceFrontLabel": "Frente de serviço",
    "projectServiceFrontPlaceholder": "Selecione uma frente…",
    "occurrenceLabel": "Ocorrência",
    "occurrencePlaceholder": "Selecione uma ocorrência…",
    "lineDescriptionLabel": "Descrição",
    "lineDescriptionPlaceholder": "O que foi feito nesta frente…",
    "workersLabel": "Equipe",
    "workersPlaceholder": "Selecione colaboradores…",
    "noWorkers": "Nenhum colaborador atribuído.",
    "occurrenceDescriptionPlaceholder": "Detalhes desta ocorrência…",
    "duplicateProjectServiceFront": "Cada frente de serviço só pode ser selecionada uma vez.",
    "duplicateOccurrence": "Cada ocorrência só pode ser selecionada uma vez.",
    "formCreateTitle": "Novo registro do diário",
    "formEditTitle": "Editar registro do diário",
    "formReviewTitle": "Revisar e enviar",
    "stepGeneral": "Geral",
    "stepProjectServiceFronts": "Frentes de serviço",
    "stepOccurrences": "Ocorrências",
    "stepMaterials": "Materiais",
    "stepDetails": "Detalhes do registro",
    "stepServiceFronts": "Frentes de serviço",
    "stepReview": "Revisar e enviar",
    "reviewSummaryTitle": "Resumo",
    "reviewAddedLine": "Adicionado",
    "reviewRemovedLine": "Removido",
    "reviewEditedLine": "Atualizado",
    "reviewSectionNoChanges": "Nenhuma alteração nesta seção.",
    "reviewPreviousLine": "Anterior: {{value}}",
    "backToList": "Voltar ao diário",
    "notFound": "Este registro não existe mais ou você não tem acesso.",
    "pastEntryReadonly": "Registros de dias anteriores não podem ser editados ou excluídos.",
    "drawerDetailTitle": "Detalhe do registro do diário",
    "drawerNoNotes": "Sem observações.",
    "loadError": "Não foi possível carregar os registros do diário.",
    "saveSuccess": "Registro do diário salvo.",
    "photosUploadFailed": "O registro foi salvo, mas algumas fotos não puderam ser enviadas.",
    "deleteSuccess": "Registro do diário removido.",
    "deleteConfirmTitle": "Excluir este registro do diário?",
    "deleteConfirmDescription": "Esta ação não pode ser desfeita. As fotos anexadas também serão removidas.",
    "deleteConfirmAction": "Excluir",
    "actionsMenu": "Ações",
    "emptyTitle": "Nenhum registro no diário",
    "emptyDescription": "Crie o primeiro registro para documentar o andamento diário desta obra.",
    "dateFromLabel": "De",
    "dateToLabel": "Até",
    "timeFromLabel": "Horário inicial",
    "timeToLabel": "Horário final",
    "filter": {
      "date": "Data",
      "status": "Status",
      "statusSearch": "Buscar status…",
      "statusEmpty": "Nenhum status encontrado.",
      "weather": "Clima",
      "weatherSearch": "Buscar clima…",
      "weatherEmpty": "Nenhum clima encontrado.",
      "projectServiceFronts": "Frentes de serviço",
      "projectServiceFrontsSearch": "Buscar frentes de serviço…",
      "projectServiceFrontsEmpty": "Nenhuma frente de serviço encontrada.",
      "creators": "Registrado por",
      "creatorsSearch": "Buscar pessoas…",
      "creatorsEmpty": "Nenhuma pessoa encontrada.",
      "apply": "Mostrar resultados",
      "reset": "Limpar",
      "close": "Fechar filtro"
    },
    "clearDates": "Limpar datas",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "noFilterResults": "Nenhum registro corresponde aos filtros selecionados.",
    "viewModeAria": "Visualização do diário",
    "viewModeGridAria": "Visualização em grade",
    "viewModeTimelineAria": "Visualização em linha do tempo",
    "timelineToday": "Hoje",
    "timelineYesterday": "Ontem",
    "timelinePhotoOverflow": "+{{count}}",
    "timelineOpenPhotoAria": "Abrir foto {{index}}",
    "timelineFrontPhotosTitle": "Fotos da frente",
    "timelineOccurrencePhotosTitle": "Fotos da ocorrência",
    "loadMoreError": "Não foi possível carregar mais registros.",
    "loadMoreRetry": "Tentar novamente",
    "photoCaptionLabel": "Legenda",
    "photoCaptionPlaceholder": "Legenda opcional…",
    "createModeTitle": "Como você quer começar?",
    "createModePhoto": "Modo fotografia",
    "createModePhotoDescription": "Tire as fotos da obra primeiro, escreva uma legenda em cada uma e depois complete o resto.",
    "createModeNormal": "Modo formulário",
    "createModeNormalDescription": "Vá direto ao formulário e preencha os detalhes do registro.",
    "photoModeTitle": "Fotos da obra",
    "photoModeAdd": "Adicionar fotos",
    "photoModeCaptionPlaceholder": "O que esta foto mostra?",
    "photoModeEmpty": "Nenhuma foto ainda. Tire ou escolha fotos para iniciar o registro.",
    "photoModeOk": "Continuar",
    "createPreparing": "Abrindo o diário…",
    "photoInvalidType": "Use imagens JPEG, PNG ou WebP.",
    "photoTooLarge": "Cada foto deve ter no máximo 10 MB.",
    "removePhoto": "Remover foto",
    "photoDeleteConfirmTitle": "Remover esta foto?",
    "photoDeleteConfirmDescription": "Esta ação não pode ser desfeita.",
    "photoDeleteConfirmAction": "Remover",
    "photoMarkupTitle": "Marcar foto",
    "photoMarkupSaveFailed": "Não foi possível salvar a foto marcada. Tente novamente.",
    "photoMarkupPen": "Caneta",
    "photoMarkupArrow": "Seta",
    "photoMarkupRect": "Caixa",
    "photoMarkupCircle": "Círculo",
    "photoMarkupText": "Texto",
    "photoMarkupSelect": "Selecionar",
    "photoMarkupDelete": "Excluir marca",
    "photoMarkupSelectHint": "Clique em uma marca para selecionar; arraste para mover ou redimensionar.",
    "photoMarkupTextHint": "Clique para posicionar, digite e pressione Enter. Clique em outro lugar para mover.",
    "photoMarkupTextPlaceholder": "Digite aqui…",
    "photoMarkupColor": "Cor",
    "photoMarkupStroke": "Espessura",
    "photoMarkupStrokeThin": "Espessura fina",
    "photoMarkupStrokeMedium": "Espessura média",
    "photoMarkupStrokeThick": "Espessura grossa",
    "photoMarkupUndo": "Desfazer",
    "noPhotos": "Nenhuma foto ainda.",
    "noProjectServiceFronts": "Nenhuma frente de serviço neste registro.",
    "noOccurrences": "Nenhuma ocorrência neste registro.",
    "noMaterials": "Nenhum material neste registro.",
    "materialsCount_one": "{{count}} material",
    "materialsCount_other": "{{count}} materiais",
    "materialLabel": "Material",
    "materialRequired": "Selecione um material.",
    "materialQuantityLabel": "Quantidade",
    "materialQuantityRequired": "Informe a quantidade utilizada.",
    "materialStockHint": "Estoque disponível: {{stock}} {{unit}}",
    "projectMaterialQuantityHint": "Disponível na obra: {{quantity}} {{unit}}",
    "materialQuantityExceedsProject": "A quantidade não pode exceder o disponível na obra.",
    "addMaterialLine": "Adicionar material",
    "lineDetailsSection": "Detalhes",
    "lineDone": "Concluir",
    "copyLine": "Copiar",
    "lineExpand": "Expandir detalhes",
    "lineCollapse": "Recolher detalhes",
    "emptyProjectServiceFrontsHint": "Nenhuma frente adicionada — você pode continuar.",
    "emptyOccurrencesHint": "Nenhuma ocorrência adicionada — você pode continuar.",
    "emptyMaterialsHint": "Nenhum material adicionado — você pode continuar.",
    "deleteLineConfirmTitle": "Remover este item?",
    "deleteLineConfirmDescription": "Ele será removido deste registro.",
    "editMaterialLine": "Editar material",
    "duplicateMaterial": "Cada material só pode ser selecionado uma vez.",
    "dateTaken": "Já existe um registro para esta data.",
    "createdAt": "Criado em",
    "createdByLabel": "Registrado por",
    "unknownCreator": "Usuário desconhecido",
    "colEquipments": "Equipamentos",
    "equipmentsSection": "Equipamentos",
    "stepEquipments": "Equipamentos",
    "noEquipments": "Nenhum equipamento neste diário.",
    "equipmentsCount_one": "{{count}} equipamento",
    "equipmentsCount_other": "{{count}} equipamentos",
    "equipmentLabel": "Equipamento",
    "equipmentRequired": "Selecione um equipamento.",
    "equipmentQuantityLabel": "Quantidade",
    "equipmentQuantityRequired": "Informe a quantidade utilizada.",
    "projectEquipmentQuantityHint": "Disponível na obra: {{quantity}}",
    "projectEquipmentIndividualHint": "Equipamento individual é registrado como uma unidade.",
    "equipmentQuantityExceedsProject": "A quantidade não pode exceder o disponível na obra.",
    "addEquipmentLine": "Adicionar equipamento",
    "emptyEquipmentsHint": "Nenhum equipamento adicionado ainda — você pode continuar.",
    "editEquipmentLine": "Editar equipamento",
    "duplicateEquipment": "Cada equipamento só pode ser selecionado uma vez.",
    "checklistsSection": "Checklists",
    "colChecklists": "Checklists",
    "checklistsCount_one": "{{count}} checklist",
    "checklistsCount_other": "{{count}} checklists",
    "checklistsLoadError": "Não foi possível carregar as checklists da obra.",
    "editChecklist": "Editar checklist",
    "editChecklistNamed": "Editar checklist — {{name}}",
    "checklistItemNotes": "Observações",
    "checklistItemNotesPlaceholder": "Observações opcionais…",
    "checklistItemChecked": "Marcado",
    "checklistItemUnchecked": "Não marcado",
    "checklistReviewCheckedCount": "{{checked}}/{{total}} marcados",
    "checklistReviewNotesCount": "{{count}} com observações"
  },
  "projects": {
    "new": "Nova obra",
    "edit": "Editar",
    "inactivate": "Inativar",
    "reactivate": "Reativar",
    "delete": "Excluir",
    "save": "Salvar",
    "cancel": "Cancelar",
    "colCode": "Código",
    "colTitle": "Título",
    "colDescription": "Descrição",
    "colClient": "Cliente",
    "colAddress": "Endereço",
    "colStartDate": "Início",
    "colType": "Tipo",
    "colPriority": "Prioridade",
    "colResponsible": "Responsável",
    "colProgress": "Progresso",
    "colStatus": "Status",
    "colDueDate": "Término previsto",
    "titleLabel": "Título",
    "codeLabel": "Código",
    "descriptionLabel": "Descrição",
    "clientLabel": "Cliente",
    "clientPlaceholder": "Selecione um cliente…",
    "clientBudgetLabel": "Orçamento do cliente",
    "clientBudgetPlaceholder": "Número do orçamento",
    "clientBudgetEmpty": "Nenhum orçamento aprovado sem obra",
    "clientBudgetCodeNotFound": "Nenhum orçamento encontrado com este número.",
    "budgetScopeLabel": "Orçamento",
    "budgetScopeWithout": "Sem orçamento",
    "budgetScopeWith": "Com orçamento",
    "formSections": {
      "budget": "Orçamento",
      "identification": "Identificação",
      "responsibilities": "Responsabilidades",
      "configuration": "Configuração",
      "serviceFronts": "Frentes de serviço",
      "schedule": "Cronograma",
      "planning": "Planejamento",
      "details": "Detalhes"
    },
    "clientSelected": "Cliente atribuído",
    "plannedRevenueLabel": "Receita prevista",
    "plannedRevenueFromClientBudget": "Definida pelo orçamento do cliente aprovado.",
    "plannedRevenueOpenClientBudget": "Abrir orçamento do cliente",
    "addressLabel": "Endereço",
    "startDateLabel": "Data de início",
    "typeLabel": "Tipo",
    "typePlaceholder": "Selecione um tipo…",
    "priorityLabel": "Prioridade",
    "statusLabel": "Status",
    "responsibleLabel": "Responsável",
    "dueDateLabel": "Término previsto",
    "dueDateBeforeStartDate": "O término previsto não pode ser anterior à data de início.",
    "responsiblePlaceholder": "Selecione um colaborador…",
    "responsibleNone": "Nenhum",
    "responsibleSelected": "Colaborador atribuído",
    "noDescription": "Sem descrição",
    "formCreateTitle": "Nova obra",
    "formEditTitle": "Editar obra",
    "formReviewTitle": "Revisar e enviar",
    "stepDetails": "Dados da obra",
    "stepReview": "Revisar e enviar",
    "reviewSummaryTitle": "Resumo",
    "reviewPreviousLine": "Anterior: {{value}}",
    "backToList": "Voltar para obras",
    "loadingTitle": "Carregando obra…",
    "notFound": "Esta obra não existe mais ou você não tem acesso.",
    "overviewSections": {
      "identification": "Identificação",
      "statusAndPriority": "Status e prioridade",
      "execution": "Execução",
      "address": "Endereço",
      "details": "Detalhes",
      "fiscal": "Dados fiscais da obra"
    },
    "startDateShortLabel": "Início",
    "dueDateShortLabel": "Término previsto",
    "loadError": "Não foi possível carregar as obras.",
    "createSuccess": "Obra criada.",
    "saveSuccess": "Obra salva.",
    "deleteSuccess": "Obra removida.",
    "statusActive": "Ativa",
    "statusInactive": "Inativa",
    "inactivateSuccess": "Obra inativada.",
    "reactivateSuccess": "Obra reativada.",
    "inactivateConfirmTitle": "Inativar esta obra?",
    "inactivateConfirmDescription": "A obra continua visível para consulta, mas ninguém pode editá-la até reativá-la. Ela também deixa de contar no limite do plano.",
    "inactivateConfirmAction": "Inativar",
    "reactivateConfirmTitle": "Reativar esta obra?",
    "reactivateConfirmDescription": "A obra volta a ser editável e conta no limite de obras ativas se o status ainda for ativo.",
    "reactivateConfirmAction": "Reativar",
    "inactiveReadonly": "Esta obra está inativada. Você pode consultar, mas não editar.",
    "deleteConfirmTitle": "Remover esta obra?",
    "deleteConfirmDescription": "Esta ação não pode ser desfeita. Diários e relatórios vinculados podem impedir a exclusão.",
    "deleteConfirmAction": "Remover",
    "deleteInUse": "Esta obra não pode ser excluída enquanto estiver em uso.",
    "invalidResponsibleWorker": "O colaborador selecionado é inválido.",
    "invalidServiceFrontModel": "O modelo de frente de serviço selecionado é inválido.",
    "serviceFrontModelLabel": "Modelo de frente de serviço",
    "serviceFrontModelPlaceholder": "Selecione um modelo…",
    "serviceFrontModelRequired": "Selecione um modelo de frente de serviço.",
    "serviceFrontModelNameLabel": "Nome do modelo",
    "serviceFrontModelNameRequired": "Informe o nome do modelo.",
    "serviceFrontsSourceLabel": "Frentes de serviço",
    "serviceFrontsSourceDescription": "Escolha como criar as frentes de serviço desta obra.",
    "serviceFrontsSourceModel": "Usar modelo de frentes",
    "serviceFrontsSourceModelDescription": "Copiar etapas de um modelo reutilizável existente.",
    "serviceFrontsSourceMsProject": "Importar do MS Project (XML)",
    "serviceFrontsSourceMsProjectDescription": "Criar uma frente de serviço para cada tarefa com datas no cronograma.",
    "serviceFrontsSourceEmpty": "Criar obra vazia",
    "serviceFrontsSourceEmptyDescription": "Criar a obra sem frentes de serviço por enquanto.",
    "msProjectFileLabel": "Arquivo XML do MS Project",
    "msProjectFileDescription": "Exporte o cronograma do Microsoft Project como XML.",
    "msProjectFileRequired": "Selecione um arquivo XML do MS Project.",
    "msProjectTasksRequired": "Confirme as frentes de serviço a importar.",
    "msProjectPreviewLabel": "Prévia da importação",
    "msProjectPreviewLoading": "Lendo cronograma…",
    "msProjectPreviewCount_one": "{{count}} frente de serviço será criada",
    "msProjectPreviewCount_other": "{{count}} frentes de serviço serão criadas",
    "msProjectReviewTitle": "Revisar importação do MS Project",
    "msProjectReviewDescription": "Selecione as tarefas a importar e ajuste nomes ou datas se precisar.",
    "msProjectReviewImportColumn": "Importar",
    "msProjectReviewNameColumn": "Nome da frente",
    "msProjectReviewStartColumn": "Início",
    "msProjectReviewFinishColumn": "Fim",
    "msProjectReviewConfirm": "Confirmar importação",
    "msProjectReviewSelectOne": "Selecione ao menos uma frente de serviço para importar.",
    "msProjectReviewNameRequired": "Informe o nome.",
    "msProjectReviewStartRequired": "Informe a data de início.",
    "msProjectReviewFinishRequired": "Informe a data de fim.",
    "msProjectReviewDatesRequired": "Informe as datas de início e fim.",
    "msProjectReviewFinishBeforeStart": "A data de fim não pode ser anterior ao início.",
    "msProjectReviewDuplicateName": "Os nomes das frentes devem ser únicos.",
    "msProjectReviewEdit": "Revisar e editar",
    "saveAsServiceFrontModelLabel": "Salvar também como modelo de frentes",
    "saveAsServiceFrontModelDescription": "Reutilize essas frentes ao criar obras futuras.",
    "msProjectModelNameDefault": "{{title}} - Frentes",
    "projectServiceFront": {
      "description": "Defina a cor e a equipe de cada etapa da frente de serviço desta obra.",
      "colorLabel": "Cor da etapa",
      "workersPlaceholder": "Selecione colaboradores…",
      "saveSuccess": "Etapa atualizada.",
      "empty": "Nenhuma etapa encontrada para esta obra.",
      "workerCount_one": "{{count}} colaborador",
      "workerCount_other": "{{count}} colaboradores"
    },
    "forbidden": "Você não tem permissão para alterar obras.",
    "actionsMenu": "Ações",
    "emptyTitle": "Nenhuma obra",
    "emptyDescription": "Crie uma para começar.",
    "searchPlaceholder": "Buscar por código, título ou descrição…",
    "clearSearch": "Limpar busca",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "noSearchResults": "Nenhuma obra corresponde à busca.",
    "noFilterResults": "Nenhuma obra corresponde aos filtros selecionados.",
    "clearFilters": "Limpar filtros",
    "filter": {
      "progress": "Progresso",
      "progressRangeInvalid": "De deve ser menor ou igual a Até.",
      "status": "Status",
      "statusSearch": "Buscar status…",
      "statusEmpty": "Nenhum status encontrado.",
      "priority": "Prioridade",
      "prioritySearch": "Buscar prioridades…",
      "priorityEmpty": "Nenhuma prioridade encontrada.",
      "startDate": "Início",
      "dueDate": "Término previsto",
      "dateFromLabel": "De",
      "dateToLabel": "Até",
      "responsible": "Responsável",
      "responsibleSearch": "Buscar pessoas…",
      "responsibleEmpty": "Nenhuma pessoa encontrada.",
      "client": "Cliente",
      "clientSearch": "Buscar clientes…",
      "clientEmpty": "Nenhum cliente encontrado."
    },
    "loadMoreError": "Não foi possível carregar mais obras.",
    "loadMoreRetry": "Tentar novamente",
    "type": {
      "residencial": "Residencial",
      "comercial": "Comercial",
      "industrial": "Industrial",
      "infraestrutura": "Infraestrutura",
      "reforma": "Reforma",
      "outro": "Outro"
    },
    "priority": {
      "normal": "Normal",
      "high": "Alta",
      "critical": "Crítica"
    },
    "status": {
      "planned": "Planejada",
      "in_progress": "Em andamento",
      "on_hold": "Em pausa",
      "overdue": "Atrasada",
      "completed": "Concluída",
      "cancelled": "Cancelada"
    }
  },
  "project": {
    "navLabel": "Seções da obra",
    "openNav": "Abrir menu da obra",
    "expandNav": "Expandir menu da obra",
    "collapseNav": "Recolher menu da obra",
    "sections": {
      "overview": "Informações",
      "tracking": "Acompanhamento",
      "projectServiceFront": "Frente de serviço",
      "projectDiaryEntries": "Diário de obra",
      "occurrences": "Ocorrências",
      "documentCategories": "Categorias de documentos",
      "issues": "Ocorrências",
      "materials": "Materiais",
      "budget": "Planejamento de custos",
      "projectBudgets": "Planejamento de custos",
      "clientBudgets": "Orçamento do cliente",
      "purchaseRequests": "Solicitações de compra",
      "projectQuotations": "Cotações",
      "purchaseOrders": "Pedidos de compra",
      "costs": "Custos da obra",
      "payables": "Contas a pagar",
      "receivables": "Contas a receber",
      "invoices": "Notas fiscais",
      "cashFlow": "Fluxo de caixa",
      "documents": "Documentos",
      "photos": "Fotos",
      "reports": "Relatórios",
      "settings": "Configurações",
      "equipments": "Equipamentos"
    },
    "navGroups": {
      "overview": "Visão geral",
      "execution": "Execução",
      "commercial": "Comercial",
      "purchases": "Compras",
      "finance": "Financeiro",
      "docs": "Documentos"
    }
  },
  "dashboard": {
    "title": "Início",
    "newProject": "Nova obra",
    "activeProjects": "Obras ativas",
    "pausedProjects": "Obra pausada",
    "noEntryToday": "Sem registro hoje",
    "overdueProjects": "Em atraso",
    "projectsTable": "Obras",
    "viewAll": "Ver todas",
    "colProject": "Obra",
    "colStatus": "Status",
    "colLastEntry": "Último registro",
    "colMembers": "Membros",
    "colProgress": "Progresso",
    "settings": "Configurações",
    "logout": "Sair",
    "lastEntryWithLabel": "Último registro · {{label}}",
    "lastEntryNone": "Sem registro",
    "lastEntryToday": "Hoje — {{time}}",
    "lastEntryYesterday": "Ontem — {{time}}",
    "lastEntryDaysAgo_one": "Há {{count}} dia",
    "lastEntryDaysAgo_other": "Há {{count}} dias",
    "membersCount_one": "{{count}} membro",
    "membersCount_other": "{{count}} membros",
    "loadError": "Não foi possível carregar o dashboard.",
    "alertBanner_one": "{{count}} obra sem registro no diário há {{days}}+ dias.",
    "alertBanner_other": "{{count}} obras sem registro no diário há {{days}}+ dias.",
    "filterActiveProjects": "Filtrar obras ativas",
    "filterPausedProjects": "Filtrar obras pausadas",
    "filterNoEntryToday": "Filtrar obras sem registro hoje",
    "filterOverdueProjects": "Filtrar obras em atraso",
    "filterOpenPayables": "Filtrar obras com contas a pagar em aberto",
    "filterOverduePayables": "Filtrar obras com contas a pagar vencidas",
    "filterOpenReceivables": "Filtrar obras com contas a receber em aberto",
    "filterOverdueReceivables": "Filtrar obras com contas a receber vencidas",
    "filterOverBudget": "Filtrar obras acima do planejado",
    "emptyFiltered": "Nenhum registro corresponde aos filtros selecionados.",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "financeOpenPayables": "A pagar em aberto",
    "financeOverduePayables": "A pagar vencido",
    "financeOpenReceivables": "A receber em aberto",
    "financeOverdueReceivables": "A receber vencido",
    "financeOverBudget": "Obras acima do planejado",
    "overBudgetBanner_one": "{{count}} obra está acima do planejado.",
    "overBudgetBanner_other": "{{count}} obras estão acima do planejado.",
    "cardFinanceTitle": "Financeiro",
    "cardFinanceBudget": "Planejado",
    "cardFinanceRealized": "Realizado",
    "cardFinanceOpenPayables": "A pagar",
    "cardFinanceRemaining": "Saldo",
    "cardFinanceOverdue_one": "{{count}} conta vencida",
    "cardFinanceOverdue_other": "{{count}} contas vencidas"
  },
  "companyTracking": {
    "title": "Acompanhamento",
    "goToHome": "Ir para o Início",
    "noPermission": "Você não tem permissão para ver o acompanhamento.",
    "empty": "Ainda não há dados para este indicador.",
    "totalProjects": "Obras",
    "count": "Quantidade",
    "scheduleTitle": "Prazo",
    "scheduleOnTrack": "No prazo",
    "scheduleOverdue": "Em atraso",
    "scheduleNoDueDate": "Sem prazo",
    "progressTitle": "Progresso",
    "progress0To25": "0–25%",
    "progress25To50": "25–50%",
    "progress50To75": "50–75%",
    "progress75To100": "75–99%",
    "progress100": "100%",
    "diaryTitle": "Diário hoje",
    "diaryWithEntry": "Com registro",
    "diaryWithoutEntry": "Sem registro",
    "financeTitle": "Financeiro",
    "financeOpen": "Em aberto",
    "financeOverdue": "Vencido",
    "payables": "A pagar",
    "receivables": "A receber",
    "measurementTitle": "Medição",
    "measurementPlanned": "Planejado",
    "measurementMeasured": "Medido",
    "purchasingTitle": "Compras",
    "openRequests": "Solicitações abertas",
    "awaitingQuotes": "Cotações aguardando",
    "openOrders": "Pedidos em aberto",
    "stockTitle": "Estoque",
    "belowMinimum": "Abaixo do mínimo"
  },
  "theme": {
    "ariaLabel": "Tema",
    "light": "Claro",
    "dark": "Escuro",
    "system": "Sistema",
    "selectionHint": "Seleção de tema"
  },
  "photoCapture": {
    "choosePhoto": "Escolher foto",
    "takePhoto": "Tirar foto",
    "uploadHint": "Escolha uma imagem ou tire uma foto.",
    "dropHint": "Solte a imagem para enviar.",
    "invalidType": "Use imagens JPEG, PNG ou WebP.",
    "tooLarge": "Cada foto deve ter no máximo 10 MB.",
    "cameraCapture": "Capturar",
    "cameraLoading": "Iniciando câmera…",
    "cameraUnavailable": "Não foi possível acessar a câmera. Verifique as permissões do navegador e tente novamente.",
    "cameraCaptureFailed": "Não foi possível capturar a foto. Tente novamente."
  },
  "fileUpload": {
    "prompt": "Clique aqui ou arraste um arquivo para enviar",
    "dropPrompt": "Solte o arquivo para enviar",
    "maxSize": "Tamanho máximo do arquivo: {{size}}",
    "supportedFormats": "Formatos suportados: {{formats}}",
    "removeFile": "Remover arquivo",
    "invalidType": "Tipo de arquivo não suportado.",
    "invalidSize": "O arquivo excede o tamanho máximo de {{size}}.",
    "pdfPreviousPage": "Página anterior",
    "pdfNextPage": "Próxima página",
    "pdfPageCounter": "{{current}} / {{total}}",
    "pdfZoomOut": "Diminuir zoom",
    "pdfZoomIn": "Aumentar zoom",
    "pdfLoadError": "Não foi possível carregar a visualização do PDF."
  },
  "documentViewer": {
    "view": "Visualizar",
    "download": "Download",
    "openInNewTab": "Abrir em nova aba",
    "previewUnavailable": "Visualização não disponível para este tipo de arquivo."
  },
  "imageLightbox": {
    "title": "Visualizador de imagem",
    "close": "Fechar",
    "previous": "Imagem anterior",
    "next": "Próxima imagem",
    "download": "Baixar imagem",
    "goToImage": "Ir para a imagem {{index}}",
    "imageAlt": "Imagem {{index}}",
    "imageUnavailable": "Imagem indisponível"
  },
  "common": {
    "openCalendar": "Abrir calendário",
    "loading": "Aguarde...",
    "downloadError": "Não foi possível baixar o arquivo. Tente novamente.",
    "cancel": "Cancelar",
    "done": "Concluído",
    "save": "Salvar",
    "remove": "Remover",
    "comingSoon": "Em breve.",
    "openMenu": "Abrir menu",
    "mainNav": "Navegação principal",
    "more": "Mais",
    "soon": "Em breve",
    "active": "Ativo",
    "language": "Idioma",
    "accountMenu": "Menu da conta",
    "guest": "Convidado",
    "organizations": "Organizações",
    "organizationMenu": "Organização",
    "switchOrganization": "Trocar organização",
    "orgOwner": "Proprietário",
    "orgAdmin": "Administrador",
    "orgMember": "Membro",
    "orgInvitePending": "Convite pendente",
    "back": "Voltar",
    "backToApp": "Voltar ao app",
    "continue": "Continuar",
    "reviewPreviousLine": "Anterior: {{value}}",
    "reviewPrevious": "Anterior:",
    "reviewNoChanges": "Nenhuma alteração para revisar.",
    "time": "Horário",
    "apply": "Aplicar",
    "tryAgain": "Tentar novamente",
    "expandSidebar": "Expandir menu",
    "collapseSidebar": "Recolher menu",
    "closeFlow": "Fechar",
    "stepCompleted": "Concluído",
    "stepGoBackAria": "Voltar à etapa {{number}}",
    "formFlowStepsMenuAria": "Ver todas as etapas",
    "required": "Obrigatório",
    "invalid": "Inválido",
    "optional": "Opcional",
    "edit": "Editar",
    "delete": "Excluir",
    "clear": "Limpar",
    "clearAll": "Limpar tudo",
    "codeLabel": "Código",
    "codeNotFound": "Nenhum item com este código.",
    "noResults": "Nenhum resultado encontrado.",
    "selectPlaceholder": "Selecione…",
    "noRegisters": "Nenhum item cadastrado.",
    "notInformed": "Não informado",
    "quantityExceedsMax": "A quantidade excede o máximo permitido.",
    "loadingMore": "Carregando mais…",
    "errorGeneric": "Algo deu errado. Tente novamente.",
    "catalogFilter": {
      "status": "Status",
      "close": "Fechar",
      "reset": "Limpar",
      "apply": "Mostrar resultados"
    },
    "filterDrawer": {
      "title": "Selecione os filtros abaixo",
      "openAriaLabel": "Abrir filtros",
      "close": "Fechar",
      "resetAll": "Limpar filtros",
      "reset": "Limpar",
      "showResults": "Mostrar resultados"
    }
  },
  "permissions": {
    "groups": {
      "app": "Navegação do app",
      "settings": "Seções em Configurações",
      "settingsHint": "Marque «Menu Configurações» acima para o usuário ver o menu. As opções abaixo definem o que ele pode abrir dentro de Configurações.",
      "projects": "Lista de obras",
      "finance": "Financeiro",
      "project": "Dentro da obra",
      "admin": "Administração da organização"
    },
    "nav": {
      "dashboard": "Início",
      "projects": "Ver lista de obras",
      "finance": "Menu Financeiro",
      "settings": "Menu Configurações"
    },
    "settings": {
      "organization": "Dados da empresa",
      "users": "Usuários",
      "workers": "Colaboradores",
      "occurrences": "Ocorrências",
      "documentCategories": "Categorias de documentos",
      "photoTags": "Etiquetas de fotos",
      "serviceFrontModels": "Modelos de frente de serviço",
      "checklistModels": "Modelos de checklist",
      "materials": "Materiais",
      "materialsStock": "Ajustar estoque de materiais",
      "lookups": "Listas auxiliares",
      "equipments": "Equipamentos",
      "equipmentsStock": "Ajustar quantidade de equipamentos",
      "partners": "Parceiros",
      "financeLookups": "Categorias e formas de pagamento",
      "fiscal": "Notas fiscais"
    },
    "projects": {
      "create": "Criar e editar obras",
      "delete": "Excluir obras"
    },
    "finance": {
      "payables": {
        "view": "Ver contas a pagar",
        "write": "Lançar e editar contas a pagar",
        "delete": "Excluir contas a pagar"
      },
      "receivables": {
        "view": "Ver contas a receber",
        "write": "Lançar e editar contas a receber",
        "delete": "Excluir contas a receber"
      },
      "cashFlow": {
        "view": "Ver fluxo de caixa"
      },
      "fiscal": {
        "view": "Ver NFS-e",
        "emit": "Emitir NFS-e",
        "cancel": "Cancelar NFS-e"
      }
    },
    "project": {
      "overview": {
        "view": "Informações da obra"
      },
      "tracking": {
        "view": "Visão geral da obra"
      },
      "projectServiceFront": {
        "view": "Ver frentes de serviço",
        "write": "Editar frentes de serviço",
        "delete": "Excluir frentes de serviço"
      },
      "projectDiary": {
        "view": "Ver diário de obra",
        "write": "Registrar no diário de obra",
        "delete": "Excluir registros do diário"
      },
      "occurrences": {
        "view": "Ver ocorrências da obra"
      },
      "documents": {
        "view": "Ver documentos da obra",
        "write": "Gerenciar documentos da obra",
        "delete": "Excluir documentos da obra"
      },
      "photos": {
        "view": "Ver fotos da obra",
        "write": "Gerenciar fotos da obra",
        "delete": "Excluir fotos da obra"
      },
      "materials": {
        "view": "Ver materiais da obra",
        "write": "Gerenciar materiais da obra",
        "delete": "Remover materiais da obra"
      },
      "reports": {
        "view": "Ver relatórios da obra"
      },
      "projectReport": {
        "view": "Ver relatórios da obra",
        "generate": "Gerar relatórios da obra",
        "delete": "Excluir relatórios da obra",
        "manageModels": "Gerenciar modelos de relatório diário"
      },
      "project_projectReports": {
        "view": "Ver relatórios da obra"
      },
      "equipments": {
        "view": "Ver equipamentos da obra",
        "write": "Gerenciar equipamentos da obra",
        "delete": "Remover equipamentos da obra"
      },
      "budgets": {
        "view": "Ver planejamento de custos da obra",
        "write": "Gerenciar planejamento de custos da obra",
        "delete": "Excluir planejamento de custos da obra",
        "approve": "Aprovar planejamento de custos da obra"
      },
      "clientBudgets": {
        "view": "Ver orçamento do cliente",
        "write": "Gerenciar orçamento do cliente",
        "delete": "Excluir orçamento do cliente",
        "approve": "Aprovar orçamento do cliente"
      },
      "purchaseRequests": {
        "view": "Ver solicitações de compra",
        "write": "Gerenciar solicitações de compra",
        "approve": "Aprovar solicitações de compra"
      },
      "quotations": {
        "view": "Ver cotações da obra",
        "write": "Gerenciar cotações da obra",
        "approve": "Aprovar cotações da obra"
      },
      "purchaseOrders": {
        "view": "Ver pedidos de compra",
        "write": "Gerenciar pedidos de compra"
      },
      "finance": {
        "view": "Ver custos da obra"
      },
      "finance": {
        "view": "Ver custos da obra"
      }
    },
    "users": {
      "manage": "Gerenciar usuários e convites"
    },
    "modules": {
      "dashboard": "Início",
      "projects": "Obras",
      "finance": "Financeiro",
      "settings": "Configurações",
      "projectsDescription": "Escolha o acesso à lista de obras e o que o usuário pode fazer dentro de cada obra.",
      "financeDescription": "Contas a pagar, a receber e fluxo de caixa.",
      "settingsDescription": "Escolha quais páginas o usuário pode abrir dentro de Configurações."
    },
    "access": {
      "none": "Sem acesso",
      "full": "Acesso total",
      "custom": "Personalizado ({{count}})"
    },
    "edit": "Editar",
    "drawer": {
      "accessLevel": "Nível de acesso",
      "noAccessHint": "O usuário não terá nenhuma permissão nesta área.",
      "customAccess": "Acesso personalizado",
      "customAccessHint": "Escolha permissões específicas abaixo.",
      "menuAccess": "Menu",
      "menuAccessHint": "Sem seções marcadas abaixo, o usuário vê Configurações no menu mas nenhuma página dentro dela.",
      "projectList": "Lista de obras",
      "projectListHint": "Criar obras ou permissões dentro da obra incluem acesso à lista automaticamente.",
      "insideProject": "Dentro da obra",
      "settingsSections": "Seções",
      "settingsSectionsHint": "Cada opção libera uma página específica dentro de Configurações.",
      "adminActions": "Ações administrativas",
      "actions": "Permissões",
      "includedAutomatically": "Incluído automaticamente",
      "subgroups": {
        "overview": "Visão da obra",
        "serviceFronts": "Frentes de serviço",
        "diary": "Diário de obra",
        "occurrences": "Ocorrências",
        "materials": "Materiais",
        "equipments": "Equipamentos",
        "clientBudgets": "Orçamento do cliente",
        "budgets": "Planejamento de custos",
        "purchaseRequests": "Solicitações de compra",
        "quotations": "Cotações",
        "purchaseOrders": "Pedidos de compra",
        "costs": "Custos da obra",
        "payables": "Contas a pagar",
        "receivables": "Contas a receber",
        "cashFlow": "Fluxo de caixa",
        "fiscal": "Notas fiscais",
        "documents": "Documentos",
        "photos": "Fotos",
        "reports": "Relatórios",
        "other": "Outros"
      }
    },
    "summary": {
      "empty": "Nenhuma permissão selecionada."
    },
    "templates": {
      "manage": "Gerenciar permissões",
      "defaultsTitle": "Padrões do sistema",
      "defaultsHint": "Perfis controlados pela plataforma. Somente leitura.",
      "customTitle": "Perfis personalizados",
      "customHint": "Perfis criados pela sua organização.",
      "systemBadge": "Padrão do sistema",
      "permissionCount": "{{count}} permissões",
      "memberCount": "{{count}} usuários",
      "view": "Ver permissões",
      "create": "Criar perfil",
      "createTitle": "Criar perfil de acesso",
      "editTitle": "Editar perfil de acesso",
      "formStep": "Permissões do perfil",
      "formStepReview": "Revisão",
      "formReviewTitle": "Revisar e enviar",
      "reviewSummaryTitle": "Resumo",
      "name": "Nome do perfil",
      "nameRequired": "Informe o nome do perfil.",
      "empty": "Ainda não há perfis personalizados configurados para esta organização.",
      "emptyTitle": "Nenhum perfil",
      "colName": "Perfil",
      "colPermissions": "Permissões",
      "colMembers": "Usuários",
      "total": "{{count}} perfis",
      "actionsMenu": "Ações do perfil",
      "drawerDetailTitle": "Detalhe do perfil",
      "permissionsHeading": "Permissões",
      "loadError": "Não foi possível carregar os perfis.",
      "loadMoreError": "Não foi possível carregar mais perfis.",
      "loadMoreRetry": "Tentar novamente",
      "createSuccess": "Perfil criado.",
      "updateSuccess": "Perfil atualizado.",
      "deleteSuccess": "Perfil excluído.",
      "deleteTitle": "Excluir perfil",
      "deleteDescription": "Este perfil será excluído permanentemente."
    }
  },
  "fiscal": {
    "save": "Salvar",
    "loading": "Carregando…",
    "loadError": "Não foi possível carregar os dados fiscais.",
    "saveError": "Não foi possível salvar os dados fiscais.",
    "saveSuccess": "Perfil fiscal salvo.",
    "projectSaveSuccess": "Dados fiscais da obra salvos.",
    "editProfile": "Editar perfil fiscal",
    "editProjectProfile": "Editar dados fiscais",
    "orgSection": "Prestador",
    "orgFormTitle": "Perfil fiscal da empresa",
    "projectFormTitle": "Dados fiscais da obra",
    "formSections": {
      "identification": "Identificação",
      "emission": "Emissão",
      "address": "Endereço",
      "withholdings": "Retenções"
    },
    "legalNameLabel": "Razão social",
    "cnpjLabel": "CNPJ",
    "orgCadastroHint": "CNPJ e razão social ficam nos dados da empresa.",
    "orgCadastroLink": "Abrir dados da empresa",
    "taxRegimeLabel": "Regime tributário",
    "taxRegimePlaceholder": "Selecione o regime tributário",
    "municipalRegistrationLabel": "Inscrição municipal",
    "cnaeLabel": "CNAE",
    "environmentLabel": "Ambiente",
    "environmentHint": "Produção envia a NFS-e à SEFIN Nacional. Homologação usa Produção Restrita (tpAmb=2, sem valor fiscal).",
    "defaultTaxCodeLabel": "Código de serviço padrão",
    "ibgeLabel": "Código IBGE",
    "ibgeInvalid": "Informe o código IBGE de 7 dígitos.",
    "certificateSection": "Certificado",
    "certificateLabel": "Certificado A1",
    "certificateConfigured": "Configurado",
    "certificateMissing": "Não configurado",
    "certificateExpires": "Válido até {{date}}",
    "certificateUpload": "Enviar certificado",
    "certificateReplace": "Substituir",
    "certificateRemove": "Remover",
    "certificateSave": "Salvar certificado",
    "certificateUploadTitle": "Certificado A1",
    "certificateReplaceTitle": "Substituir certificado A1",
    "certificateFormSection": "Arquivo",
    "certificateHint": "Envie o arquivo .pfx ou .p12 do e-CNPJ A1 da empresa e a senha. A senha não é armazenada.",
    "certificatePasswordLabel": "Senha do certificado",
    "certificateUploadSuccess": "Certificado A1 salvo.",
    "certificateRemoveSuccess": "Certificado A1 removido.",
    "certificateRemoveTitle": "Remover o certificado A1?",
    "certificateRemoveDescription": "Sem o certificado não é possível emitir NFS-e no ambiente da SEFIN.",
    "cnoLabel": "CNO",
    "artLabel": "ART",
    "taxCodesSection": "Códigos de serviço (LC 116)",
    "taxCodeNew": "Novo código",
    "taxCodesEmpty": "Nenhum código de serviço cadastrado.",
    "taxCodesEmptyTitle": "Nenhum código de serviço",
    "taxCodesEmptyDescription": "Cadastre os itens da LC 116 usados na emissão de NFS-e.",
    "taxCodesTotal": "{{count}} códigos",
    "taxCodeActionsMenu": "Ações do código de serviço",
    "taxCodeDrawerDetailTitle": "Código de serviço",
    "createdAt": "Criado em",
    "colLc116": "LC 116",
    "colIssRate": "ISS",
    "taxCodeCreateTitle": "Novo código de serviço",
    "taxCodeEditTitle": "Editar código de serviço",
    "taxCodeNameLabel": "Descrição",
    "lc116Label": "Item LC 116",
    "issRateLabel": "Alíquota ISS (%)",
    "issRateValue": "ISS {{rate}}%",
    "nationalTaxCodeLabel": "Código nacional",
    "nbsCodeLabel": "NBS",
    "taxCodeActiveLabel": "Ativo",
    "withholdIss": "Reter ISS",
    "withholdIrrf": "Reter IRRF",
    "withholdPis": "Reter PIS",
    "withholdCofins": "Reter COFINS",
    "withholdCsll": "Reter CSLL",
    "withholdInss": "Reter INSS",
    "taxCodeSaveSuccess": "Código de serviço salvo.",
    "taxCodeNotFound": "Código de serviço não encontrado.",
    "taxCodeDelete": "Excluir",
    "taxCodeDeleteTitle": "Excluir este código de serviço?",
    "taxCodeDeleteDescription": "Isso remove o código se ele não estiver em uso em uma NFS-e.",
    "taxCodeDeleteSuccess": "Código de serviço removido.",
    "taxCodeDeleteInUse": "Este código está em uso em uma NFS-e e não pode ser excluído.",
    "statusActive": "Ativo",
    "statusInactive": "Inativo",
    "nfseSection": "NFS-e",
    "drawerDetailTitle": "Detalhe da nota fiscal",
    "colNumber": "Número",
    "colType": "Tipo",
    "colProject": "Obra",
    "colPartner": "Parceiro",
    "colAmount": "Valor",
    "colIssuedAt": "Emissão",
    "colStatus": "Status",
    "accessKeyLabel": "Chave de acesso",
    "rejectionLabel": "Rejeição",
    "openReceivable": "Abrir conta a receber",
    "openPayable": "Abrir conta a pagar",
    "receivableLabel": "Conta a receber",
    "payableLabel": "Conta a pagar",
    "searchPlaceholder": "Buscar notas fiscais",
    "clearSearch": "Limpar busca",
    "actionsMenu": "Ações da nota fiscal",
    "emptyTitle": "Nenhuma nota fiscal",
    "emptyDescription": "Emita a NFS-e a partir de uma conta a receber. Notas de entrada aparecem quando você importa o XML na conta a pagar.",
    "emptyFilteredTitle": "Nenhuma nota fiscal encontrada",
    "emptyFilteredDescription": "Tente outro termo de busca.",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "documentType": {
      "nfs_e_out": "NFS-e emitida",
      "nfs_e_in": "NFS-e recebida",
      "nfe_in": "NF-e recebida"
    },
    "noDocument": "Nenhuma NFS-e emitida para esta conta.",
    "readinessLabel": "Emissão",
    "readinessReady": "Cadastro pronto para emitir.",
    "readinessWarning": "aviso",
    "emit": "Emitir NFS-e",
    "emitSuccess": "NFS-e autorizada.",
    "alreadyEmitted": "Já existe uma NFS-e autorizada ou em envio para esta conta.",
    "notReady": "Complete o cadastro fiscal antes de emitir.",
    "notCancellable": "Esta NFS-e não pode ser cancelada.",
    "downloadXml": "Baixar XML",
    "downloadPdf": "Baixar PDF",
    "viewPdf": "Ver PDF",
    "pdfPreviewTitle": "DANFSe",
    "pdfLoadError": "Não foi possível carregar o PDF da NFS-e.",
    "cancelNfse": "Cancelar NFS-e",
    "cancelSuccess": "NFS-e cancelada.",
    "cancelConfirmTitle": "Cancelar esta NFS-e?",
    "cancelConfirmDescription": "O cancelamento é enviado ao ambiente fiscal. Esta ação não pode ser desfeita.",
    "cancelDefaultReason": "Cancelamento solicitado pelo usuário",
    "inboundSection": "XML do fornecedor",
    "importXml": "Importar XML",
    "importXmlHint": "Anexe o XML da NF-e ou NFS-e recebida para guardar a chave de acesso nesta conta.",
    "importSuccess": "XML importado.",
    "xmlInvalid": "O XML não pôde ser lido. Use um arquivo de NF-e ou NFS-e.",
    "taxRegime": {
      "simples_nacional": "Simples Nacional",
      "lucro_presumido": "Lucro presumido",
      "lucro_real": "Lucro real",
      "mei": "MEI"
    },
    "environment": {
      "homologation": "Homologação",
      "production": "Produção"
    },
    "documentStatus": {
      "draft": "Rascunho",
      "sending": "Enviando",
      "authorized": "Autorizada",
      "rejected": "Rejeitada",
      "cancelled": "Cancelada"
    },
    "readiness": {
      "org": {
        "cnpj": "CNPJ da empresa",
        "legalName": "Razão social da empresa",
        "fiscalProfile": "Perfil fiscal da empresa",
        "im": "Inscrição municipal",
        "cnae": "CNAE",
        "address": "Endereço fiscal da empresa",
        "ibge": "Código IBGE da empresa",
        "certificate": "Certificado A1 da empresa",
        "demoProduction": "Organização de demonstração não emite em produção"
      },
      "partner": {
        "document": "CPF/CNPJ do tomador",
        "address": "Endereço do tomador",
        "ibge": "Código IBGE do tomador"
      },
      "project": {
        "cno": "CNO da obra",
        "obraAddress": "Endereço da obra",
        "obraIbge": "Código IBGE da obra"
      },
      "serviceTaxCode": "Código de serviço (LC 116)",
      "receivable": {
        "amount": "Valor da conta a receber",
        "status": "Status da conta a receber"
      }
    }
  },
  "chargeAccount": {
    "sectionTitle": "Cobranças",
    "description": "PIX e boleto são processados pelo Pagar.me. A taxa do Pagar.me é descontada do valor pago. O líquido cai na conta bancária cadastrada aqui. A KonstruLog não fica com comissão.",
    "statusLabel": "Situação",
    "statusDisconnected": "Não cadastrada",
    "statusPending": "Em análise",
    "statusActive": "Ativa",
    "statusRefused": "Recusada",
    "statusSuspended": "Suspensa",
    "add": "Cadastrar",
    "edit": "Editar",
    "drawerCreateTitle": "Cadastrar conta bancária",
    "drawerEditTitle": "Editar conta bancária",
    "bank": "Banco",
    "representative": "Representante",
    "cpfInvalid": "Informe um CPF válido.",
    "bankInvalid": "Selecione um banco.",
    "bankCode": "Código do banco",
    "branch": "Agência",
    "branchDigit": "Dígito da agência",
    "account": "Conta",
    "accountDigit": "Dígito da conta",
    "accountType": "Tipo de conta",
    "checking": "Corrente",
    "savings": "Poupança",
    "representativeName": "Representante legal",
    "representativeCpf": "CPF do representante",
    "birthDate": "Data de nascimento",
    "monthlyIncome": "Renda mensal",
    "annualRevenue": "Faturamento anual",
    "saveError": "Não foi possível cadastrar a conta bancária. Tente de novo em instantes.",
    "saved": "Conta bancária enviada para análise."
  },
  "asaas": {
    "sectionTitle": "Cobranças",
    "sectionDescription": "Ative PIX e boleto para contas a receber. O dinheiro cai na conta da sua empresa, não na da KonstruLog.",
    "statusLabel": "Status",
    "statusDisconnected": "Não ativado",
    "statusApproved": "Aprovado",
    "statusPending": "Em análise",
    "statusRejected": "Recusado",
    "statusActionRequired": "Ação necessária",
    "activate": "Ativar cobranças",
    "onboardSuccess": "Cobranças ativadas. Complete o cadastro se o Asaas pedir.",
    "onboardError": "Não foi possível ativar as cobranças.",
    "completeOnboarding": "Completar cadastro no Asaas",
    "baasDisclosure": "PIX, boleto e a conta de pagamento são processados pelo Asaas Gestão Financeira Instituição de Pagamentos S.A., instituição autorizada pelo Banco Central. A KonstruLog apenas integra essa experiência e não é instituição financeira.",
    "baasSupport": "Dúvidas sobre a operação financeira: 0800 009 0037 ou contato@asaas.com.br.",
    "baasSealAlt": "Serviços financeiros Asaas"
  },
  "errors": {
    "unexpected": "Algo deu errado. Tente novamente.",
    "boundaryTitle": "Algo deu errado",
    "boundaryBody": "Ocorreu um erro inesperado. Recarregue a página para continuar.",
    "boundaryReload": "Recarregar",
    "loadErrorHint": "Verifique sua conexão e tente novamente.",
    "UNAUTHORIZED": "Sua sessão expirou. Entre novamente.",
    "ONBOARDING_REQUIRED": "Conclua o cadastro para continuar.",
    "ADMIN_REQUIRED": "Você não tem permissão para esta ação.",
    "NOT_FOUND": "O item solicitado não foi encontrado.",
    "PROJECT_NOT_FOUND": "Obra não encontrada.",
    "EMAIL_ALREADY_EXISTS": "Já existe uma conta com este e-mail.",
    "ORG_ALREADY_EXISTS": "Você já possui uma organização.",
    "CNPJ_ALREADY_EXISTS": "Já existe uma organização com este CNPJ.",
    "VALIDATION_FAILED": "Verifique o formulário e tente novamente.",
    "REPORT_RANGE_EMPTY": "Não há dados no período para este relatório.",
    "INVALID_CURSOR": "Não foi possível carregar esta página de resultados.",
    "UNKNOWN_FILTER_TYPE": "Tipo de filtro desconhecido.",
    "WORKER_BIRTH_DATE_IN_FUTURE": "A data de nascimento não pode ser no futuro.",
    "WORKER_MIN_AGE": "O colaborador deve ter pelo menos 16 anos.",
    "USER_BIRTH_DATE_IN_FUTURE": "A data de nascimento não pode ser no futuro.",
    "USER_MIN_AGE": "Você precisa ter pelo menos 18 anos.",
    "STEP_NAMES_NOT_UNIQUE": "Os nomes das etapas devem ser únicos no modelo.",
    "INVALID_HEX_COLOR": "Informe uma cor hexadecimal válida (ex.: #1A56DB).",
    "WORKER_IN_USE": "Este colaborador está em uso em atividades e não pode ser excluído.",
    "WORKER_NAME_TAKEN": "Já existe um colaborador com este nome.",
    "WORKER_CODE_TAKEN": "Já existe um colaborador com este código.",
    "WORKER_USER_ALREADY_LINKED": "Este usuário já está vinculado a outro colaborador.",
    "INVALID_WORKER_USER_ID": "O usuário selecionado não faz parte desta organização.",
    "INVALID_WORKER_IDS": "Um ou mais colaboradores são inválidos.",
    "INVALID_RESPONSIBLE_WORKER_ID": "O colaborador responsável selecionado não é válido.",
    "SERVICE_FRONT_MODEL_NAME_TAKEN": "Já existe um modelo com este nome.",
    "SERVICE_FRONT_MODEL_IN_USE": "Este modelo está em uso em obras e não pode ser excluído.",
    "INVALID_SERVICE_FRONT_MODEL_ID": "O modelo de frente de serviço selecionado não é válido.",
    "INVALID_MS_PROJECT_XML": "O arquivo XML do MS Project é inválido ou não pôde ser lido.",
    "MS_PROJECT_NO_TASKS": "Nenhuma tarefa com datas foi encontrada no arquivo do MS Project.",
    "MS_PROJECT_DUPLICATE_TASK_NAMES": "O arquivo do MS Project tem nomes de tarefa duplicados.",
    "INVALID_DOCUMENT_TYPE": "Este tipo de arquivo não é suportado.",
    "DOCUMENT_TOO_LARGE": "O arquivo é grande demais.",
    "SERVICE_FRONT_NAME_TAKEN": "Já existe uma frente de serviço com este nome na obra.",
    "SERVICE_FRONT_IN_USE": "Esta frente está em uso em atividades e não pode ser excluída.",
    "OCCURRENCE_NAME_TAKEN": "Já existe uma ocorrência com este nome.",
    "OCCURRENCE_IN_USE": "Esta ocorrência está em uso e não pode ser excluída.",
    "MATERIAL_CATEGORY_NAME_TAKEN": "Já existe uma categoria com este nome.",
    "PHOTO_TAG_NAME_TAKEN": "Já existe uma etiqueta com este nome.",
    "PHOTO_TAG_RESERVED": "Esta etiqueta é reservada pelo sistema e não pode ser editada ou atribuída manualmente.",
    "MATERIAL_NAME_TAKEN": "Já existe um material com este nome.",
    "MATERIAL_CODE_TAKEN": "Já existe um material com este código.",
    "MATERIAL_BARCODE_TAKEN": "Já existe um material com este código de barras.",
    "MATERIAL_INSUFFICIENT_STOCK": "Não é possível remover mais do que o estoque atual.",
    "PROJECT_MATERIAL_INSUFFICIENT_QUANTITY": "Quantidade insuficiente na obra.",
    "PROJECT_MATERIAL_ALREADY_SELECTED": "Este material já está na obra.",
    "PROJECT_EQUIPMENT_ALREADY_SELECTED": "Este equipamento já está na obra.",
    "INVALID_MATERIAL_CATEGORY_ID": "A categoria selecionada não é válida.",
    "WEATHER_CONDITION_NAME_TAKEN": "Já existe uma condição climática com este nome.",
    "INVALID_WEATHER_CONDITION_ID": "A condição climática selecionada não é válida.",
    "WEATHER_CONDITION_IN_USE": "Esta condição climática está em uso no diário e não pode ser excluída.",
    "PROJECT_PRIORITY_NAME_TAKEN": "Já existe uma prioridade de obra com este nome.",
    "INVALID_PROJECT_PRIORITY_ID": "A prioridade selecionada não é válida.",
    "PROJECT_PRIORITY_IN_USE": "Esta prioridade está em uso em obras e não pode ser excluída.",
    "PROJECT_TYPE_NAME_TAKEN": "Já existe um tipo de obra com este nome.",
    "INVALID_PROJECT_TYPE_ID": "O tipo de obra selecionado não é válido.",
    "PROJECT_STATUS_NOT_FOUND": "O status de obra selecionado não é válido.",
    "PROJECT_TYPE_IN_USE": "Este tipo está em uso e não pode ser excluído.",
    "INVALID_DEFAULT_SERVICE_FRONT_MODEL_ID": "O modelo de frentes selecionado não é válido.",
    "WORKER_ROLE_NAME_TAKEN": "Já existe um cargo com este nome.",
    "INVALID_WORKER_ROLE_ID": "O cargo selecionado não é válido.",
    "WORKER_ROLE_IN_USE": "Este cargo está atribuído a colaboradores e não pode ser excluído.",
    "MEASUREMENT_UNIT_SYMBOL_TAKEN": "Já existe uma unidade com este símbolo.",
    "MEASUREMENT_UNIT_IN_USE": "Esta unidade está em uso e não pode ser excluída.",
    "INVALID_MEASUREMENT_UNIT_ID": "A unidade de medida selecionada não é válida.",
    "PROJECT_STEP_NAMES_NOT_UNIQUE": "Os nomes das etapas do modelo devem ser únicos.",
    "PROJECT_SERVICE_FRONT_CONFLICT": "Não foi possível criar as etapas da obra a partir do modelo.",
    "PROJECT_DELETE_CONFLICT": "Esta obra não pode ser excluída enquanto estiver em uso.",
    "PROJECT_NAME_TAKEN": "Já existe uma obra com este título.",
    "PROJECT_CODE_TAKEN": "Já existe uma obra com este código.",
    "PROJECT_INACTIVE": "Esta obra está inativada e só pode ser consultada.",
    "SUBSCRIPTION_REQUIRED": "É necessário ter uma assinatura para continuar.",
    "SUBSCRIPTION_CANCELED": "Sua assinatura foi cancelada. Escolha um plano para continuar.",
    "PAYMENT_OVERDUE": "Pagamento em atraso. Atualize seus dados de cobrança.",
    "ORGANIZATION_BLOCKED": "O acesso da sua organização foi suspenso.",
    "HELP_CHAT_UNAVAILABLE": "O assistente de ajuda está indisponível agora. Tente de novo ou escreva para support@konstrulog.com.",
    "HELP_CHAT_LIMIT": "Você atingiu o limite diário do assistente ({{limit}}). Tente amanhã ou fale com o suporte.",
    "PLATFORM_INVITE_REQUIRED": "É necessário aceitar o convite da plataforma antes de continuar.",
    "PLATFORM_INVITE_ALREADY_ACCEPTED": "Este convite da plataforma já foi aceito.",
    "PUBLIC_ONBOARD_DISABLED": "O cadastro de organização está desativado. Solicite um convite.",
    "FEATURE_NOT_ON_PLAN": "Este recurso não está disponível no plano {{plan}}.",
    "PLAN_LIMIT_REACHED": "Limite do plano atingido: {{current}}/{{limit}} {{resource}}.",
    "planResources": {
      "activeProjects": "obras ativas",
      "teamMembers": "usuários"
    },
    "MEMBER_ALREADY_EXISTS": "Este usuário já faz parte da sua organização.",
    "INVITE_ALREADY_ACCEPTED": "Este convite já foi aceito.",
    "ORG_ACCESS_REVOKED": "Você não tem mais acesso a uma organização. Entre em contato com o administrador se precisar de ajuda.",
    "ORG_ACCESS_DENIED": "Você não tem acesso a essa organização.",
    "USER_ALREADY_IN_ORG": "Este e-mail pertence a um usuário de outra organização.",
    "MEMBER_LIMIT_REACHED": "Limite de usuários do plano atingido.",
    "MEMBER_DISABLED": "Seu acesso a esta organização está desativado.",
    "MEMBER_ALREADY_DISABLED": "Este usuário já está desativado.",
    "MEMBER_ALREADY_ENABLED": "Este usuário já está ativo.",
    "PERMISSION_DENIED": "Você não tem permissão para esta ação.",
    "IMPERSONATION_READ_ONLY": "Esta sessão de impersonação é somente leitura. As alterações estão bloqueadas.",
    "PERMISSION_TEMPLATE_IN_USE": "Este perfil está em uso por usuários.",
    "PERMISSION_TEMPLATE_LOCKED": "Este perfil do sistema não pode ser alterado.",
    "PERMISSION_TEMPLATE_NAME_TAKEN": "Já existe um perfil com este nome.",
    "LAST_ORG_ADMIN_REQUIRED": "A organização precisa ter pelo menos um Org Admin.",
    "PROJECT_DIARY_ENTRY_DATE_TAKEN": "Já existe um registro para esta data.",
    "PROJECT_DIARY_ENTRY_SERVICE_FRONT_DUPLICATE": "Esta frente de serviço já está no registro.",
    "PROJECT_DIARY_ENTRY_SERVICE_FRONT_LIMIT": "Um registro do diário pode ter apenas uma frente de serviço.",
    "PROJECT_DIARY_ENTRY_OCCURRENCE_DUPLICATE": "Esta ocorrência já está no registro.",
    "PROJECT_DIARY_ENTRY_PAST_READONLY": "Registros de dias anteriores não podem ser editados ou excluídos.",
    "DIARY_ENTRY_FORM_SECTION_DISABLED": "Esta seção não está habilitada no formulário do diário da organização.",
    "INVALID_PHOTO_TYPE": "Use imagens JPEG, PNG ou WebP.",
    "PHOTO_TOO_LARGE": "Cada foto deve ter no máximo 10 MB.",
    "DIARY_LINE_PHOTO_LIMIT_REACHED": "Não foi possível adicionar mais fotos nesta linha.",
    "GALLERY_PHOTO_LIMIT_REACHED": "Limite de fotos do álbum atingido ({{current}}/{{limit}}).",
    "PHOTO_UPLOAD_FAILED": "Armazenamento de fotos indisponível. Verifique a configuração do Supabase Storage na API.",
    "EQUIPMENT_CATEGORY_NAME_TAKEN": "Já existe uma categoria com este nome.",
    "EQUIPMENT_NAME_TAKEN": "Já existe um equipamento com este nome.",
    "EQUIPMENT_CODE_TAKEN": "Já existe um equipamento com este código.",
    "EQUIPMENT_INSUFFICIENT_QUANTITY": "Não é possível remover mais do que a quantidade atual.",
    "INVALID_EQUIPMENT_CATEGORY_ID": "A categoria selecionada não é válida.",
    "CHECKLIST_MODEL_NAME_TAKEN": "Já existe um modelo de checklist com este nome.",
    "CHECKLIST_MODEL_IN_USE": "Este modelo de checklist está em uso e não pode ser excluído.",
    "CHECKLIST_ITEM_NAMES_NOT_UNIQUE": "Os nomes dos itens devem ser únicos dentro do modelo.",
    "INVALID_CHECKLIST_MODEL_IDS": "Um ou mais modelos de checklist são inválidos.",
    "INVALID_PROJECT_CHECKLIST_ID": "Checklist inválido para esta frente de serviço.",
    "PROJECT_DIARY_ENTRY_CHECKLIST_DUPLICATE": "Este checklist já foi adicionado a esta frente no diário.",
    "PROJECT_CHECKLIST_IN_USE": "Este checklist está em uso e não pode ser removido.",
    "INVALID_BUDGET_ITEM_IDS": "A linha de planejamento selecionada não é válida.",
    "BUDGET_ITEM_IN_USE": "Esta linha de planejamento está em uso em contas a pagar e não pode ser excluída.",
    "PROJECT_BUDGET_IN_USE": "Este planejamento tem contas a pagar vinculadas e não pode ser excluído.",
    "PROJECT_BUDGET_NOT_EDITABLE": "Este planejamento não pode ser editado neste status.",
    "PROJECT_BUDGET_FRONT_HAS_EDITABLE": "Esta frente já tem um planejamento em elaboração ou em análise. Edite esse planejamento.",
    "CLIENT_BUDGET_STATUS_NOT_FOUND": "O status de orçamento do cliente selecionado não é válido.",
    "CLIENT_BUDGET_STATUS_NAME_TAKEN": "Já existe um status de orçamento do cliente com este nome.",
    "CLIENT_BUDGET_NOT_FOUND": "Orçamento do cliente não encontrado.",
    "CLIENT_BUDGET_VERSION_TAKEN": "Já existe um orçamento do cliente com esta versão.",
    "CLIENT_BUDGET_NOT_EDITABLE": "Este orçamento do cliente não pode ser editado neste status.",
    "CLIENT_BUDGET_IN_USE": "Este orçamento do cliente tem contas a receber vinculadas e não pode ser excluído.",
    "CLIENT_BUDGET_DISCOUNT_EXCEEDS_TOTAL": "O desconto não pode ser maior que o total dos itens.",
    "INVALID_CLIENT_BUDGET_SERVICE_FRONT_IDS": "Uma ou mais frentes de serviço do orçamento não são válidas.",
    "INVALID_CLIENT_BUDGET_MODEL_STEP_IDS": "Uma ou mais etapas do modelo não são válidas para este orçamento.",
    "CLIENT_BUDGET_ALREADY_HAS_PROJECT": "Este orçamento já está vinculado a uma obra.",
    "CLIENT_BUDGET_NOT_APPROVED": "Só orçamentos aprovados podem gerar uma obra.",
    "CLIENT_BUDGET_PROPOSED_NAME_REQUIRED": "Informe o nome da obra para criar a partir deste orçamento.",
    "PARTNER_NAME_TAKEN": "Já existe um parceiro com este nome.",
    "PARTNER_DOCUMENT_TAKEN": "Já existe um parceiro com este documento.",
    "PARTNER_IN_USE": "Este parceiro está em uso e não pode ser excluído.",
    "INVALID_PARTNER_ID": "O parceiro selecionado não é válido.",
    "FINANCIAL_CATEGORY_NAME_TAKEN": "Já existe uma categoria financeira com este nome.",
    "FINANCIAL_CATEGORY_IN_USE": "Esta categoria financeira está em uso e não pode ser excluída.",
    "INVALID_FINANCIAL_CATEGORY_ID": "A categoria financeira selecionada não é válida.",
    "PAYMENT_METHOD_NAME_TAKEN": "Já existe uma forma de pagamento com este nome.",
    "PAYMENT_METHOD_IN_USE": "Esta forma de pagamento está em uso e não pode ser excluída.",
    "SERVICE_TAX_CODE_IN_USE": "Este código de serviço está em uso em uma NFS-e e não pode ser excluído.",
    "FISCAL_NOT_READY": "Complete o cadastro fiscal antes de emitir a NFS-e.",
    "FISCAL_DOCUMENT_ALREADY_EMITTED": "Já existe uma NFS-e autorizada ou em envio para esta conta.",
    "FISCAL_DOCUMENT_NOT_CANCELLABLE": "Esta NFS-e não pode ser cancelada.",
    "FISCAL_XML_INVALID": "O XML não pôde ser lido. Use um arquivo de NF-e ou NFS-e.",
    "FISCAL_CERTIFICATE_INVALID": "O arquivo do certificado A1 é inválido.",
    "FISCAL_CERTIFICATE_PASSWORD": "A senha do certificado A1 está incorreta.",
    "FISCAL_CERTIFICATE_CNPJ_MISMATCH": "O CNPJ do certificado não é o da empresa.",
    "FISCAL_CERTIFICATE_EXPIRED": "O certificado A1 está vencido.",
    "FISCAL_CERTIFICATE_NOT_ICP_BRASIL": "Use um certificado e-CNPJ A1 ICP-Brasil da empresa.",
    "FISCAL_CERTIFICATE_MISSING": "Envie o certificado A1 em Configurações → Fiscal.",
    "FISCAL_ORG_CNPJ_REQUIRED": "Informe o CNPJ da empresa antes de enviar o certificado.",
    "FISCAL_CERTIFICATE_VAULT_UNAVAILABLE": "Não foi possível guardar o certificado. Tente de novo.",
    "FISCAL_SEFIN_UNAVAILABLE": "A SEFIN Nacional não respondeu. Tente de novo em instantes.",
    "FISCAL_DISABLED": "Esta empresa não emite notas fiscais.",
    "CHARGES_DISABLED": "Esta empresa não gera boleto e PIX.",
    "ASAAS_NOT_CONFIGURED": "Cobranças ainda não estão disponíveis neste ambiente.",
    "ASAAS_NOT_AVAILABLE_FOR_COUNTRY": "Cobranças PIX e boleto estão disponíveis só para empresas no Brasil.",
    "ASAAS_ORG_PROFILE_INCOMPLETE": "Complete CNPJ, e-mail comercial, telefone e endereço da empresa antes de ativar cobranças.",
    "ASAAS_ACCOUNT_NOT_READY": "Ative as cobranças e conclua o cadastro antes de gerar PIX ou boleto.",
    "ASAAS_CHARGE_NOT_ALLOWED": "Só é possível gerar cobrança para uma conta a receber em aberto.",
    "ASAAS_PARTNER_DOCUMENT_INVALID": "Informe um CPF ou CNPJ válido no cadastro do cliente.",
    "ASAAS_PARTNER_INCOMPLETE": "Informe o e-mail do cliente antes de gerar a cobrança.",
    "ASAAS_CHARGE_ALREADY_EXISTS": "Já existe uma cobrança para esta conta a receber.",
    "ASAAS_CHARGE_NOT_CANCELLABLE": "Esta cobrança não pode ser cancelada.",
    "ASAAS_REQUEST_FAILED": "O Asaas não concluiu o pedido. Tente de novo em instantes.",
    "PAGARME_NOT_CONFIGURED": "Cobranças ainda não estão disponíveis neste ambiente.",
    "PAGARME_NOT_AVAILABLE_FOR_COUNTRY": "Cobranças PIX e boleto estão disponíveis só para empresas no Brasil.",
    "PAGARME_ORG_PROFILE_INCOMPLETE": "Complete CNPJ, e-mail comercial, telefone e endereço da empresa antes de cadastrar a conta.",
    "PAGARME_ACCOUNT_NOT_READY": "Cadastre a conta bancária antes de gerar PIX ou boleto.",
    "PAGARME_REGISTRATION_NOT_ALLOWED": "O cadastro de conta bancária não está disponível para esta empresa.",
    "PAGARME_CHARGE_NOT_ALLOWED": "Só é possível gerar cobrança para uma conta a receber em aberto.",
    "PAGARME_REPRESENTATIVE_DOCUMENT_INVALID": "Informe um CPF válido para o representante legal.",
    "PAGARME_PARTNER_DOCUMENT_INVALID": "Informe um CPF ou CNPJ válido no cadastro do cliente.",
    "PAGARME_PARTNER_INCOMPLETE": "Informe o e-mail e o telefone do cliente antes de gerar a cobrança.",
    "PAGARME_CHARGE_ALREADY_EXISTS": "Já existe uma cobrança para esta conta a receber.",
    "PAGARME_CHARGE_NOT_CANCELLABLE": "Esta cobrança não pode ser cancelada.",
    "PAGARME_REQUEST_FAILED": "Não foi possível concluir o pedido. Tente de novo em instantes.",
    "BILLING_NOT_CONFIGURED": "A cobrança online ainda não está configurada. Fale com o suporte.",
    "BILLING_SUBSCRIBE_NOT_ALLOWED": "Esta organização não pode iniciar uma assinatura pelo app.",
    "BILLING_ALREADY_SUBSCRIBED": "Já existe uma assinatura vinculada ao provedor de pagamento.",
    "BILLING_METHOD_NOT_SUPPORTED": "Essa forma de pagamento não está disponível para o seu país.",
    "BILLING_PROVIDER_UNAVAILABLE": "Este provedor de cobrança ainda não está disponível.",
    "BILLING_CARD_REQUIRED": "Informe os dados do cartão de crédito para assinar com cartão.",
    "BILLING_RETRY_NOT_ALLOWED": "Não há cobrança de cartão em aberto para tentar novamente nesta organização.",
    "INVALID_PAYMENT_METHOD_ID": "A forma de pagamento selecionada não é válida.",
    "INVALID_PAYABLE_STATUS": "O status da conta a pagar não é válido.",
    "INVALID_RECEIVABLE_STATUS": "O status da conta a receber não é válido.",
    "PROJECT_PAYABLE_NOT_FOUND": "Conta a pagar não encontrada.",
    "PROJECT_RECEIVABLE_NOT_FOUND": "Conta a receber não encontrada.",
    "PURCHASE_REQUEST_INVALID_STATUS": "Esta solicitação de compra não pode ser alterada neste status.",
    "PURCHASE_REQUEST_HAS_ACTIVE_QUOTATION": "Esta solicitação já tem uma cotação ativa.",
    "PURCHASE_REQUEST_ITEM_LIMIT": "A solicitação ultrapassa o limite de itens.",
    "QUOTATION_INVALID_STATUS": "Esta cotação não pode ser alterada neste status.",
    "QUOTATION_SUPPLIER_LIMIT": "A cotação ultrapassa o limite de fornecedores.",
    "QUOTATION_SUPPLIER_ALREADY_ADDED": "Este fornecedor já está na cotação.",
    "QUOTATION_ALREADY_HAS_PURCHASE_ORDER": "Esta cotação já gerou um pedido de compra.",
    "PURCHASE_ORDER_ALREADY_RECEIVED": "O estoque deste pedido já foi atualizado.",
    "PURCHASE_ORDER_STOCK_MATERIAL_REQUIRED": "Informe o material do catálogo para cada item sem vínculo.",
    "PURCHASE_ORDER_NOT_RECEIVABLE": "Este pedido não pode receber estoque neste status.",
    "PURCHASE_ORDER_INVALID_STATUS": "Este pedido não pode ser cancelado neste status.",
    "PURCHASE_ORDER_HAS_PAYABLES": "Cancele ou remova as contas a pagar vinculadas antes de cancelar este pedido."
  },
  "globalSearch": {
    "dialogTitle": "Buscar",
    "dialogDesc": "Encontre páginas ou navegue.",
    "openAria": "Abrir busca",
    "ariaLabel": "Paleta de busca",
    "triggerPlaceholder": "Buscar ou navegar…",
    "palettePlaceholder": "Digite para filtrar a navegação…",
    "shortcutMac": "⌘K",
    "shortcutWin": "Ctrl+K",
    "empty": "Sem resultados.",
    "sectionGoTo": "Ir para",
    "sectionSettings": "Configurações"
  },
  "equipmentCategories": {
    "new": "Nova categoria",
    "edit": "Editar",
    "delete": "Excluir",
    "save": "Salvar",
    "cancel": "Cancelar",
    "colName": "Nome",
    "colDescription": "Descrição",
    "colStatus": "Status",
    "statusActive": "Ativa",
    "statusInactive": "Inativa",
    "nameLabel": "Nome",
    "descriptionLabel": "Descrição",
    "formCreateTitle": "Nova categoria",
    "formEditTitle": "Editar categoria",
    "formReviewTitle": "Revisar e enviar",
    "stepDetails": "Dados da categoria",
    "stepReview": "Revisar e enviar",
    "reviewSummaryTitle": "Resumo",
    "reviewPreviousLine": "Anterior: {{value}}",
    "drawerDetailTitle": "Detalhe da categoria",
    "drawerNoDescription": "Sem descrição",
    "loadError": "Não foi possível carregar as categorias.",
    "saveSuccess": "Categoria salva.",
    "deleteSuccess": "Categoria removida.",
    "deleteConfirmTitle": "Remover esta categoria?",
    "deleteConfirmDescription": "Esta ação não pode ser desfeita.",
    "deleteConfirmAction": "Remover",
    "actionsMenu": "Ações",
    "emptyTitle": "Nenhuma categoria",
    "emptyCatalog": "Nenhuma categoria cadastrada.",
    "emptyDescription": "Ainda não há categorias de equipamentos configuradas para esta organização.",
    "searchPlaceholder": "Buscar por nome…",
    "clearSearch": "Limpar busca",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "noSearchResults": "Nenhuma categoria corresponde à busca.",
    "noFilterResults": "Nenhuma categoria corresponde aos filtros selecionados.",
    "loadMoreError": "Não foi possível carregar mais categorias.",
    "loadMoreRetry": "Tentar novamente",
    "notFound": "Esta categoria não existe mais ou você não tem acesso.",
    "createdAt": "Criado em"
  },
  "equipments": {
    "new": "Novo equipamento",
    "edit": "Editar",
    "delete": "Excluir",
    "save": "Salvar",
    "cancel": "Cancelar",
    "colCode": "Código",
    "colName": "Nome",
    "colCategory": "Categoria",
    "colControlType": "Controle",
    "colOperationalStatus": "Status do equipamento",
    "colCurrentQuantity": "Quantidade",
    "colManufacturer": "Fabricante",
    "colStatus": "Status",
    "statusActive": "Ativo",
    "statusInactive": "Inativo",
    "allocatedProjectLabel": "Alocado em",
    "allocatedProjectsLabel": "Alocado em",
    "onProject": "Na obra {{project}}",
    "onProjects": "Nas obras {{projects}}",
    "nameLabel": "Nome",
    "codeLabel": "Código",
    "codeHint": "Gerado automaticamente. Você pode alterar se quiser.",
    "descriptionLabel": "Descrição",
    "manufacturerLabel": "Fabricante",
    "modelLabel": "Modelo",
    "categoryLabel": "Categoria",
    "categoryPlaceholder": "Selecione uma categoria",
    "noneOption": "Nenhuma",
    "controlTypeLabel": "Tipo de controle",
    "controlTypePlaceholder": "Selecione o tipo de controle",
    "acquisitionTypeLabel": "Aquisição",
    "acquisitionTypePlaceholder": "Selecione o tipo de aquisição",
    "rentalCompanyLabel": "Empresa de locação",
    "rentalStartDateLabel": "Início da locação",
    "rentalExpectedReturnDateLabel": "Devolução prevista",
    "serialNumberLabel": "Número de série",
    "assetTagLabel": "Patrimônio",
    "currentQuantityLabel": "Quantidade atual",
    "statusPlaceholder": "Selecione o status",
    "controlType": {
      "individual": "Individual",
      "quantity": "Quantidade"
    },
    "acquisitionType": {
      "owned": "Próprio",
      "rented": "Alugado"
    },
    "status": {
      "available": "Disponível",
      "allocated": "Alocado",
      "maintenance": "Manutenção",
      "inactive": "Inativo"
    },
    "formSections": {
      "identification": "Identificação",
      "control": "Controle",
      "acquisition": "Aquisição"
    },
    "formCreateTitle": "Novo equipamento",
    "formEditTitle": "Editar equipamento",
    "formReviewTitle": "Revisar e enviar",
    "stepDetails": "Dados do equipamento",
    "stepReview": "Revisar e enviar",
    "reviewSummaryTitle": "Resumo",
    "drawerDetailTitle": "Detalhe do equipamento",
    "drawerNoDescription": "Sem descrição",
    "drawerNoCategory": "Sem categoria",
    "drawerNoValue": "—",
    "loadError": "Não foi possível carregar os equipamentos.",
    "saveSuccess": "Equipamento salvo.",
    "deleteSuccess": "Equipamento removido.",
    "deleteConfirmTitle": "Remover este equipamento?",
    "deleteConfirmDescription": "Esta ação não pode ser desfeita.",
    "deleteConfirmAction": "Remover",
    "actionsMenu": "Ações",
    "actionsStockSection": "Estoque",
    "viewMovements": "Ver movimentações",
    "changeStatus": "Alterar status",
    "statusChangeTitle": "Alterar status",
    "statusChangeLabel": "Novo status",
    "statusChangeConfirm": "Atualizar status",
    "statusChangeSuccess": "Status atualizado.",
    "emptyTitle": "Nenhum equipamento",
    "emptyDescription": "Ainda não há equipamentos configurados para esta organização.",
    "searchPlaceholder": "Buscar por nome, código…",
    "clearSearch": "Limpar busca",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "noSearchResults": "Nenhum equipamento corresponde à busca.",
    "noFilterResults": "Nenhum equipamento corresponde aos filtros selecionados.",
    "loadMoreError": "Não foi possível carregar mais equipamentos.",
    "loadMoreRetry": "Tentar novamente",
    "codeNotFound": "Nenhum equipamento com este código.",
    "notFound": "Este equipamento não existe mais ou você não tem acesso.",
    "createdAt": "Criado em",
    "filterCategory": "Categoria",
    "filterCategorySearch": "Buscar categorias…",
    "filterCategoryEmpty": "Nenhuma categoria encontrada.",
    "filterManufacturer": "Fabricante",
    "filterManufacturerSearch": "Buscar fabricantes…",
    "filterManufacturerEmpty": "Nenhum fabricante encontrado.",
    "filterControlType": "Controle",
    "filterControlTypeSearch": "Buscar tipos de controle…",
    "filterControlTypeEmpty": "Nenhum tipo encontrado.",
    "filterStatus": "Status do equipamento",
    "filterStatusSearch": "Buscar status…",
    "filterStatusEmpty": "Nenhum status encontrado.",
    "filterAcquisitionType": "Aquisição",
    "filterAcquisitionTypeSearch": "Buscar tipos de aquisição…",
    "filterAcquisitionTypeEmpty": "Nenhum tipo encontrado.",
    "stockAdd": "Adicionar",
    "stockRemove": "Remover",
    "stockAdjustAddTitle": "Adicionar quantidade",
    "stockAdjustRemoveTitle": "Remover quantidade",
    "stockAdjustQuantityLabel": "Quantidade",
    "stockAdjustConfirmAdd": "Adicionar quantidade",
    "stockAdjustConfirmRemove": "Remover quantidade",
    "stockAdjustSuccess": "Quantidade atualizada.",
    "stockInsufficient": "Não é possível remover mais do que a quantidade atual.",
    "tabs": {
      "list": "Lista",
      "movements": "Movimentações"
    }
  },
  "equipmentStockMovements": {
    "pageTitle": "Movimentações",
    "colDate": "Data",
    "colEquipment": "Equipamento",
    "colCategory": "Categoria",
    "colQuantity": "Quantidade",
    "colSource": "Tipo",
    "colProject": "Obra",
    "colOrigin": "Descrição",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "loadError": "Não foi possível carregar as movimentações.",
    "loadMoreError": "Não foi possível carregar mais movimentações.",
    "loadMoreRetry": "Tentar novamente",
    "emptyTitle": "Nenhuma movimentação",
    "emptyDescription": "As alterações de equipamentos aparecerão aqui.",
    "emptyFilteredTitle": "Nenhuma movimentação corresponde aos filtros",
    "emptyFilteredDescription": "Tente ajustar o período ou os filtros.",
    "drawerTitle": "Movimentações",
    "formSections": {
      "identification": "Identificação"
    },
    "recentSection": "Movimentações recentes",
    "searchPlaceholder": "Buscar por nome ou código",
    "clearSearch": "Limpar busca",
    "dateFromLabel": "De",
    "dateToLabel": "Até",
    "timeFromLabel": "Horário inicial",
    "timeToLabel": "Horário final",
    "filter": {
      "date": "Data",
      "equipment": "Equipamento",
      "equipmentSearch": "Buscar equipamentos",
      "equipmentEmpty": "Nenhum equipamento encontrado",
      "category": "Categoria",
      "categorySearch": "Buscar categorias",
      "categoryEmpty": "Nenhuma categoria encontrada",
      "type": "Tipo",
      "typeSearch": "Buscar tipos",
      "typeEmpty": "Nenhum tipo encontrado"
    },
    "source": {
      "opening_balance": "Saldo inicial",
      "purchase": "Compra",
      "rental_start": "Início de locação",
      "rental_end": "Fim de locação",
      "allocated": "Alocado",
      "returned": "Devolvido",
      "transferred": "Transferido",
      "maintenance_start": "Início de manutenção",
      "maintenance_end": "Fim de manutenção",
      "disposed": "Baixa",
      "adjustment": "Ajuste",
      "manual": "Manual",
      "usage": "Uso"
    }
  },
  "projectEquipments": {
    "dateFromLabel": "Data inicial",
    "dateToLabel": "Data final",
    "timeFromLabel": "Hora inicial",
    "timeToLabel": "Hora final",
    "clearFilters": "Limpar filtros",
    "searchPlaceholder": "Buscar por nome ou código…",
    "clearSearch": "Limpar busca",
    "formSections": {
      "identification": "Identificação"
    },
    "filter": {
      "date": "Data",
      "equipment": "Equipamento",
      "equipmentSearch": "Buscar equipamentos…",
      "equipmentEmpty": "Nenhum equipamento encontrado.",
      "creators": "Registrado por",
      "creatorsSearch": "Buscar pessoas…",
      "creatorsEmpty": "Nenhuma pessoa encontrada.",
      "apply": "Mostrar resultados",
      "reset": "Limpar",
      "close": "Fechar filtro"
    },
    "colDate": "Data",
    "colCode": "Código",
    "colEquipment": "Equipamento",
    "colQuantity": "Quantidade",
    "colCreatedBy": "Registrado por",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "loadError": "Não foi possível carregar os equipamentos.",
    "emptyTitle": "Nenhum equipamento registrado",
    "emptyDescription": "Equipamentos usados nos diários aparecerão aqui.",
    "noFilterResults": "Nenhum equipamento corresponde aos filtros selecionados.",
    "drawerTitle": "Detalhe do equipamento",
    "unknownCreator": "Usuário desconhecido",
    "openProjectDiaryEntry": "Abrir diário",
    "loadMoreError": "Não foi possível carregar mais equipamentos.",
    "loadMoreRetry": "Tentar novamente",
    "tabs": {
      "usage": "Histórico de uso",
      "catalog": "Catálogo da obra",
      "movements": "Movimentações"
    }
  },
  "projectEquipmentMovements": {
    "colDate": "Data",
    "colCode": "Código",
    "colEquipment": "Equipamento",
    "colQuantity": "Quantidade",
    "colSource": "Tipo",
    "colFromProject": "Origem",
    "colToProject": "Destino",
    "colOrigin": "Descrição",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "loadError": "Não foi possível carregar as movimentações.",
    "emptyTitle": "Nenhuma movimentação",
    "emptyDescription": "Transferências e usos do diário aparecerão aqui.",
    "emptyFilteredTitle": "Nenhuma movimentação corresponde aos filtros",
    "emptyFilteredDescription": "Tente ajustar o período ou os filtros.",
    "loadMoreError": "Não foi possível carregar mais movimentações.",
    "loadMoreRetry": "Tentar novamente",
    "drawerTitle": "Movimentações do equipamento",
    "movementDetailTitle": "Detalhe da movimentação",
    "formSections": {
      "identification": "Identificação"
    },
    "recentSection": "Movimentações recentes",
    "searchPlaceholder": "Buscar por nome ou código",
    "clearSearch": "Limpar busca",
    "dateFromLabel": "De",
    "dateToLabel": "Até",
    "timeFromLabel": "Hora inicial",
    "timeToLabel": "Hora final",
    "filter": {
      "date": "Data",
      "equipment": "Equipamento",
      "equipmentSearch": "Buscar equipamentos",
      "equipmentEmpty": "Nenhum equipamento encontrado",
      "type": "Tipo",
      "typeSearch": "Buscar tipos",
      "typeEmpty": "Nenhum tipo encontrado"
    },
    "source": {
      "transfer_in": "Entrada por transferência",
      "transfer_out": "Saída por transferência",
      "usage": "Uso",
      "usage_delta": "Ajuste de quantidade",
      "reversal": "Estorno",
      "returned": "Devolvido"
    }
  },
  "projectEquipmentSelection": {
    "colCode": "Código",
    "colName": "Nome",
    "colCategory": "Categoria",
    "colControlType": "Controle",
    "colStatus": "Status",
    "colQuantity": "Quantidade atual",
    "colOrgStock": "Estoque org.",
    "total_one": "{{count}} resultado",
    "total_other": "{{count}} resultados",
    "loadError": "Não foi possível carregar os equipamentos da obra.",
    "saveError": "Não foi possível salvar os equipamentos da obra.",
    "deleteError": "Não foi possível remover o equipamento da obra.",
    "emptyTitle": "Nenhum equipamento selecionado",
    "emptyDescription": "Adicione equipamentos do catálogo da organização e aloque-os a esta obra.",
    "searchPlaceholder": "Buscar por nome ou código…",
    "clearSearch": "Limpar busca",
    "clearFilters": "Limpar filtros",
    "noSearchResults": "Nenhum equipamento corresponde à busca.",
    "noFilterResults": "Nenhum equipamento corresponde aos filtros selecionados.",
    "statusActive": "Ativo",
    "statusInactive": "Inativo",
    "filterCategory": "Categoria",
    "filterCategorySearch": "Buscar categorias…",
    "filterCategoryEmpty": "Nenhuma categoria encontrada.",
    "filterControlType": "Controle",
    "filterControlTypeSearch": "Buscar tipos de controle…",
    "filterControlTypeEmpty": "Nenhum tipo encontrado.",
    "addEquipmentsAction": "Adicionar equipamentos",
    "addLabel": "Equipamento",
    "addPlaceholder": "Buscar equipamentos do catálogo…",
    "addLineTitle": "Adicionar linha de equipamento",
    "addLineAction": "Adicionar linha",
    "addItemSave": "Adicionar",
    "edit": "Editar",
    "editItem": "Editar linha",
    "addBatchSuccess": "Equipamentos adicionados à obra.",
    "alreadySelected": "Este equipamento já está na obra.",
    "codeNotFound": "Este código não está no estoque da obra.",
    "alreadyAllocated": "Já alocado em outra obra.",
    "allocatedToProject": "Alocado em {{project}}",
    "allocatedToProjects": "Alocado em {{projects}}",
    "equipmentRequired": "Selecione um equipamento.",
    "quantityLabel": "Quantidade",
    "quantityRequired": "Informe uma quantidade.",
    "quantityExceedsStock": "A quantidade não pode exceder o estoque da organização.",
    "quantityMaxHint": "Máximo disponível: {{max}}",
    "quantityNoStock": "Não há estoque disponível para este equipamento.",
    "orgStockHint": "Estoque da organização: {{stock}}",
    "orgStockLabel": "Estoque org.",
    "orgStockInsufficient": "Estoque da organização insuficiente para esta quantidade.",
    "projectQuantityInsufficient": "Quantidade insuficiente na obra.",
    "individualQuantityHint": "Equipamento individual é alocado como uma unidade.",
    "individualAvailableOnly": "Somente equipamentos individuais disponíveis podem ser alocados.",
    "remove": "Excluir",
    "actionsMenu": "Ações",
    "actionsQuantitySection": "Estoque",
    "viewMovements": "Ver movimentações",
    "quantityAdd": "Adicionar",
    "quantityRemove": "Remover",
    "quantityAdjustAddTitle": "Adicionar quantidade à obra",
    "quantityAdjustRemoveTitle": "Remover quantidade da obra",
    "quantityAdjustLabel": "Quantidade",
    "quantityAdjustConfirmAdd": "Adicionar",
    "quantityAdjustConfirmRemove": "Remover",
    "quantityAdjustSuccess": "Quantidade da obra atualizada.",
    "transfer": "Transferir",
    "transferTitle": "Transferir equipamento",
    "transferTargetLabel": "Obra de destino",
    "transferTargetPlaceholder": "Selecione uma obra…",
    "transferNotesLabel": "Observações",
    "transferConfirm": "Transferir",
    "transferSuccess": "Equipamento transferido.",
    "transferAlreadySelected": "Este equipamento já está na obra de destino.",
    "deleteSuccess": "Equipamento removido da obra.",
    "deleteConfirmTitle": "Remover equipamento da obra?",
    "deleteConfirmDescription": "A quantidade restante voltará ao estoque da organização. Registros do diário são mantidos.",
    "deleteConfirmAction": "Remover",
    "cancel": "Cancelar",
    "diaryEmptyHint": "Nenhum equipamento com quantidade disponível nesta obra. Adicione equipamentos na aba Catálogo da obra primeiro.",
    "formTitle": "Adicionar equipamentos à obra",
    "formStepDetails": "Equipamentos",
    "formStepReview": "Revisar e enviar",
    "formReviewTitle": "Revisar e enviar",
    "reviewSummaryTitle": "Resumo",
    "formSave": "Salvar",
    "formDraftSection": "Equipamentos a adicionar",
    "formDraftEmpty": "Adicione uma ou mais linhas de equipamento.",
    "formItemsRequired": "Adicione pelo menos uma linha de equipamento.",
    "draftQuantity": "Quantidade: {{quantity}}",
    "removeDraftLine": "Remover linha",
    "controlType": {
      "individual": "Individual",
      "quantity": "Quantidade"
    }
  },
  "diaryReports": {
    "title": "Relatórios",
    "formSections": {
      "identification": "Identificação"
    },
    "description": "Gere e acesse relatórios oficiais do projeto.",
    "settingsTitle": "Modelos de relatório do diário",
    "modelsTitle": "Modelo do relatório",
    "modelsTotal": "{{count}} modelos",
    "modelsLoadError": "Não foi possível carregar os modelos de relatório.",
    "modelsEmptyTitle": "Nenhum modelo de relatório",
    "modelsEmptyDescription": "Ainda não há modelos de relatório reutilizáveis.",
    "systemModelsTitle": "Modelos do sistema",
    "systemModelsHint": "Modelos controlados pela plataforma. Somente leitura — clone para personalizar.",
    "customModelsTitle": "Modelos personalizados",
    "customModelsHint": "Modelos criados pela sua organização a partir de um modelo do sistema.",
    "customModelsEmpty": "Nenhum modelo personalizado ainda.",
    "customModelsEmptyTitle": "Nenhum modelo personalizado",
    "customModelsEmptyDescription": "Ainda não há modelos personalizados configurados para esta organização.",
    "modelDrawerTitle": "Detalhes do modelo de relatório",
    "editModelTitle": "Editar modelo de relatório",
    "sectionsTitle": "Seções do relatório",
    "sectionsIncludedTitle": "Seções incluídas",
    "documentPreviewTitle": "Prévia do documento",
    "weatherAutoHint": "Automático via API de clima",
    "sectionOptions": {
      "groupByWorkFront": "Agrupar por frente de obra",
      "criticalOnly": "Somente ocorrências críticas",
      "hideIfEmpty": "Ocultar seção se não houver dados",
      "photoGrid3": "Exibir em grade de 3 colunas",
      "includeCaptions": "Incluir legenda por foto"
    },
    "sectionEnabled": "Incluída",
    "sectionDisabled": "Não incluída",
    "modelTypeLabel": "Tipo",
    "modelType": {
      "system": "Sistema",
      "custom": "Personalizado"
    },
    "clone": "Clonar modelo",
    "copyName": "Cópia de {{name}}",
    "modelCloned": "Modelo editável criado.",
    "modelSaved": "Modelo de relatório salvo.",
    "modelDeleted": "Modelo de relatório excluído.",
    "defaultUpdated": "Modelo padrão da obra atualizado.",
    "currentDefault": "Padrão da obra",
    "setDefault": "Definir como padrão",
    "systemModelHint": "O modelo padrão é somente leitura. Clone-o para alterar nomes, visibilidade ou ordem das seções.",
    "modelName": "Nome do modelo",
    "reorderSection": "Reordenar seção",
    "moveUp": "Mover seção para cima",
    "moveDown": "Mover seção para baixo",
    "includePhotos": "Incluir fotos do diário",
    "signatures": "Exibir campos de assinatura",
    "generateTitle": "Gerar relatório",
    "chooseReportTitle": "Escolher relatório",
    "backToChoose": "Voltar",
    "dateFromLabel": "De",
    "dateToLabel": "Até",
    "invalidDateRange": "A data inicial deve ser anterior ou igual à data final.",
    "periodTitle": "Período",
    "reportTypes": {
      "diary": {
        "name": "Diário de obra",
        "description": "PDF oficial dos diários publicados no período, com o modelo selecionado.",
        "paramsHint": "Informe o intervalo (data e hora). Cada diário publicado no período vira um dia no PDF (até 31)."
      },
      "equipment": {
        "name": "Equipamentos",
        "description": "Equipamentos usados e ociosos no período.",
        "paramsHint": "Informe o intervalo de datas do relatório."
      },
      "labor": {
        "name": "Mão de obra",
        "description": "Trabalhadores presentes nos diários do período.",
        "paramsHint": "Informe o intervalo de datas do relatório."
      },
      "occurrences": {
        "name": "Ocorrências",
        "description": "Ocorrências registradas nos diários do período.",
        "paramsHint": "Informe o intervalo de datas do relatório."
      },
      "progress": {
        "name": "Progresso",
        "description": "Evolução do progresso por frente no período.",
        "paramsHint": "Informe o intervalo de datas do relatório."
      },
      "materials": {
        "name": "Materiais",
        "description": "Materiais utilizados nos diários do período.",
        "paramsHint": "Informe o intervalo de datas do relatório."
      },
      "photos": {
        "name": "Registro fotográfico",
        "description": "Fotos dos diários e da galeria no período (até 80).",
        "paramsHint": "Informe o intervalo de datas do relatório."
      },
      "weather": {
        "name": "Clima e praticabilidade",
        "description": "Condições de tempo e praticabilidade nos diários publicados.",
        "paramsHint": "Informe o intervalo de datas do relatório."
      },
      "checklists": {
        "name": "Checklists",
        "description": "Itens de checklist preenchidos nos diários do período.",
        "paramsHint": "Informe o intervalo de datas do relatório."
      },
      "measurement": {
        "name": "Medição",
        "description": "Avanços de quantidade no período com acumulado e valor.",
        "paramsHint": "Informe o intervalo de datas da medição."
      },
      "costVsBudget": {
        "name": "Custo vs orçamento",
        "description": "Planejado, medido e pago nos orçamentos vigentes da obra.",
        "paramsHint": "Informe o intervalo de datas do relatório."
      },
      "clientProposal": {
        "name": "Proposta comercial",
        "description": "PDF de um orçamento de cliente selecionado.",
        "paramsHint": "Escolha o orçamento de cliente que será impresso."
      },
      "purchaseOrders": {
        "name": "Ordens de compra",
        "description": "Pedidos de compra emitidos no período.",
        "paramsHint": "Informe o intervalo de datas do relatório."
      },
      "payables": {
        "name": "Contas a pagar",
        "description": "Contas a pagar com vencimento no período.",
        "paramsHint": "Informe o intervalo de datas do relatório."
      },
      "receivables": {
        "name": "Contas a receber",
        "description": "Contas a receber com vencimento no período.",
        "paramsHint": "Informe o intervalo de datas do relatório."
      },
      "cashFlow": {
        "name": "Fluxo de caixa",
        "description": "Entradas e saídas previstas e realizadas no período.",
        "paramsHint": "Informe o intervalo de datas do relatório."
      }
    },
    "groups": {
      "execution": "Execução",
      "commercial": "Comercial",
      "purchasesFinance": "Compras e financeiro"
    },
    "formatLabel": "Formato",
    "clientBudgetLabel": "Orçamento de cliente",
    "selectClientBudget": "Selecione um orçamento de cliente",
    "diaryEntryLabel": "Diário de obra",
    "selectDiary": "Selecione um diário publicado",
    "searchDiary": "Buscar por data ou conteúdo do diário",
    "noPublishedDiaries": "Não há diários publicados disponíveis.",
    "modelLabel": "Modelo do relatório",
    "selectModel": "Selecione um modelo de relatório",
    "selectedDiary": "Diário selecionado",
    "preview": "Pré-visualizar",
    "generate": "Gerar",
    "generateError": "Não foi possível iniciar a geração do relatório. Tente de novo.",
    "publishedOnly": "O PDF oficial só pode ser gerado a partir de um diário publicado.",
    "selectDiaryHint": "Abra um diário publicado para gerar o relatório.",
    "openDiaries": "Ver diários",
    "openReports": "Relatórios",
    "generated": "PDF oficial gerado.",
    "generatingQueued": "Gerando relatório… Você será notificado quando estiver pronto.",
    "historyTitle": "Relatórios gerados",
    "emptyHistory": "Nenhum relatório gerado ainda.",
    "total": "{{count}} relatórios",
    "colType": "Tipo",
    "colModel": "Modelo",
    "colParams": "Parâmetros",
    "colCreatedAt": "Gerado em",
    "colStatus": "Status",
    "emptyTitle": "Nenhum relatório gerado",
    "emptyDescription": "Gere o primeiro relatório escolhendo o tipo e os parâmetros.",
    "loadError": "Não foi possível carregar os relatórios.",
    "drawerTitle": "Detalhes do relatório",
    "statusLabel": "Status",
    "modelVersionLabel": "Versão",
    "generatedAtLabel": "Gerado em",
    "fileSection": "Arquivo",
    "fileLabel": "Arquivo",
    "sourceDiaryTitle": "Diário de origem",
    "errorTitle": "Erro na geração",
    "errorMessageLabel": "Detalhes",
    "open": "Abrir relatório",
    "download": "Baixar relatório",
    "actionsMenu": "Ações do relatório",
    "delete": "Excluir relatório",
    "deleteSelected": "Excluir {{count}} relatórios",
    "deleteReportTitle": "Excluir este relatório gerado?",
    "deleteReportDescription": "O arquivo gerado será removido permanentemente. Os dados de origem não serão excluídos.",
    "deleteSelectedTitle": "Excluir {{count}} relatórios gerados?",
    "deleteSelectedDescription": "Os arquivos gerados serão removidos permanentemente. Os dados de origem não serão excluídos.",
    "deleteSuccess": "Relatório excluído",
    "deleteSelectedSuccess": "{{count}} relatórios excluídos",
    "deleteError": "Não foi possível excluir o relatório. Tente novamente.",
    "selectAll": "Selecionar todos os relatórios",
    "selectRow": "Selecionar relatório",
    "deleteTitle": "Excluir este modelo de relatório?",
    "deleteDescription": "Obras que usam este modelo voltarão ao modelo padrão. PDFs já gerados serão preservados.",
    "status": {
      "pending": "Pendente",
      "processing": "Processando",
      "done": "Pronto",
      "error": "Falhou"
    }
  }
}
